module.exports = {
	"de": {
		"moet-core": {
			"select_language": {
				"title": "Wählen Sie Ihre Sprache",
				"paragraph": "Dies ist Ihre Standardsprache.",
				"submit": "OK"
			},
			"products": {
				"mandatory": "Immer inklusive",
				"kco": {
					"name": {
						"default": "Checkout"
					},
					"description": {
						"default": "Bieten Sie alle unsere Zahlungsarten an."
					},
					"options": {
						"kco-pay-now": {
							"name": {
								"default": "Sofort bezahlen"
							},
							"description": {
								"default": "Direktzahlung per Karte oder Sofortüberweisung."
							}
						},
						"kco-pay-later": {
							"name": {
								"default": "In 30 Tagen bezahlen"
							},
							"description": {
								"default": "Rechnungskauf in 30 Tagen. Keine Zinsen.\n "
							}
						},
						"kco-slice-it": {
							"name": {
								"default": "Ratenkauf"
							},
							"description": {
								"default": "Ratenzahlung über 6–36 Monate.",
								"DE": "Ratenzahlung über 6–24 Monate",
								"AT": "Ratenzahlung über 6–24 Monate."
							}
						},
						"kco-slice-it-in-3": {
							"name": {
								"default": "Raten"
							},
							"description": {
								"default": "Drei zinsfreie Ratenzahlungen anbieten.",
								"GB": "Drei zinsfreie Ratenzahlungen anbieten."
							}
						},
						"kco-slice-it-in-4": {
							"name": {
								"default": "Slice it in 4",
								"US": "Ratenzahlung",
								"AU": "In 4 Raten zahlen"
							},
							"description": {
								"default": "Vier zinsfreie Ratenzahlungen anbieten.",
								"GB": "Vier zinsfreie Ratenzahlungen anbieten."
							}
						}
					}
				},
				"kp": {
					"name": {
						"default": "Zahlungsarten"
					},
					"description": {
						"default": "Wählen Sie aus unseren eigenständigen Zahlungslösungen. Diese können einzeln oder in Kombination verwendet werden - einfach und einmalig zu integrieren."
					},
					"options": {
						"kp-pay-now": {
							"name": {
								"default": "Sofort bezahlen"
							},
							"description": {
								"default": "Direktzahlung per Karte oder Sofortüberweisung."
							}
						},
						"kp-pay-later": {
							"name": {
								"default": "In 30 Tagen bezahlen"
							},
							"description": {
								"default": "Rechnungskauf in 30 Tagen. Keine Zinsen.\n "
							}
						},
						"kp-slice-it": {
							"name": {
								"default": "Ratenkauf"
							},
							"description": {
								"default": "Ratenzahlung über 6–36 Monate.",
								"DE": "Ratenzahlung über 6–24 Monate",
								"AT": "Ratenzahlung über 6–24 Monate."
							}
						},
						"kp-slice-it-in-3": {
							"name": {
								"default": "Raten"
							},
							"description": {
								"default": "Drei zinsfreie Ratenzahlungen anbieten.",
								"GB": "Drei zinsfreie Ratenzahlungen anbieten."
							}
						},
						"kp-slice-it-in-4": {
							"name": {
								"default": "Slice it in 4",
								"US": "4 Zahlungen",
								"CA": "4 Zahlungen",
								"AU": "In 4 Raten zahlen"
							},
							"description": {
								"default": "Vier zinsfreie Ratenzahlungen anbieten.",
								"GB": "Vier zinsfreie Ratenzahlungen anbieten.",
								"US": "Bestellungen von 35 $ bis 1000 $ können in 4 zinsfreie Zahlungen mit 14-tägiger Fälligkeit aufgeteilt werden.",
								"CA": "Bestellungen von 35 $ bis 1000 $ können in 4 zinsfreie Zahlungen mit 14-tägiger Fälligkeit aufgeteilt werden."
							}
						}
					}
				},
				"kco_one": {
					"name": {
						"default": "Checkout"
					},
					"description": {
						"default": "Ersetzen Sie die Bezahlseite Ihres Shops mit Klarnas komplettem Checkout-Service."
					},
					"description_expanded": {
						"default": "Ersetzen Sie die Bezahlseite Ihres Shops mit Klarnas komplettem Checkout-Service."
					}
				},
				"kp_one": {
					"name": {
						"default": "Zahlungsmethode"
					},
					"description": {
						"default": "Fügen Sie die Zahlungsmöglichkeiten von Klarna in Ihren bestehenden Checkout ein"
					},
					"description_expanded": {
						"default": "Die Möglichkeit, per Klarna zu zahlen, erhöht die Konversionsrate um durchschnittlich 30 %, den durchschnittlichen Bestellwert um 41 % und die Bestellhäufigkeit um 36 %."
					}
				}
			}
		},
		"products-fe": {
			"error_messages": {
				"validation": {
					"required": "Dieses Feld muss ausgefüllt werden, um fortzufahren",
					"generic": "Der angegebene Wert ist ungültig",
					"required_suffix": "ist nötig, um fortzufahren",
					"generic_suffix": "ist ungültig",
					"min_one": "Sie müssen mindestens ein Element auswählen",
					"min": "Sie müssen mindestens {min} Elemente auswählen",
					"max": "Sie können nicht mehr als {max} Elemente auswählen",
					"given_name": "Vorname fehlt",
					"family_name": {
						"general": "Nachname fehlt",
						"too_short": "Bitte geben Sie einen gültigen Nachnamen an"
					},
					"date_of_birth": {
						"general": {
							"default": "Bitte geben Sie ein gültiges Geburtsdatum an (TT.MM.JJJJ)",
							"US": "Bitte geben Sie ein gültiges Geburtsdatum an (MM/TT/JJJJ)"
						},
						"too_young": "Alle Stakeholder müssen älter als 16 Jahre sein",
						"too_young_eighteen": "Sie müssen älter als 18 Jahre sein"
					},
					"street_address": "Bitte geben Sie eine Adresse an.",
					"street_address2": "Bitte geben Sie eine gültige Adresszeile 2 an",
					"postal_code": "Bitte geben Sie eine Postleitzahl an",
					"country": "Bitte geben Sie ein Land an",
					"region": "Bitte geben Sie eine Region an",
					"state": "Bitte geben Sie einen Bundesstaat an",
					"iban": "Bitte geben Sie eine Kontonummer (IBAN) an.",
					"companyName": "Bitte geben Sie eine Firmenbezeichnung an",
					"email": "Bitte geben Sie eine gültige Email adresse an",
					"contact_email": "Bitte geben Sie eine gültige Kontakt-E-Mail-Adresse an",
					"support_email": "Bitte geben Sie eine gültige Kundenservice-E-Mail-Adresse an",
					"support_phone": "Bitte geben Sie eine gültige Kundenservice-Telefonnummer an",
					"selling_countries": "Sie müssen mindestens ein Land wählen",
					"store_category": "Sie müssen eine der Optionen auswählen",
					"name": "Bitte geben Sie einen Shop-Namen an",
					"legal_form": "Bitte wählen Sie eine der aufgelisteten Unternehmensarten aus",
					"generic_toggle_undefined": "Bitte wählen Sie eine der Optionen",
					"website": "Bitte geben Sie eine gültige Website-URL an",
					"bankAccounts": "Bitte geben Sie mindestens ein Bankkonto an.",
					"product": "Bitte wählen Sie ein Produkt.",
					"platform": "Bitte wählen Sie eine Plattform",
					"password": "Bitte erstellen Sie ein sicheres Passwort",
					"currency_code": "Bitte geben Sie einen Währungscode an.",
					"account_holder": "Bitte geben Sie einen Kontoinhaber an.",
					"account_type": "Bitte geben Sie eine Bankkontoart an.",
					"routing_number": "Bitte geben Sie eine gültige Bankleitzahl an",
					"account_number": {
						"first": "Bitte geben Sie eine gültige Kontonummer für das Standard-Bankkonto an",
						"second": "Bitte geben Sie eine gültige Kontonummer für das erste zusätzliche Bankkonto an",
						"third": "Bitte geben Sie eine gültige Kontonummer für das zweite zusätzliche Bankkonto an",
						"fourth": "Bitte geben Sie eine gültige Kontonummer für das dritte zusätzliche Bankkonto an",
						"general": "Bitte geben Sie eine gültige Kontonummer an"
					},
					"role": "Bitte geben Sie eine Funktion an.",
					"address": "Bitte geben Sie eine Adresse an.",
					"political_exposed_person": "Bitte geben Sie Informationen bezüglich der politisch exponierten Person an.",
					"pep_position": "Bitte geben Sie Informationen zur Position der politisch exponierten Person an.",
					"pep_relationship": "Bitte geben Sie an, in welcher Beziehung Sie zur politisch exponierten Person stehen.",
					"goodsCategory": "Bitte geben Sie eine Produktkategorie an.",
					"registered": "Bitte geben Sie Informationen zu Ihrem Handelsregistereintrag an. ",
					"subjectToVat": "Bitte geben Sie eine USt-IdNr. an.",
					"registrationCourt": "Bitte geben Sie ein Registrierungsgericht an.",
					"registrationId": {
						"general": {
							"default": "Geben Sie eine gültige Registernummer ein",
							"AT": "Geben Sie eine gültige Registernummer ein",
							"AU": "Geben Sie eine gültige ABN ein.",
							"ES": "Geben Sie eine gültige Unternehmens-NIF/NIE/DNI ein.",
							"GB": "Geben Sie eine gültige Organisationsnummer ein",
							"GR": "Geben Sie eine gültige G.E.MI. Nummer (Γ.Ε.ΜΗ.) ein.",
							"CA": "Geben Sie eine gültige Geschäftsnummer ein",
							"NZ": "Bitte geben Sie eine gültige Geschäftsnummer ein",
							"US": "Bitte geben Sie eine gültige Arbeitgeber-Identifikationsnummer ein"
						},
						"missing_leading_0_GB": "Bitte geben Sie eine achtstellige Organisationsnummer an. Möglicherweise lässt Ihre Organisationsnummer eine Null an erster Stelle aus (z. B. 03452578)",
						"invalid": {
							"default": "Bitte geben Sie eine gültige Registernummer an",
							"AT": "Die Registernummer soll zwischen 5 und 11 Zeichen lang sein. Bitte beachten Sie, dass es sich hierbei nicht um Ihre USt-IdNr. oder Ihre Shop-ID handelt.",
							"AU": "Die ABN umfasst 9 Ziffern, es sind keine Leerzeichen erlaubt. Z. B: 123456789",
							"BE": "Die Registernummer sollte 10 Ziffern lang sein. Bsp.: 1234567890",
							"CA": "Die Geschäftsnummer sollte 9 Ziffern lang sein. Bsp.: 123456789",
							"CZ": "Die Registernummer sollte 8 Ziffern lang sein. Bsp: 12345678",
							"DE": "Die Registernummer sollte zwischen 6 und 11 Zeichen lang sein und muss mit HRA, HRB, GnR, VR oder PR beginnen, gefolgt von einem Leerzeichen. Beachten Sie, dass dies weder Ihre USt-IdNr. noch Ihre Händler-ID ist.",
							"ES": "Die NIF/NIE/DNI sollte 8 oder 9 Zeichen lang sein und mit 1 Buchstaben/Ziffer beginnen, gefolgt von 6 oder 7 Ziffern und 1 Buchstaben/Ziffer",
							"FI": "Die Registernummer sollte 8 Ziffern lang sein, einen Bindestrich vor der letzten Ziffer und kein Leerzeichen haben. Bsp.: 1234567-8",
							"FR": "Die Registernummer sollte 9-stellig sein, z. B. 123 456 789 oder 123456789 (SIREN) oder 14-stellig, z. B. 123 456 789 12345 oder 12345678912345 (SIRET).",
							"IE": "Die Registernummer sollte 2 Buchstaben, gefolgt von 6 Ziffern oder nur 6 Ziffern enthalten, wenn Sie ein Einzelunternehmer sind (z. B. AB123456).",
							"IT": "Die Registernummer sollte 11 Ziffern lang sein (z. B. 01234567890) oder eine Kombination aus 16 Ziffern und Großbuchstaben (z. B. ABCABC12A12A123A)",
							"GB": "Die Organisationsnummer sollte 8 Ziffern lang sein, z. B. 12345678, oder aus 2 Buchstaben gefolgt von 6 Ziffern bestehen (SC123456) oder aus 1 Buchstaben gefolgt von 7 Ziffern (S1234567)",
							"GR": "Die G.E.MI.-Nummer sollte 12 Ziffern umfassen, z. B. 012345678901",
							"NL": "Die Registernummer sollte 8 Ziffern lang sein. Bsp.: 12345678",
							"NO": "Die Registernummer sollte 9 Ziffern lang sein und kein Leerzeichen beinhalten, z. B. 123456789",
							"NZ": "Die Geschäftsnummer sollte 13 Ziffern lang sein. Bsp.: 1234567890123",
							"PL": "Die Registernummer sollte 10 Ziffern lang sein und darf kein Leerzeichen beinhalten, z. B. 1234561234",
							"PT": "Die Registernummer sollte 9 Ziffern lang sein und kein Leerzeichen beinhalten. Z. B.: 123123123",
							"SE": "Die Registernummer sollte 10 Ziffern lang sein und einen Bindestrich beinhalten, jedoch kein Leerzeichen. Bsp.: 123456-1234",
							"US": "Die Arbeitgeber-Identifikationsnummer besteht üblicherweise aus 9 Ziffern. Die ersten zwei Ziffern sind durch einen Bindestrich von den restlichen getrennt, z. B.: 12-3456789 ",
							"MX": "Die RFC-Nummer sollte aus 12 Zeichen bestehen, beginnend mit den Initialen des Unternehmens, gefolgt vom 6-stelligen Gründungsdatum und dem Prüfwert, z. B.: ABC921010H20"
						}
					},
					"tocLink": "Bei den AGB ist ein Fehler aufgetreten. Versuchen Sie es später erneut oder wenden Sie sich an unseren Kundendienst unter {supportEmail}",
					"vat": {
						"general": {
							"default": "Geben Sie eine gültige USt.-IdNr. ein",
							"AU": "Geben Sie eine gültige ABN ein",
							"ES": "Bitte geben Sie eine gültige Unternehmens-NIF/NIE/DNI ein.",
							"NZ": "Bitte geben Sie eine gültige GST-Nummer ein"
						},
						"invalid": {
							"default": "Ungültige UST-IdNr.",
							"AT": "Die USt-IdNr. sollte mit ATU beginnen, gefolgt von 8 Ziffern, z.  B. ATU12345678",
							"AU": "Die ABN sollte 11 Ziffern lang sein.",
							"CZ": "Die USt-IdNr. sollte mit CZ beginnen, gefolgt von 8, 9 oder 10 Ziffern. Z. B.: CZ123456789",
							"GR": "Die USt-IdNr. sollte 9 Ziffern enthalten und mit EL beginnen. Z. B.: EL123456789",
							"DE": "Die USt-IdNr. sollte mit DE beginnen, gefolgt von 9 Ziffern, z.  B. DE123456789",
							"ES": "Die NIF/NIE/DNI sollte 8 oder 9 Zeichen lang sein und mit 1 Buchstaben/Ziffer beginnen, gefolgt von 6 oder 7 Ziffern und 1 Buchstaben/Ziffer",
							"FR": "Die USt-IdNr. beginnt üblicherweise mit FR, gefolgt von 2 Buchstaben/Ziffern und 9 Ziffern (SIREN), z. B. FRXX123456789",
							"GB": "Die USt-IdNr. sollte zwischen 6 und 15 Zeichen lang sein.",
							"IE": "Die USt-IdNr. sollte mit IE beginnen gefolgt von 8 oder 9 Zeichen, davon 1 oder 2 Buchstaben, z. B.: IE1234567WA, IE1234567A",
							"IT": "Die USt-IdNr. sollte mit IT beginnen, gefolgt von 11 Ziffern, z. B. IT12345678912",
							"NL": "Die USt-IdNr. sollte mit NL beginnen, gefolgt von 9 Ziffern, auf die ein B und 2 Ziffern folgen, z. B. NL123456789B12",
							"NZ": "Die GST-Nummer sollte 8 (12345678) oder 9 Ziffern lang sein, mit oder ohne durch Bindestriche getrennte Dreiergruppen (123-123-123 oder 123123123)",
							"PL": "Die USt-IdNr. sollte mit PL beginnen, gefolgt von 10 Ziffern, z. B. PL1234567890",
							"PT": "Die USt-IdNr. sollte mit PT beginnen, gefolgt von 9 Ziffern. Z. B.: PT123123123",
							"MX": "Die RFC-Nummer sollte mit den Initialen des Unternehmens beginnen, gefolgt vom 6-stelligen Gründungsdatum und dem Prüfwert, z. B.: ABC921010H20"
						}
					},
					"personal_id": {
						"US": {
							"general": "Bitte geben Sie die letzten vier Ziffern Ihrer SVN an",
							"format": "Bitte geben Sie die letzten vier Ziffern Ihrer SVN ein"
						},
						"US_FULL_SSN": {
							"general": "Bitte geben Sie die vollständige SVN (9 Ziffern) ein",
							"format": "Bitte geben Sie ihre vollständige SVN (9 Ziffern) ein"
						},
						"CA": {
							"general": "Bitte geben Sie eine gültige SVN- oder Passnummer ein.",
							"format": "SVN: XXX-XXX-XXX / Passnummer: ABXXXXXX"
						},
						"SE": {
							"general": "Bitte geben Sie eine gültige persönliche Identifikationsnummer (PNO) ein",
							"format": "PNO-Format: JJJJMMTT-XXXX"
						},
						"FI": {
							"general": "Bitte geben Sie einen gültigen persönlichen Identifikationscode (HETU) ein",
							"format": "HETU-Format: TTMMJJSXXXX"
						},
						"NO": {
							"general": "Bitte geben Sie eine gültige nationale identitätsnummer an",
							"format": "Format: TTMMJJXXXXX"
						},
						"DK": {
							"general": "Bitte geben Sie eine gültige persönliche Identifikationsnummer(CPR) ein",
							"format": "CPR-Format: TTMMJJ-XXXX"
						},
						"IT": {
							"general": "Bitte geben Sie eine gültige Steuernummer an",
							"format": "Bitte geben Sie eine Steuernummer im folgenden Format an: CLDNRG84L58H501R"
						},
						"ES": {
							"general": "Bitte geben Sie eine gültige Persönliche Identifikationsnummer an (DNI oder NIE)",
							"format": "Bitte geben Sie die DNI oder NIE ein, z. B. 12345678A"
						},
						"PL": {
							"general": "Bitte geben Sie eine gültige Persönliche Identifikationsnummer (PESEL) ein",
							"format": "Bitte geben Sie die PESEL in diesem Format ein: JJMMTTZZZXQ"
						},
						"default": {
							"general": "Bitte geben Sie eine gültige Passnummer ein"
						}
					},
					"store_name": "Bitte geben Sie einen Shop-Namen an"
				},
				"errors_keys": {
					"correlationIdLabel": "Correlation ID: {correlationId}",
					"decisionTaken": "Entscheidung zur Vorbewertung bereit getroffen. Bitte aktualisieren Sie die Seite.",
					"maintenanceMode": "Unsere App ist aktuell wegen Wartungsarbeiten nicht verfügbar. Bitte versuchen Sie es später erneut.",
					"validation": {
						"storeName": {
							"invalidType": "Bitte geben Sie einen gültigen Shop-Namen an."
						},
						"email": {
							"invalidType": "Bitte geben Sie eine gültige Email adresse an."
						},
						"goodsCategory": {
							"invalidType": "Bitte geben Sie eine Produktkategorie an."
						},
						"website": {
							"invalidType": "Bitte geben Sie eine gültige Website an."
						}
					}
				}
			},
			"general": {
				"yes": "Ja",
				"no": "Nein",
				"encrypted_text": "*******",
				"pricing_link_eu": "Alle Preise anzeigen",
				"pricing_link_us": "Preise anzeigen",
				"formFieldOptional": "Optional",
				"buttons": {
					"next": "Weiter",
					"back": "Zurück",
					"continue": "Weiter",
					"submit_application": {
						"default": "Los geht's",
						"UPSELL_WEBSTORE_TO_ADS_MANAGER": "Erste Schritte"
					},
					"add_aditional_item": "+ Weiteren Artikel hinzufügen"
				},
				"unknown_step_title": "Bitte geben Sie die benötigten Informationen an",
				"selected": "Ausgewählt",
				"clear_all": "Alle löschen"
			},
			"errors": {
				"general": "Ein Fehler ist aufgetreten. Bitte kontaktieren Sie unseren Kundendienst.",
				"salesforce": "Bitte versuchen Sie, die Seite zu aktualisieren. Falls der Fehler fortbesteht, senden Sie bitte die Fehler-ID auf dem Slack-Kanal an #smooothforce-support. Wir helfen Ihnen gerne weiter.",
				"managed_kyc": "Bitte versuchen Sie, die Seite neu zu laden. Wenn der Fehler weiterhin auftritt, wenden Sie sich an unseren Händler-Support oder Ihren Ansprechpartner im Vertrieb.",
				"copy": "Kopieren",
				"noTermsAccepted": "Bitte lesen und akzeptieren Sie alle unsere aufgelisteten Vereinbarungen",
				"termsAlreadyAccepted": "Sie haben alle aufgelisteten Vereinbarungen bereits akzeptiert",
				"mandatoryField": " ist erforderlich"
			},
			"options": {
				"entity_types": {
					"SOLE_TRADER": "Einzelunternehmer",
					"PARTNERSHIP": "Partnerschaften/Andere",
					"PUBLIC_LISTED_COMPANY": "Börsennotiertes Unternehmen",
					"PRIVATE_COMPANY": "Privatunternehmen"
				},
				"organization_entity_types": {
					"C_CORP": "C Corporation",
					"S_CORP": "S Corporation",
					"PARTNERSHIP": "Partnerschaften/Andere",
					"TRUST_ESTATE": "Trust/Nachlass",
					"INDIVIDUAL": "Natürliche Person",
					"SOLE_PROPRIETORSHIP": "Einzelunternehmen",
					"SOLE_TRADER": "Einzelunternehmer",
					"LIMITED_LIABILITY_COMPANY": "Gesellschaft mit beschränkter Haftung",
					"SINGLE_MEMBER_LIMITED_LIABILITY_COMPANY": "Single-Member-LLC"
				},
				"goods_categories": {
					"ADULT_SHOES_AND_CLOTHING": "Bekleidung & Schuhe - Schuhe und Kleidung für Erwachsene",
					"AUTOMOTIVE_PARTS_AND_ACCESSORIES": "Automotive Produkte - Autoteile und Zubehör",
					"BAGS_AND_WALLETS": "Schmuck & Accessoires - Taschen und Brieftaschen",
					"BODY_AND_HAIR_CARE": "Gesundheit & Schönheit - Körper- und Haarpflege",
					"BOOK_AND_MAGAZINES": "Unterhaltung - Bücher und Magazine",
					"CANDY": "Speisen und Getränke - Süßigkeiten",
					"CAR_ELECTRONICS": "Elektronik - Kfz-Elektronik",
					"CHILDREN_CLOTHES_AND_NURTURING_PRODUCTS": "Kinder Produkte - Kinderkleidung und -pflege",
					"CHILDREN_TOYS": "Kinder Produkte - Kinderspielzeug",
					"CLEANING_AND_SANITARY": "Haus & Garten - Reinigung und Sanitär",
					"COLLECTIBLES": "Freizeit, Sport & Hobby - Sammlerstücke",
					"CONCEPT_STORES_AND_MISCELLANEOUS": "Freizeit, Sport & Hobby - Concept Stores und Sonstiges",
					"COSMETICS": "Gesundheit & Schönheit - Kosmetik",
					"COSTUMES_AND_PARTY_SUPPLIES": "Freizeit, Sport & Hobby - Kostüme und Partyzubehör",
					"DATING_SERVICES": "Immaterielle Produkte - Datingservice",
					"DECORATION_AND_ART": "Haus & Garten - Kunst und Dekoration",
					"DIETARY_SUPPLEMENTS": "Gesundheit & Schönheit - Nahrungsergänzungsmittel",
					"DIGITAL_SERVICES": "Immaterielle Produkte - Digitale Dienste",
					"DIVERSIFIED_CHILDREN_PRODUCTS": "Kinder Produkte - Diverse Produkte für Kinder",
					"DIVERSIFIED_ELECTRONICS": "Elektronik - Diverse Elektronik ",
					"DIVERSIFIED_ENTERTAINMENT": "Unterhaltung - Unterhaltung diverse",
					"DIVERSIFIED_EROTIC_MATERIAL": "Erotikartikel - Diverse Erotikartikel",
					"DIVERSIFIED_HEALTH_AND_BEAUTY_PRODUCTS": "Gesundheit & Schönheit – Diverse Gesundheits- und Schönheitsprodukte",
					"DIVERSIFIED_HOME_AND_GARDEN_PRODUCTS": "Haus & Garten - Heim und Garten diverse",
					"DIVERSIFIED_JEWELRY_AND_ACCESSORIES": "Schmuck & Accessoires - Diverse Schmuckstücke und Accessoires",
					"EDUCATION": "Immaterielle Produkte - Bildung",
					"ELECTRONIC_EQUIPMENT_AND_RELATED_ACCESSORIES": "Elektronik - Elektrogeräte und Zubehör",
					"EROTIC_CLOTHING_AND_ACCESSORIES": "Erotikartikel - Erotische Kleidung und Accessoires",
					"EVENT_TICKETS": "Immaterielle Produkte - Event-Tickets",
					"FOOD_AND_BEVERAGE": "Speisen und Getränke - Speisen und Getränke",
					"FRAGRANCES": "Gesundheit & Schönheit - Düfte",
					"FURNITURE": "Haus & Garten - Möbel",
					"GENERAL_SHOES_AND_CLOTHING": "Bekleidung & Schuhe - Schuhe und Kleidung allgemein",
					"HOBBY_ARTICLES": "Freizeit, Sport & Hobby - Hobbyartikel ",
					"HOUSEHOLD_ELECTRONICS": "Elektronik - Haushaltsgeräte",
					"JEWELRY_AND_WATCHES": "Schmuck & Accessoires - Schmuck und Uhren",
					"KITCHENWARE": "Haus & Garten - Küchengeräte",
					"MARKETPLACES": "Immaterielle Produkte - Marketplaces",
					"MUSIC_AND_MOVIES": "Unterhaltung - Musik und Film",
					"MUSICAL_INSTRUMENTS_AND_EQUIPMENT": "Freizeit, Sport & Hobby - Musikinstrumente und Zubehör",
					"NON_PRESCRIPTION_SUNGLASSES_AND_LENSES": "Schmuck & Accessoires - Sonnenbrillen und Linsen ohne Stärke ",
					"OFFICE_MACHINES_AND_RELATED_ACCESSORIES": "Elektronik - Bürogeräte und Zubehör",
					"OTHER_SERVICES": "Immaterielle Produkte - Andere Services",
					"PERSONAL_CARE_AND_BODY_IMPROVEMENT": "Gesundheit & Schönheit - Körperpflege",
					"PET_SUPPLIES": "Haus & Garten - Haustierzubehör",
					"PHARMACEUTICAL_PRODUCTS": "Gesundheit & Schönheit - Arzneimittel",
					"PLANTS_AND_FLOWERS": "Haus & Garten - Pflanzen und Blumen",
					"PRESCRIPTION_OPTICS": "Gesundheit & Schönheit - Brillen und Linsen mit Sehstärke",
					"PRINTS_AND_PHOTOS": "Freizeit, Sport & Hobby - Drucke und Fotos",
					"SAFETY_PRODUCTS": "Haus & Garten - Sicherheitsprodukte",
					"SEX_TOYS": "Erotikartikel - Sex-Spielzeug",
					"SPORTS_GEAR_AND_OUTDOOR": "Freizeit, Sport & Hobby - Sport- und Outdoor-Ausrüstung",
					"TOBACCO": "Speisen und Getränke - Tabakwaren",
					"TOOLS_AND_HOME_IMPROVEMENT": "Haus & Garten - Heim- und Handwerk",
					"TRAVEL_SERVICES": "Immaterielle Produkte - Reisedienste",
					"UNDERWEAR": "Bekleidung & Schuhe - Unterwäsche",
					"VIDEO_GAMES_AND_RELATED_ACCESSORIES": "Unterhaltung - Videospiele und Zubehör",
					"WHEELS_AND_TIRES": "Automotive Produkte - Reifen und Räder",
					"WINE_BEER_AND_LIQUOR": "Speisen und Getränke - Wein, Bier und Spirituosen",
					"YOUTHFUL_SHOES_AND_CLOTHING": "Bekleidung & Schuhe - Jugendliche Kleidung und Schuhe",
					"GAMBLING_BETTING_CASINOS_AND_LOTTERY": "Mit Altersbeschränkung – Glücksspiel, Wetten, Casinos und Lotterie",
					"CHARITIES_AND_NGO": "Immaterielle Produkte – Wohltätigkeitsorganisationen und NGO-Dienstleistungen",
					"EROTIC_SERVICES": "Erotik – Erotikdienstleistungen",
					"FINANCIAL_SERVICES_CRYPTO": "Finanzdienstleistungen – Aktivitäten mit Cryptowährung",
					"FINANCIAL_SERVICES_MSB": "Finanzdienstleistungen – Gelddienstleistungen",
					"FINANCIAL_SERVICES_E_WALLETS": "Finanzdienstleistungen – E-Wallets",
					"FINANCIAL_SERVICES_TRADING": "Finanzdienstleistungen – Handelsgeschäfte",
					"SOCIAL_PLATFORMS_COMMUNITIES": "Immaterielle Produkte – Social Media Communities",
					"TRAVEL_AIR_TRAVEL_AND_CRUISE_OPERATORS": "Reisen - Flug- und Kreuzfahrtunternehmen",
					"TRAVEL_BROKER_AND_AGENCIES": "Reisen - Makler und Agenturen",
					"TRAVEL_GROUND_TRANSPORTATION": "Reisen - Bodentransport",
					"TRAVEL_ACCOMMODATION_AND_RESORTS": "Reisen - Unterkunft und Resorts",
					"EVENT_ORGANIZER": "Veranstaltung - Organisator",
					"EVENT_BROKER_AND_AGENCIES": "Veranstaltung - Makler und Agenturen"
				},
				"us_states": {
					"AL": "Alabama",
					"AK": "Alaska",
					"AZ": "Arizona",
					"AR": "Arkansas",
					"CA": "Kalifornien",
					"CO": "Colorado",
					"CT": "Connecticut",
					"DC": "District of Columbia",
					"DE": "Delaware",
					"FL": "Florida",
					"GA": "Georgia",
					"HI": "Hawaii",
					"ID": "Idaho",
					"IL": "Illinois",
					"IN": "Indiana",
					"IA": "Iowa",
					"KS": "Kansas",
					"KY": "Kentucky",
					"LA": "Louisiana",
					"ME": "Maine",
					"MD": "Maryland",
					"MA": "Massachusetts",
					"MI": "Michigan",
					"MN": "Minnesota",
					"MS": "Mississippi",
					"MO": "Missouri",
					"MT": "Montana",
					"NE": "Nebraska",
					"NV": "Nevada",
					"NH": "New Hampshire",
					"NJ": "New Jersey",
					"NM": "New Mexico",
					"NY": "New York",
					"NC": "North Carolina",
					"ND": "North Dakota",
					"OH": "Ohio",
					"OK": "Oklahoma",
					"OR": "Oregon",
					"PA": "Pennsylvania",
					"RI": "Rhode Island",
					"SC": "South Carolina",
					"SD": "South Dakota",
					"TN": "Tennessee",
					"TX": "Texas",
					"UT": "Utah",
					"VT": "Vermont",
					"VA": "Virginia",
					"WA": "Washington",
					"WV": "West Virginia",
					"WI": "Wisconsin",
					"WY": "Wyoming"
				},
				"stakeholder": {
					"types": {
						"PERSON": "Person",
						"COMPANY": "Firma"
					},
					"roles": {
						"OWNER": "Eigentümer",
						"ULTIMATE_BENEFICIAL_OWNER": "Wirtschaftlicher Eigentümer",
						"CONTROL_OVER_MANAGEMENT": "Management-Kontrolle",
						"APPLICANT": "Unterschriftsberechtigter",
						"SOLE_TRADER": "Einzelunternehmer",
						"PARTNER": "Eigentümer"
					}
				},
				"payment_intervals": {
					"DAILY": "Täglich",
					"WEEKLY": "Wöchentlich"
				},
				"business_concepts": {
					"TRADITIONAL_SALE_OF_GOODS": {
						"label": "Traditioneller Verkauf von Ware",
						"description": "Der Händler verkauft Produkte oder Dienstleistungen auf traditionelle Weise: Die Waren gelten bei der ersten Lieferung als vollständig verbraucht, und zwischen Bestellung und Lieferung liegt in der Regel kein längerer Zeitraum."
					},
					"VOUCHER": {
						"label": "Gutschein",
						"description": "Mehr als 10 % des Verkaufs sind Gutscheine und/oder Geschenkkarten"
					},
					"MEMBERSHIP": {
						"label": "Mitgliedschaft",
						"description": "Mehr als 10 % des Verkaufs sind Mitgliedschaften"
					},
					"SUBSCRIPTION": {
						"label": "Abonnement",
						"description": "Mehr als 10 % des Verkaufs sind Abonnements"
					},
					"PHARMACIES": {
						"label": "Apotheken",
						"description": "Händler verkauft Medikamente (verschreibungspflichtig oder nicht)"
					},
					"US_PHARMACIES": {
						"label": "Apotheken der USA",
						"description": "Der Händler verkauft verschreibungspflichtige und frei verkäufliche Medikamente in den USA."
					},
					"MEDICAL_SERVICES": {
						"label": "Medizinische Versorgung",
						"description": "Der Händler bietet medizinische Versorgungsdienstleistungen wie Tests, Untersuchungen, Pflegeleistungen"
					},
					"MARKETPLACES": {
						"label": "Marketplaces",
						"description": "Händler hat eine Unterhändler-Beziehung"
					},
					"FIREARM_DEALERS": {
						"label": "Schusswaffenhändler",
						"description": "Händler verkauft Waffen, Munition, die eine Lizenz benötigen"
					},
					"AUCTIONS": {
						"label": "Auktionen",
						"description": "Händler ist ein Auktionshaus"
					},
					"ALCOHOL": {
						"label": "Alkohol",
						"description": "Händler verkauft Alkohol"
					},
					"TOBACCO": {
						"label": "Tabakwaren",
						"description": "Händler verkauft Tabak mit oder ohne Nikotin oder Händler verkauft E-Zigaretten"
					},
					"HEMP_CBD_THC": {
						"label": "Hanf, CBD oder THC",
						"description": "Händler verkauft Produkte, die Hanf, CBD oder THC enthalten."
					},
					"DONATIONS_CHARITY": {
						"label": "Spenden und Wohlfahrt",
						"description": "Händler ist eine spendenbasierte oder Wohlfahrtsorganisation, die Onboarding über \"Auszahlung nach Abrechnung\" betreibt"
					},
					"TRAVEL": {
						"label": "Reisen",
						"description": "Mehr als 10 % des Verkaufs sind Reisen"
					},
					"EVENTS": {
						"label": "Events",
						"description": "Mehr als 10 % des Verkaufs sind Events"
					},
					"COURSES": {
						"label": "Kurse",
						"description": "Mehr als 10 % des Verkaufs sind Kurse"
					},
					"EDUCATIONAL_COURSES": {
						"label": "Schulungen",
						"description": "Der Händler bietet Schulungen an, die eine bestimmte Zeit dauern."
					},
					"FOOD_DELIVERY": {
						"label": "Essenslieferung",
						"description": "Der Händler bietet Essenslieferungen als Dienstleistung an."
					},
					"CUSTOMISED_PRE_ORDER_FURNITURE": {
						"label": "Personalisierte Vorbestellungen/Möbel",
						"description": "Der Händler verkauft Produkte auf Vorbestellung, beispielsweise Möbel."
					},
					"DIGITAL_CONTENT": {
						"label": "Digitale Inhalte",
						"description": "Der Händler verkauft digitale Inhalte wie E-Books und Onlinespiele."
					},
					"GAMING_INDUSTRY": {
						"label": "Glücksspielbranche (Glücksspiel, Wetten, Casinos, Lotterien)",
						"description": "Der Händler bietet Dienstleistungen an, die mit der Glücksspielbranche in Verbindung stehen, beispielsweise Glücksspiele, Wetten, Casinos und Lotterien."
					}
				}
			},
			"pages": {
				"select_products_page": {
					"page_header": {
						"primary_title": "Hallo {firstName},",
						"primary_title_without_name": "Hallo",
						"sub_title": "Shakespeare sagt: Mehr Klarna ist mehr Klarna.",
						"sub_title_no_products": "Starten Sie durch mit Klarna, indem Sie weiter unten ein Produkt auswählen",
						"sub_title_kp_products": "Wählen Sie ein weiteres Klarna Produkt",
						"sub_title_ongoing_product": "Einrichtung von {productName} fortsetzen"
					},
					"sidebar_left": {
						"products": {
							"title": "Zahlungsprodukte",
							"text_blocks": [
								{
									"text": "Fügen Sie ein Lösung zu Ihrem Setup hinzu"
								}
							]
						}
					},
					"buttons": {
						"start": "Start",
						"continue": "Weiter",
						"view_summary": "Zusammenfassung anzeigen",
						"add_another_product": "Mehr Produkte hinzufügen"
					},
					"goodie_bags": {
						"playground": {
							"title": "Playground",
							"text": "Wechseln Sie zum Playground, um Test-API-Zugangsdaten zu erstellen und Ihre Plattform zu testen. ",
							"link": "Playground"
						},
						"marketing_assets": {
							"title": "Marketingmaterial",
							"text": "Mit Klarna wird für Ihre Kunden einfach alles smoooth. Nutzen Sie unser Marketingmaterial, um sie auf den Geschmack zu bringen.",
							"link": "Material erhalten"
						},
						"your_application": {
							"title": "Ihre Anmeldung",
							"text": "Klicken Sie hier, um die Einrichtung abzuschließen oder Details zu Ihrer Anwendung anzuzeigen, einschließlich der AGB.",
							"link": "Öffnen"
						},
						"invite_more_users": {
							"title": "Laden Sie weitere Nutzer ein",
							"text": "Laden Sie Ihre Mitarbeiter in das Händlerportal ein. Dort können Sie ihnen passende Berechtigungen zuweisen.",
							"link": "Benutzer einladen"
						}
					},
					"footer": {
						"title": "Immer inklusive mit Klarna",
						"list": {
							"merchant_portal": {
								"title": "Das Händlerportal",
								"text_blocks": [
									{
										"text": "Verwalten Sie alles rund um Klarna mit vollständigem Zugang zum Backend."
									}
								]
							},
							"global_products": {
								"title": "Globale Produkte, lokale Gesichter",
								"text_blocks": [
									{
										"text": "Alle unsere Produkte sind angepasst an die lokalen Vorlieben und die rechtliche Situation."
									}
								]
							},
							"local_support": {
								"title": "Lokaler Support für Sie und Ihre Kunden",
								"text_blocks": [
									{
										"text": "Bei uns stehen Tausende von Kollegen bereit, um Ihren Kunden zu helfen, wenn sie den persönlichen Kontakt benötigen."
									}
								]
							},
							"marketing_tool": {
								"title": "Klarna als Marketinginstrument",
								"text_blocks": [
									{
										"text": "Wir geben Ihnen Zugang zu Klarnas Materialien, sodass Sie diese für Ihr Marketing nutzen können."
									}
								]
							},
							"single_integration": {
								"title": "Eine Integration, automatische Updates",
								"text_blocks": [
									{
										"text": "Eine Integration, keine Updates. Niemals."
									},
									{
										"text": "Sobald Sie Klarna integriert haben, sind Sie fertig. Klarna bleibt auf dem aktuellsten Stand - und Sie können sich entspannt zurücklehnen."
									}
								]
							},
							"no_risk": {
								"title": "Kein Risiko für Sie oder Ihre Kunden",
								"text_blocks": [
									{
										"text": "Ihre Auszahlungen erhalten Sie garantiert und Ihre Kunden sind duch den Klarna Käuferschutz versichert."
									}
								]
							}
						}
					}
				},
				"credentials_page": {
					"sidebar_left": {
						"connection_key": {
							"title": "Klarna API-Zugangsdaten",
							"text_blocks": [
								{
									"text": "Klarna API-Zugangsdaten verbinden unser Produkt mit Ihrem Onlineshop, sodass Sie direkt verkaufen können."
								}
							]
						},
						"toc_key": {
							"title": "AGB",
							"text_blocks": [
								{
									"text": "Sie müssen Ihre E-Commerce-AGB aktualisieren"
								}
							]
						},
						"connect_to_your_platform": {
							"title": "Integrationsanleitung",
							"text_blocks": [
								{
									"text": ""
								}
							]
						}
					},
					"main": {
						"how_to_use": {
							"title": "So nutzen Sie Ihre Klarna API-Zugangsdaten",
							"ordered_list": {
								"one": "Erstellen und erhalten Sie Ihre Zugangsdaten",
								"two": "Füge Sie die Zugangsdaten (Klarna API-Benutzername und Passwort) auf Ihrer Plattform ein, wie in der Integrationsanleitung unten beschrieben."
							}
						},
						"number_of_live_keys_in_total": {
							"title": "Insgesamt 5 Klarna API-Zugangsdaten",
							"text": "Sie können bis zu 5 Klarna API-Zugangsdaten erstellen. Erhalten Sie die ersten hier und erstellen Sie die restlichen unter Einstellungen.",
							"button": "API-Zugangsdaten generieren"
						},
						"how_to_update_toc": {
							"title": "So aktualisieren Sie die AGB",
							"ordered_list": {
								"one": "Den Link besuchen",
								"two": "Lesen Sie die Anleitung und kopieren Sie den Text",
								"three": "Fügen Sie Ihn den AGB Ihres Webshops hinzu"
							}
						},
						"update_toc_link": {
							"title": "",
							"text": "Bitte denken Sie daran, den Text um die Produkte zu ergänzen, für die Sie sich angemeldet haben.",
							"linkText": "Zur Aktualisierung der AGB >"
						},
						"buttons": {
							"back": "Zurück"
						}
					}
				},
				"whats_next_page": {
					"communication": {
						"TRANSACTIONS_REVIEW_AUTOMATED": "Ihr Antrag wird derzeit geprüft ...",
						"TRANSACTION_DETAILS_STARTED": "Ihr Antrag wird derzeit von unserem Team geprüft. Wir werden uns so schnell wie möglich mit Ihnen in Verbindung setzen.",
						"TRANSACTIONS_REVIEW_MANUAL": "Ihr Antrag wird derzeit von unserem Team geprüft. Wir werden uns so schnell wie möglich mit Ihnen in Verbindung setzen.",
						"TRANSACTIONS_ENABLED": "Glückwunsch! Sie können nun mit Klarna verkaufen.",
						"PAYOUTS_REVIEW_AUTOMATED": "Ihr Antrag auf Auszahlungen wird derzeit geprüft...",
						"PAYOUTS_REVIEW_MANUAL": "Ihr Antrag auf Auszahlungen wird derzeit von unserem Team geprüft. Wir werden uns so schnell wie möglich mit Ihnen in Verbindung setzen.",
						"PAYOUTS_REVIEW_AWAITING_FIRST_TRANSACTION": "Wir warten auf Ihren ersten Verkauf mit Klarna...",
						"TRANSACTIONS_DISABLED": "Ihr Account is deaktiviert, bis Sie Ihre Auszahlungen freischalten.",
						"SUSPENDED": "Ihr Account wurde gesperrt.",
						"notice": "Derzeit haben wir überdurchschnittlich lange Wartezeiten, um Ihren Antrag zu prüfen. Machen Sie sich aber keine Sorgen, Ihr Antrag wird geprüft, und wir werden schnellstmöglich mit weiteren Informationen zu den nächsten Schritten auf Sie zukommen. Wir wissen Ihre Geduld zu schätzen und danken Ihnen für Ihr Verständnis."
					},
					"statuses": {
						"pending": "In Bearbeitung",
						"done": "Fertig"
					},
					"in_review": {
						"title": "Wir prüfen Ihren Antrag.",
						"subtitle": "Ihr Antrag an Klarna befindet sich gerade in der letzten Prüfphase, damit wir sichergehen können, dass im Vertrag alles korrekt ist. Dies ist ein manueller Vorgang, weshalb die Bearbeitungszeiten variieren können. Wir bemühen uns jedoch um schnellstmögliche Erledigung.",
						"content": {
							"title": "Um eine reibungslose Prüfung zu ermöglichen, sollte auf Ihrer Website Folgendes zu finden sein:",
							"list": {
								"default": {
									"item_1": "Ihr eingetragener Unternehmensname",
									"item_2": "Ihre eingetragene Unternehmensnummer",
									"item_3": "Ihre eingetragene Unternehmensanschrift",
									"item_4": "Rückgaberecht von mindestens 14 Tagen",
									"item_5": "E-Mail oder Telefonnummer des Kundenservice"
								},
								"US": {
									"item_1": "Eingetragener Firmenname",
									"item_2": "Rücksendebedingungen",
									"irem_3": "E-Mail oder Telefonnummer des Kundenservice"
								},
								"AU": {
									"item_1": "ABN (Unternehmensnummer) oder eingetragener Unternehmensname.",
									"item_3": "Ihre eingetragene Unternehmensanschrift",
									"item_4": "Rückgaberecht von mindestens 14 Tagen",
									"item_5": "E-Mail oder Telefonnummer des Kundenservice"
								}
							}
						},
						"footer": "Sobald die Prüfung abgeschlossen ist oder wir noch zusätzliche Informationen von Ihnen benötigen, kontaktieren wir Sie per E-Mail."
					},
					"suspended": {
						"title": "Leider …",
						"subtitle": "Nach Prüfung der Vertragsbestimmungen müssen wir Ihren Antrag leider ablehnen. Es können mehrere Gründe vorliegen, warum Ihr Antrag abgelehnt wurde. Im Folgenden nennen wir Ihnen die häufigsten ausschlaggebenden Faktoren:",
						"content": {
							"title": "",
							"list": {
								"item_1": "Ihr Store widerspricht Klarnas ethischen Richtlinien.",
								"item_2": "Der angegebene Ansprechpartner ist nicht erreichbar.",
								"item_3": "Andere technische oder administrative Faktoren."
							}
						},
						"footer": "Vielen Dank für Ihr Interesse an Klarna. Gerne stehen wir Ihnen für Fragen zur Verfügung oder falls Sie zu einem späteren Zeitpunkt einen anderen Store anmelden möchten."
					},
					"disabled": {
						"title": "Ihr Antrag wurde gesperrt.",
						"subtitle": "Ihr Konto wurde automatisch gesperrt, da gesetzlich vorgeschriebene Angaben fehlen.",
						"content": {
							"title": "Dies erfolgt gewöhnlich dann, wenn Klarna entsprechende Angaben von Ihnen angefordert hat, innerhalb der festgelegten Frist jedoch keine Antwort erhielt."
						},
						"footer": "Falls Sie der Ansicht sind, dass es sich hierbei um einen Fehler handelt oder Sie Angaben nachreichen möchten, wenden Sie sich bitte an den Händler Support unter der in der Fußzeile dieser Seite angegebenen Adresse."
					},
					"ready_to_connect": {
						"title": "Verbinden Sie Ihren Onlineshop.",
						"subtitle": "Ihr Vertrag wurde angenommen. Sie können Klarna ab jetzt in Ihren Store integrieren. Folgen Sie den im Folgenden angegebenen Schritten, um die Integration zu vollziehen.",
						"status_messsage": {
							"title": "Die Integration wurde noch nicht abgeschlossen",
							"subtitle": "Folgen Sie den Anweisungen zur Integration, um Ihren Store zu verbinden. Dieser Status ändert sich zu Grün, sobald eine Transaktion über Klarna getätigt wurde."
						},
						"content": {
							"title": "Anweisungen",
							"options": {
								"label_1": "Erzeugen Sie Ihre Klarna API-Zugangsdaten und speichern Sie diese",
								"description_1": "Erzeugen Sie neue API-Zugangsdaten und laden Sie sie auf Ihren Computer. Sie benötigen diese API-Zugangsdaten im nächsten Abschnitt.",
								"label_2": "Installieren Sie Klarna in Ihrem Shopify Store"
							}
						}
					},
					"ready_to_connect_new_ig": {
						"title": "Fast geschafft",
						"subtitle": "Sie sind einen Schritt näher, Ihren Kund:innen ein smooothes Shopping anbieten zu können! Ihr Vertrag wurde angenommen und Ihr Shop ist bereit zur Integration.",
						"buttons": {
							"connect": "Verbinden Sie Ihren Onlineshop."
						},
						"additional_info": "Bitte beachten Sie, dass die Integration erst dann als vollständig abgeschlossen gilt, wenn wir die erste Bestellung erhalten, was je nach Ihrer Plattform eine Weile dauern kann."
					},
					"store_connected": {
						"title": "Ihr Store ist verbunden",
						"subtitle": "Die Integration Ihres Stores in Klarna war erfolgreich. Ihre Kunden können ab jetzt über Klarna Zahlungen leisten.",
						"status_messsage": {
							"title": "Erfolgreiche Integration",
							"subtitle": "In Ihrem Store wurde eine Klarna Transaktion erfolgreich abgewickelt.",
							"button_text": {
								"shown": "Anweisungen zur Integration anzeigen",
								"hidden": "Anweisungen zur Integration ausblenden"
							}
						}
					},
					"actions": {
						"view_summary": {
							"title": "Ihre Anmeldung",
							"subtitle": "Prüfen Sie Ihre Antragsdaten.",
							"button_text": "Zusammenfassung anzeigen"
						},
						"connect_store": {
							"title": "Klarna API-Zugangsdaten",
							"subtitle": "Erzeugen Sie Ihre Klarna API-Zugangsdaten, um Ihren Store zu integrieren.",
							"button_text": "Klarna API-Zugangsdaten erzeugen"
						},
						"add_product": {
							"title": "Produkte",
							"subtitle": "Klicken Sie hier, falls Sie ein Produkt zu diesem Setup hinzufügen möchten.",
							"button_text": "Produkte hinzufügen"
						}
					},
					"timeline": {
						"application": {
							"title": "Ihre Anmeldung",
							"alert": {
								"view_summary": "Zusammenfassung anzeigen",
								"rejected": "Wir mussten Ihren Antrag ablehnen.",
								"review": "Über den folgenden Link gelangen Sie zu Ihren Antragsdaten."
							}
						},
						"payouts": {
							"title": "Auszahlungen aktiviert"
						},
						"integration": {
							"title": "Die Integration wurde noch nicht abgeschlossen",
							"alert": "Folgen Sie den Anweisungen zur Integration, um Ihren Shop zu verbinden."
						},
						"integration_complete": {
							"title": "Die Integration ist abgeschlossen!"
						}
					}
				},
				"summary_page": {
					"header": {
						"title": "Herzlichen Glückwunsch! Die Einrichtung ist abgeschlossen!",
						"rejection": "Es tut uns leid, wir konnten Ihre Einrichtung nicht abschließen."
					},
					"header_new": {
						"title": "Willkommen bei Klarna",
						"subtitle": "Zusammenfassung",
						"rejection": "Antrag abgelehnt"
					},
					"joy_section": {
						"approved": {
							"title": "Akzeptiert!",
							"content": "Ihre Bewerbung wurde geprüft und akzeptiert. Nun steht Ihnen voller Zugriff auf die Dienste von Klarna zur Verfügung. Wir freuen uns darauf, mit Ihnen zusammenzuarbeiten!",
							"button_title": "Prüfen Sie Ihre Bestellungen",
							"link": "oder unser Marketingmaterial"
						},
						"rejected": {
							"title": "Es tut uns Leid …",
							"content_1": "Nach Prüfung Ihrer Bewerbung können wir Ihren Händlervertrag leider nicht genehmigen.",
							"content_2": "Wenden Sie sich bei Fragen an unser Support Team."
						}
					},
					"sidebar_left": {
						"application_details": "Ihre Anwendung",
						"store_details": {
							"title": "Angaben zum Shop",
							"text_blocks": [
								{
									"text": "Zusammenfassung Ihrer Angaben"
								}
							]
						},
						"credentials": {
							"title": "Klarna API-Zugangsdaten",
							"text_blocks": [
								{
									"text": "Ihre Klarna API-Zugangsdaten"
								}
							]
						},
						"payouts": {
							"title": "Auszahlungen",
							"text_blocks": [
								{
									"text": "Ihre Bankdaten"
								}
							]
						},
						"additional_bank_accounts": {
							"title": "Weitere Bankkonten",
							"text_block": null
						},
						"business_owners": {
							"title": "Geschäftsinhaber",
							"text_blocks": null
						},
						"material_influencers": {
							"title": "Personen mit maßgeblichem Einfluss",
							"text_blocks": null
						},
						"stakeholders": {
							"title": "Stakeholder",
							"text_blocks": [
								{
									"text": "Ihre übermittelten Informationen"
								}
							]
						}
					},
					"main": {
						"store_details": {
							"business_owners": {
								"title": "Geschäftsinhaber",
								"no_elements": "Sie haben keine Geschäftsinhaber angegeben"
							}
						},
						"payouts": {
							"default_bank_accounts": {
								"title": "Standard-Bankkonto",
								"no_elements": "Kein Standard-Bankkonto vorhanden"
							},
							"additional_bank_accounts": {
								"title": "Weitere Bankkonten",
								"no_elements": "Sie haben keine weiteren Bankkonten angegeben"
							}
						},
						"stakeholders": {
							"owners": {
								"title": "Eigentümer",
								"no_elements": "Sie haben keine Geschäftsinhaber angegeben"
							},
							"ultimate_beneficial_owner": {
								"title": "Wirtschaftlicher Eigentümer",
								"no_elements": "Sie haben keine wirtschaftlichen Eigentümer angegeben"
							},
							"applicant": {
								"title": "Antragsteller",
								"no_elements": "Sie haben keinen Antragsteller angegeben"
							},
							"control_over_management": {
								"title": "Personen mit Management-Kontrolle",
								"no_elements": "Sie haben keine Personen mit Management-Kontrolle übermittelt"
							}
						},
						"buttons": {
							"back": "Zurück",
							"next_step": "Weiter"
						}
					}
				},
				"additional_products_page": {
					"sidebar_left": {
						"we_have_your_data": {
							"title": "Wir haben Ihre Angaben bereits",
							"text_blocks": [
								{
									"text": "Diese Informationen haben wir von Ihnen erhalten"
								}
							]
						}
					},
					"main": {
						"business_ownership": {
							"no_elements": "Sie haben keine Geschäftsinhaber angegeben"
						},
						"buttons": {
							"submit": "Abschicken",
							"back": "Zurück"
						}
					}
				},
				"checking_page": {
					"title": "Wird geprüft...",
					"subtitle": "Danke, dass Sie den Antrag eingereicht haben. Bitte warten Sie, bis wir ihn geprüft haben ..."
				},
				"success_page": {
					"title": "Sie können Ihren Shop jetzt verbinden",
					"subtitle": "Danke, dass Sie den Antrag eingereicht haben.",
					"buttons": {
						"next": "Weiter"
					}
				}
			},
			"components": {
				"split_image_container": {
					"timeline": {
						"basics": "Grundlagen",
						"business": "Unternehmen",
						"stakeholders": "Stakeholder",
						"bank_accounts": "Bankkonten"
					}
				},
				"app_error": {
					"title": "Die Produkt-App ist momentan nicht verfügbar",
					"message": "Es liegen aktuell Probleme mit unserer Anwendung vor und wir kümmern uns bereits darum. Wir versuchen, alle Probleme so bald wie möglich zu lösen. Bitte versuchen Sie es später erneut."
				},
				"temporarily_down": {
					"title": "Wir haben momentan technische Schwierigkeiten",
					"message": "Bitte entschuldigen Sie die Unannehmlichkeiten und kommen Sie später nochmals wieder. Wir arbeiten mit Hochdruck daran, das Problem zu lösen!"
				},
				"maintenance_mode": {
					"title": {
						"products_app": "Unsere Produkt-App ist wegen Wartungsarbeiten gerade nicht verfügbar",
						"signup_app": "Unsere Anmeldungs-App ist momentan aufgrund von Wartungsarbeiten nicht aktiv"
					},
					"message": "Wir arbeiten daran, Ihre Erfahrung zu verbessern und hoffen, dass bald alles erledigt ist. Bitte versuchen Sie es später erneut."
				},
				"unknown_merchant": {
					"before_link": "Sollten Sie bereits einen Vertrag mit uns haben, besuchen Sie bitte",
					"link_text": "diese Seite,",
					"after_link": "um mehr über unsere Produkte herauszufinden!"
				},
				"pre_assessment_error": {
					"title": {
						"invalid_flow_type": "Es ist ein Fehler aufgetreten.",
						"invalid_token": "Dieser Link ist abgelaufen"
					},
					"message": {
						"invalid_token_risk": "Bitte kontaktieren Sie uns auf dem Slack-Kanal #smooothforce-support. Wir helfen Ihnen gerne weiter.",
						"invalid_token": "Bitte wenden Sie sich an Ihren Ansprechpartner im Vertrieb.",
						"invalid_flow_type": "Onboarding-Typ und Status dieses Händlers sind nicht kompatibel. Wenn Sie glauben, dass es sich um einen Fehler handelt, wenden Sie sich bitte an den Händler-Support."
					}
				},
				"topbar": {
					"title": "Setup",
					"widget_type": {
						"MANAGED_KYC": "KYC-Erfassung",
						"MANAGED_RISK": "Vorbewertungs-Erfassung",
						"MANAGED_SME_RISK": "SME Vorbewertungs-Erfassung"
					}
				},
				"product_card": {
					"incompatible_description": "Nicht für Ihr Land/Ihre Plattform verfügbar",
					"kco_footer_text": "Die in Klarna Checkout verfügbaren Zahlungsarten sind abhängig vom Land der Registrierung und dem Land, in das verkauft wird.",
					"products_link_text": "Mehr"
				},
				"product_prices_card": {
					"title": "Produkte",
					"subtitle": "{country}",
					"pricing": "Preise für {country}",
					"monthly_fee": "monatiliche Gebühr",
					"transaction_fee": "Transaktionsgebühr",
					"before_link": "Ich akzeptiere die Klarna",
					"link_text": "AGB",
					"after_link_one_product": "für dieses Produkt",
					"after_link_more_than_one_product": "für diese Produkte",
					"product_not_available_in_your_country": "* Dieses Produkt ist nicht für Ihren Heimatmarkt verfügbar, funktioniert jedoch in anderen Ländern.",
					"edit_link": "Bearbeiten",
					"merchant_agreement": {
						"before_link": "Ich stimme Folgendem zu:",
						"link_text": "Händlervereinbarung",
						"after_link_one_product": "für dieses Produkt",
						"after_link_more_than_one_product": "für diese Produkte"
					},
					"pricing_annex": {
						"before_link": "Ich stimme Folgendem zu:",
						"link_text": "Bedingungen für die Preisgestaltung",
						"after_link_one_product": "für dieses Produkt"
					}
				},
				"support_footer": {
					"text": "Englischsprachiger Support",
					"copyright": {
						"eu": "Copyright © 2005-{currentYear} Klarna Bank AB (publ). Alle Rechte vorbehalten.",
						"ap": "Copyright © 2005-{currentYear} Klarna Australia Pty Ltd, ABN # 82 635 912 579.",
						"us": "Copyright © 2005-{currentYear} Klarna Inc. NMLS #1353190, 629 N. High Street, Third Floor, Columbus, OH 43215."
					},
					"terms_and_conditions": "Allgemeine Geschäftsbedingungen (AGB)",
					"privacy_policy": "Datenschutzrichtlinie zu",
					"merchant_id": "Händler-ID {merchantId}",
					"email": "moa.support@klarna.com",
					"contact_number": "+46 (8) 123 45 67",
					"support_link": "Händler-Support",
					"recaptcha": {
						"1_main_text": "Diese Website ist durch reCAPTCHA geschützt. Es gelten die",
						"2_privacy_policy": "Datenschutzrichtlinie",
						"3_and": "und",
						"4_terms_of_service": "Nutzungsbedingungen von",
						"5_apply": "Google."
					}
				},
				"global_prices_dialog": {
					"title_eu": "Preise für alle unsere Märkte",
					"title_us": "Preise",
					"subtitle": "Sie zahlen nur eine Gebühr per Transaktion, das ist smoooth!",
					"table": {
						"country": "Land",
						"price_column_heading": "Gebühr per Transaktion",
						"global": "global",
						"title": {
							"kp": "Zahlungsarten",
							"kco": "Klarna Checkout",
							"kco_one": "Klarna Checkout",
							"kp_one": "Klarna Zahlungsmethode"
						},
						"headers": {
							"kp_one": "Servicegebühr"
						}
					},
					"buttons": {
						"back": "Zurück"
					},
					"foot_notes": {
						"global_price": "* Lokale Währung des Händlers, ansonsten "
					}
				},
				"fake_approval": {
					"first_transaction": {
						"title": "Erste Transaktion",
						"content": "Bevor wir ihre Auszahlungsdetails prüfen, brauchen Sie eine erste Bestellung. Wollen Sie nicht ihr eigenes Geld verwenden? Kein Problem!",
						"button": "Tun Sie einfach so!"
					},
					"transactions": {
						"title": "Transaktionen ermöglichen",
						"content": "Sie können die Genehmigung der Translaktion in Saleforce einfach vortäuschen",
						"button": "Genehmigen"
					},
					"payouts": {
						"title": "Auszahlungen ermöglichen",
						"content": "Sie können die Genehmigung der Auszahlungen in Saleforce einfach vortäuschen",
						"button": "Genehmigen"
					}
				},
				"bank_account_summary": {
					"subtitle": {
						"default": "Standard-Bankkonto",
						"additional": "Weiteres Bankkonto {index}",
						"normal": "Bankkonto {index}"
					},
					"currency_code": {
						"label": "Währung"
					},
					"country_of_bank_account": {
						"label": "Land"
					},
					"account_number": {
						"label": {
							"default": "Kontonummer",
							"MX_LOCAL": "CLABE-Nummer"
						}
					},
					"account_holder": {
						"label": "Name des Kontoinhabers"
					},
					"routing_number": {
						"label": "Bankleitzahl"
					},
					"transit_number": {
						"label": "Transitnummer"
					},
					"institution_number": {
						"label": "Institutsnummer"
					},
					"bic": {
						"label": {
							"default": "BIC",
							"AU": "BSB (Bankleitzahl in Australien)"
						}
					},
					"no_edit_button": "Nach Abschluss Ihres Onboardings können Sie Ihre Bankdaten ändern"
				},
				"store_details_summary": {
					"legal_company_name": {
						"label": "Juristische Bezeichnung des Unternehmens"
					},
					"country": {
						"label": "Land"
					},
					"registrationId": {
						"label": {
							"default": "Handelsregisternummer",
							"AT": "Firmenbuchnummer",
							"AU": "ABN",
							"CA": "Geschäftsnummer",
							"ES": "Unternehmens-NIF/NIE/DNI",
							"GB": "Handelsregisternummer",
							"GR": "G.E.MI.-Nummer (Γ.Ε.ΜΗ.)",
							"US": "Arbeitgeber-Identifikationsnummer"
						}
					},
					"organizationRegistrationAuthority": {
						"label": "Registergericht"
					},
					"goodsCategory": {
						"label": "Warenkategorie"
					},
					"registered": {
						"label": {
							"default": "Eingetragenes Unternehmen",
							"AU": "Unternehmen hat eine ABN"
						}
					},
					"subjectToVat": {
						"label": {
							"default": "Unternehmen ist umsatzsteuerpflichtig",
							"AU": "Unternehmen unterliegt ABN",
							"ES": "Unternehmen verfügt über eine NIF/NIE/DNI"
						}
					},
					"vatId": {
						"label": {
							"default": "USt-IdNr.",
							"AU": "ABN",
							"ES": "Unternehmens-NIF/NIE/DNI"
						}
					},
					"storeName": {
						"label": "Name des Shops"
					},
					"website": {
						"label": "Website"
					},
					"email": {
						"label": "Kundenservice Email"
					},
					"entityType": {
						"label": "Entitätstyp"
					},
					"toc_data": {
						"label": "AGB",
						"toc_approval_text": {
							"before_link": "Ihre",
							"link_text": "AGB,",
							"after_link": "die am {date} akzeptiert wurden",
							"merchant_agreement": {
								"before_link": "Ihre",
								"link_text": "Händlervereinbarung",
								"after_link": "– die am {date} akzeptiert wurde"
							},
							"pricing_annex": {
								"before_link": "Ihre",
								"link_text": "Anlage für die Preisgestaltung",
								"after_link": "– die am {date} akzeptiert wurde"
							}
						}
					},
					"companyName": {
						"label": "Name der Handelsgesellschaft"
					},
					"registeredCompanyName": {
						"label": "Name des Unternehmens"
					},
					"address": {
						"label": "Adresse"
					},
					"operatingAddress": {
						"label": "Betriebsadresse"
					},
					"organizationEntityType": {
						"label": "Steuerklassifikation"
					}
				},
				"api_key_dialog": {
					"title": "Klarna API-Zugangsdaten erzeugt",
					"subtitle": "Die Zugangsdaten werden nur einmal angezeigt. Klicken Sie auf die unten stehende Schaltfläche und laden Sie Ihre Zugangsdaten herunter, bevor Sie dieses Fenster schließen.",
					"key_box": {
						"username": {
							"label": "Klarna API-Benutzername"
						},
						"password": {
							"label": "Klarna API-Passwort"
						},
						"file_name": "Klarna_Zugangsdaten"
					},
					"buttons": {
						"download": "Als .txt herunterladen"
					}
				},
				"platform_instructions": {
					"step": "Schritt  {current}/{max}",
					"next": "Weiter",
					"back": "Zurück",
					"shopify": [
						{
							"title": "Erzeugen Sie Ihre Klarna API-Zugangsdaten und speichern Sie diese",
							"step_instructions": [
								[
									{
										"text": "Erzeugen Sie neue API-Zugangsdaten und laden Sie die Datei auf Ihren Computer. Öffnen Sie die Datei und lassen Sie sie geöffnet, da Sie diese API-Zugangsdaten im nächsten Abschnitt benötigen werden."
									}
								]
							],
							"alternate": [
								{
									"text": "Für weitere ausführliche Informationen über Ihre Shopify-Integration, folgen Sie bitte dem"
								},
								{
									"link": "https://x.klarnacdn.net/plugins/Klarna%20Payments%20on%20Shopify%20-%20Merchant%20Guide.pdf#page=4",
									"text": "detaillierten Integrationsleitfaden."
								}
							]
						},
						{
							"title": "Installieren Sie Klarna in Ihrem Shopify Store",
							"step_instructions": [
								[
									{
										"text": "Gehen Sie zu"
									},
									{
										"link": "https://www.klarnapayments.com/merchant_admin/guide/install_app/slice_it_pay_over_time_with_klarna/enter-your-shopify-store-name-here",
										"text": "Klarna Zahlungsmethode Setup-Assistent für Shopify."
									}
								],
								[
									{
										"text": "Folgen Sie den Anweisungen, um die Integration abzuschließen."
									}
								]
							],
							"alternate": [
								{
									"text": "Für weitere ausführliche Informationen über Ihre Shopify-Integration, folgen Sie bitte dem"
								},
								{
									"link": "https://x.klarnacdn.net/plugins/Klarna%20Payments%20on%20Shopify%20-%20Merchant%20Guide.pdf#page=4",
									"text": "detaillierten Integrationsleitfaden."
								}
							]
						},
						{
							"title": "Machen Sie einen Testkauf",
							"step_instructions": [
								[
									{
										"text": "Um die korrekte Integration zu prüfen, machen Sie in Ihrem Store bitte einen Testkauf."
									}
								],
								[
									{
										"text": "Nach Absenden der Bestellung, gehen Sie"
									},
									{
										"link": "/orders/#realm=merchants",
										"text": "im Händler Portal auf Bestellungen,"
									},
									{
										"text": "suchen Ihre Bestellung und stornieren sie, damit Sie keine Zahlung an sich selbst leisten müssen."
									}
								],
								[
									{
										"text": "Sobald Ihre Integration erfolgreich abgeschlossen wurde, ändert der Banner am oberen Rand dieser Seite seine Farbe zu Grün und zeigt „Integration abgeschlossen“ an."
									}
								]
							],
							"alternate": [
								{
									"text": "Für weitere ausführliche Informationen über Ihre Shopify-Integration, folgen Sie bitte dem"
								},
								{
									"link": "https://x.klarnacdn.net/plugins/Klarna%20Payments%20on%20Shopify%20-%20Merchant%20Guide.pdf#page=4",
									"text": "detaillierten Integrationsleitfaden."
								}
							]
						}
					],
					"plentymarkets": [
						{
							"title": "Aktivieren Sie das Klarna Zahlungsmethode-Plugin für Plentymarkets",
							"step_instructions": [
								[
									{
										"text": "Um das Klarna Plugin installieren zu können, benötigen Sie eine lauffähige Umgebung von Plentymarkets CERES. Das"
									},
									{
										"link": "https://marketplace.plentymarkets.com/en/plugins/sales/online-shops/ceres_4697",
										"text": "Ceres Plugin"
									},
									{
										"text": "können Sie sich über den plentyMarketplace herunterladen, von dort werden Sie auch zur"
									},
									{
										"link": "https://knowledge.plentymarkets.com/en/online-store/setting-up-ceres",
										"text": "Installationsanleitung des Ceres Systems weitergeleitet."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Für detaillierte Informationen bzgl. der Klarna Integration unter Plentymarkets CERES folgen Sie bitte der"
									},
									{
										"link": "https://marketplace.plentymarkets.com/plugins/payment/klarna_6731",
										"text": "Integrationsanleitung."
									}
								]
							]
						},
						{
							"title": "Installation & Einrichtung",
							"step_instructions": [
								[
									{
										"text": "Die Installation des Klarna Plugins erfolgt über den"
									},
									{
										"link": "https://marketplace.plentymarkets.com/plugins/payment/klarna_6731",
										"text": "plentyMarketplace."
									},
									{
										"text": "Auch aus dem Backend des plentymarkets Systems werden Sie direkt dorthin weitergeleitet. Eine"
									},
									{
										"link": "https://knowledge.plentymarkets.com/en/slp/plugins/plugins-system-hinzufuegen",
										"text": "Anleitung zur Installation von Plugins"
									},
									{
										"text": "finden Sie auf plentyKnowledge."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Für detaillierte Informationen bzgl. der Klarna Integration unter Plentymarkets CERES folgen Sie bitte der"
									},
									{
										"link": "https://marketplace.plentymarkets.com/plugins/payment/klarna_6731",
										"text": "Integrationsanleitung."
									}
								]
							]
						},
						{
							"title": "Plugin-Konfiguration",
							"step_instructions": [
								[
									{
										"text": "Das Plugin wird direkt im jeweiligen Set konfiguriert. Durch Klick auf die Zeile des"
									},
									{
										"bold": "Klarna Plugins"
									},
									{
										"text": "öffnet sich die Seite mit der Konfiguration."
									}
								],
								[
									{
										"text": "Die Konfiguration teilt sich in zwei Bereiche:"
									},
									{
										"list": [
											[
												{
													"bold": "Authentifizierung:"
												},
												{
													"text": "Hier wird über den Modus festgelegt ob es sich um Testing oder Produktiv handelt. Je nach Modus muss der Benutzername und das Passwort hinterlegt werden."
												}
											],
											[
												{
													"bold": "Allgemeine Einstellungen:"
												},
												{
													"text": "Hier wird das Produkt ausgewählt, das Sie nutzen möchten. Zur Wahl stehen die flexiblen Zahlungsarten Klarna Payment oder Klarna Checkout. Bei der Auswahl des Checkouts wird der Checkout im Shop dann automatisch durch den Klarna Checkout überschrieben. Es sind hierbei keinerlei weitere Einstellungen notwendig. Beim Deaktivieren des Plugins wird dies auch wieder rückgängig gemacht."
												}
											]
										]
									},
									{
										"text": "Mehr Einstellungen müssen nicht im Plugin vorgenommen werden. Sobald die Zahlungsarten dann in den entsprechenden Kundenklassen aktiviert wurden, erscheinen diese auch im Webshop."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Für detaillierte Informationen bzgl. der Klarna Integration unter Plentymarkets CERES folgen Sie bitte der"
									},
									{
										"link": "https://marketplace.plentymarkets.com/plugins/payment/klarna_6731",
										"text": "Integrationsanleitung."
									}
								]
							]
						},
						{
							"title": "Letzte Informationen",
							"step_instructions": [
								[
									{
										"text": "Folgende Systemvoraussetzungen gelten:"
									},
									{
										"list": [
											{
												"text": "Plentymarkets version 7"
											},
											{
												"text": "Ceres and IO Plugins installiert"
											}
										]
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Für detaillierte Informationen bzgl. der Klarna Integration unter Plentymarkets CERES folgen Sie bitte der"
									},
									{
										"link": "https://marketplace.plentymarkets.com/plugins/payment/klarna_6731",
										"text": "Integrationsanleitung."
									}
								]
							]
						}
					],
					"woocommerce_kco": [
						{
							"title": "Klarna Checkout Plugin für WooCommerce aktivieren",
							"step_instructions": [
								[
									{
										"text": "Stellen Sie zunächst sicher, dass Sie das Klarna Checkout Plugin für WooCommerce installiert haben. Falls das Plugin noch nicht installiert ist, besuchen Sie"
									},
									{
										"link": "https://woocommerce.com/products/klarna-checkout/#",
										"text": "diese Seite,"
									},
									{
										"text": "um es abzurufen."
									}
								],
								[
									{
										"text": "Sobald Sie die Zugangsdaten für Ihre Klarna API erhalten haben, klicken Sie im WooCommerce Panel zunächst auf \"Einstellungen\" und dann auf \"Checkout\". Wählen Sie \"Klarna Checkout\"."
									}
								],
								[
									{
										"text": "Aktivieren Sie Klarna Checkout, indem Sie das Kontrollkästchen \"Klarna Checkout aktivieren\" auswählen."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Weitere Informationen zur Integration von WooCommerce finden Sie im"
									},
									{
										"link": "https://docs.woocommerce.com/document/klarna-checkout/?_ga=2.128400911.2052696952.1531845795-1157999962.1506496988#",
										"text": "umfangreichen Leitfaden."
									}
								]
							]
						},
						{
							"title": "Konfigurieren der Einstellungen",
							"step_instructions": [
								[
									{
										"text": "Konfigurieren Sie die Einstellungen für Ihren Klarna Checkout. Beachten Sie, dass das Feld \"Titel\" zur Festlegung des Titels der beim Checkout angezeigten Zahlungsmethode und der Emails zur Bestellbestätigung dient (d. h. Klarna Checkout)."
									}
								],
								[
									{
										"text": "Aktivieren Sie das Kontrollkästchen \"Testmodus\", wenn Sie Bestellungen über einen Testzugang erstellen möchten."
									}
								],
								[
									{
										"text": "Nun ist es Zeit, die Ländereinstellungen festzulegen. Wenn Sie sich in Europa befinden, klicken Sie im Abschnitt \"Europa\" auf \"Ausklappen\". Wenn Sie sich in den Vereinigten Staaten befinden, klicken Sie im Abschnitt \"Vereinigte Staaten\" auf \"Ausklappen\"."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Weitere Informationen zur Integration von WooCommerce finden Sie im"
									},
									{
										"link": "https://docs.woocommerce.com/document/klarna-checkout/?_ga=2.128400911.2052696952.1531845795-1157999962.1506496988#",
										"text": "umfangreichen Leitfaden."
									}
								]
							]
						},
						{
							"title": "Geben Sie Ihre Klarna API-Zugangsdaten ein.",
							"step_instructions": [
								[
									{
										"text": "Geben Sie Ihre Klarna API-Zugangsdaten in die Felder \"Klarna API-Benutzername\" und \"Klarna API-Passwort\" ein."
									}
								],
								[
									{
										"text": "Speichern Sie Ihre Einstellungen."
									}
								],
								[
									{
										"text": "Dann müssen Sie noch Klarna Checkout als Standard-Zahlungemethode festlegen. Wechseln Sie im WooCommerce Panel zu \"Einstellungen\" und dann zu \"Zahlungen\". Legen Sie im Abschnitt \"Zahlungsmethoden\" Klarna Checkout als Standard-Zahlungemethode fest."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Weitere Informationen zur Integration von WooCommerce finden Sie im"
									},
									{
										"link": "https://docs.woocommerce.com/document/klarna-checkout/?_ga=2.128400911.2052696952.1531845795-1157999962.1506496988#",
										"text": "umfangreichen Leitfaden."
									}
								]
							]
						},
						{
							"title": "Letzte Schritte",
							"step_instructions": [
								[
									{
										"text": "Aktivieren Sie"
									},
									{
										"link": "https://codex.wordpress.org/Using_Permalinks",
										"text": "Pretty Permalinks"
									},
									{
										"text": "in Ihrer WordPress-Installation. Andernfalls werden Callbacks von Klarna in Ihrem Store nicht funktionieren und Bestellungen werden nicht mit dem korrekten Bestellstatus/der korrekten Information aktualisiert."
									}
								],
								[
									{
										"text": "Wenn Sie Ihre Klarna-Bestellung direkt in WooCommerce verwalten möchten, müssen Sie das"
									},
									{
										"link": "https://wordpress.org/plugins/klarna-order-management-for-woocommerce/",
										"text": "Klarna Order Management"
									},
									{
										"text": "Plugin installieren."
									}
								],
								[
									{
										"text": "Stellen Sie sicher, dass Klarna Checkout wie gewünscht angezeigt wird, indem Sie Ihrem Warenkorb einen Artikel hinzufügen und zum Checkout wechseln (geben Sie keine tatsächliche Bestellung auf)."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Weitere Informationen zur Integration von WooCommerce finden Sie im"
									},
									{
										"link": "https://docs.woocommerce.com/document/klarna-checkout/?_ga=2.128400911.2052696952.1531845795-1157999962.1506496988#",
										"text": "umfangreichen Leitfaden."
									}
								]
							]
						}
					],
					"woocommerce_kp": [
						{
							"title": "Erzeugen Sie Ihre Klarna API-Zugangsdaten und speichern Sie diese",
							"step_instructions": [
								[
									{
										"text": "Erzeugen Sie neue API-Zugangsdaten und laden Sie die Datei auf Ihren Computer. Öffnen Sie die Datei und lassen Sie sie geöffnet, da Sie diese API-Zugangsdaten im nächsten Abschnitt benötigen werden."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Für weitere ausführliche Informationen über Ihre WooCommerce-Integration folgen Sie bitte dem"
									},
									{
										"link": "https://docs.woocommerce.com/document/klarna-payments/",
										"text": "detaillierten Integrationsleitfaden."
									}
								]
							]
						},
						{
							"title": "Installieren und aktivieren Sie das Klarna Zahlungsmethode-Plugin",
							"step_instructions": [
								[
									{
										"text": "Installieren Sie das"
									},
									{
										"link": "https://woocommerce.com/products/klarna-payments/",
										"text": "Klarna Zahlungsmethode-Plugin für WooCommerce."
									}
								],
								[
									{
										"text": "Gehen Sie in Ihrem WooCommerce-Konto auf"
									},
									{
										"bold": "Einstellungen → Zahlungen → Klarna Zahlungsmethode."
									}
								],
								[
									{
										"text": "Aktivieren Sie die Klarna Zahlungsmethode, indem Sie ein Häkchen bei „Klarna Zahlungsmethode aktivieren“ setzen."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Für weitere ausführliche Informationen über Ihre WooCommerce-Integration, folgen Sie bitte dem"
									},
									{
										"link": "https://docs.woocommerce.com/document/klarna-payments/",
										"text": "detaillierten Integrationsleitfaden."
									}
								]
							]
						},
						{
							"title": "Konfigurieren Sie Ihre Ländereinstellungen",
							"step_instructions": [
								[
									{
										"text": "Füllen Sie die Ländereinstellungen aus. Jedes Klarna Land hat eigene länderspezifische Einstellungen. Wenn Sie Händler-Zugangsdaten zu einem bestimmten Land hinzufügen, aktivieren Sie damit auch die Klarna Zahlungsmethode als Zahlungsart für dieses Land."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Für weitere ausführliche Informationen über Ihre WooCommerce-Integration, folgen Sie bitte dem"
									},
									{
										"link": "https://docs.woocommerce.com/document/klarna-payments/",
										"text": "detaillierten Integrationsleitfaden."
									}
								]
							]
						},
						{
							"title": "Geben Sie Ihre Klarna API-Zugangsdaten ein.",
							"step_instructions": [
								[
									{
										"text": "Geben Sie Ihre Klarna API-Zugangsdaten in den Feldern Klarna API-Benutzername und Klarna API-Passwort ein."
									}
								],
								[
									{
										"text": "Speichern Sie Ihre Einstellungen."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Für weitere ausführliche Informationen über Ihre WooCommerce-Integration, folgen Sie bitte dem"
									},
									{
										"link": "https://docs.woocommerce.com/document/klarna-payments/",
										"text": "detaillierten Integrationsleitfaden."
									}
								]
							]
						},
						{
							"title": "Machen Sie einen Testkauf",
							"step_instructions": [
								[
									{
										"text": "Um die korrekte Integration zu prüfen, machen Sie in Ihrem Store bitte einen Testkauf."
									}
								],
								[
									{
										"text": "Nach Absenden der Bestellung, gehen Sie"
									},
									{
										"link": "/orders/#realm=merchants",
										"text": "im Händler Portal auf Bestellungen,"
									},
									{
										"text": "suchen Ihre Bestellung und stornieren sie, damit Sie keine Zahlung an sich selbst leisten müssen."
									}
								],
								[
									{
										"text": "Sobald Ihre Integration erfolgreich abgeschlossen wurde, ändert der Banner am oberen Rand dieser Seite seine Farbe zu Grün und zeigt „Integration abgeschlossen“ an."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Für weitere ausführliche Informationen über Ihre WooCommerce-Integration, folgen Sie bitte dem"
									},
									{
										"link": "https://docs.woocommerce.com/document/klarna-payments/",
										"text": "detaillierten Integrationsleitfaden."
									}
								]
							]
						}
					],
					"magento_kco": [
						{
							"title": "Konfigurieren der Einstellungen zur Aktivierung von Klarna Checkout",
							"step_instructions": [
								[
									{
										"text": "Stellen Sie zunächst sicher, dass Sie das Klarna Modul Plugin für Magento installiert haben. Falls das Modul noch nicht installiert ist, besuchen Sie"
									},
									{
										"link": "https://marketplace.magento.com/klarna-m2-checkout.html",
										"text": "diese Seite,"
									},
									{
										"text": "um es abzurufen."
									}
								],
								[
									{
										"text": "Sobald Sie über Ihre Klarna API-Zugangsdaten verfügen, öffnen Sie Ihr Magento Panel. Wechseln Sie zu “Stores” → ”Konfiguration” → ”Verkauf” → ”Zahlungsmethoden” → ”Klarna” → ”Klarna API”."
									}
								],
								[
									{
										"text": "Klappen Sie den Abschnitt \"Klarna API\" aus und geben Sie Ihre API-Version, Klarna API-Benutzername und Klarna API-Passwort an. Achten Sie darauf, den Testmodus zu deaktiveren, wenn Sie bereit sind, mit Ihrer Seite Live zu gehen."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Weitere Informationen zur Integration von Magento finden Sie im"
									},
									{
										"link": "https://marketplace.magento.com/media/catalog/product/klarna-m2-checkout-6-2-0-ce/user_guides.pdf",
										"text": "umfangreichen Leitfaden."
									}
								]
							]
						},
						{
							"title": "Letzte Schritte",
							"step_instructions": [
								[
									{
										"text": "Wenn Ihre Einstellungen konfiguriert sind, müssen Sie sicherstellen, dass Klarna Checkout in Ihren Checkout-Optionen aktiviert ist."
									}
								],
								[
									{
										"text": "Wechseln Sie im Magento Panel zu “Stores” → ”Konfiguration” → ”Verkauf” → ”Checkout” → ”Klarna Checkout Optionen”."
									}
								],
								[
									{
										"text": "Klarna Checkout sollte standardmäßig aktiviert sein. Falls nicht, ändern Sie die Einstellung zu"
									},
									{
										"bold": "Aktiviert"
									},
									{
										"text": "unter \"Klarna Checkout aktivieren\"."
									}
								]
							]
						}
					],
					"magento_kp": [
						{
							"title": "Erzeugen Sie Ihre Klarna API-Zugangsdaten und speichern Sie diese",
							"step_instructions": [
								[
									{
										"text": "Erzeugen Sie neue API-Zugangsdaten und laden Sie die Datei auf Ihren Computer. Öffnen Sie die Datei und lassen Sie sie geöffnet, da Sie diese API-Zugangsdaten im nächsten Abschnitt benötigen werden."
									}
								]
							]
						},
						{
							"title": "Installieren und aktivieren Sie das Klarna Zahlungsmethode-Modul",
							"step_instructions": [
								[
									{
										"text": "Rufen Sie die"
									},
									{
										"link": "https://docs.magento.com/user-guide/payment/klarna-setup.html#set-up-klarna-payments-in-magento",
										"text": "Magento Benutzeranleitung „Klarna einrichten auf …“"
									},
									{
										"text": "auf und folgen Sie den Anweisungen, um das Modul in Ihrem Magento-Konto zu installieren und zu konfigurieren."
									}
								]
							]
						},
						{
							"title": "Machen Sie einen Testkauf",
							"step_instructions": [
								[
									{
										"text": "Um die korrekte Integration zu prüfen, machen Sie in Ihrem Store bitte einen Testkauf."
									}
								],
								[
									{
										"text": "Nach Absenden der Bestellung, gehen Sie"
									},
									{
										"link": "/orders/#realm=merchants",
										"text": "im Händler Portal auf Bestellungen,"
									},
									{
										"text": "suchen Ihre Bestellung und stornieren sie, damit Sie keine Zahlung an sich selbst leisten müssen."
									}
								],
								[
									{
										"text": "Sobald Ihre Integration erfolgreich abgeschlossen wurde, ändert der Banner am oberen Rand dieser Seite seine Farbe zu Grün und zeigt „Integration abgeschlossen“ an."
									}
								]
							]
						}
					],
					"shopware_kp": [
						{
							"title": "Aktivieren Sie das Klarna Zahlungsmethode-Plugin für Shopware",
							"step_instructions": [
								[
									{
										"text": "Stellen Sie zunächst sicher, dass Sie das Klarna Zahlungsmethode-Plugin für Shopware installiert haben. Wenn Sie das Plugin noch nicht haben, gehen Sie zu"
									},
									{
										"link": "https://store.shopware.com/en/besti13231874259f/klarna-payments.html",
										"text": "diese Seite,"
									},
									{
										"text": "um es abzurufen."
									}
								],
								[
									{
										"text": "Im nächsten Schritt müssen Sie das Klarna Zahlungsmethode-Plugin in Shopware importieren. Klicken Sie dazu durch die Navigationspunkte"
									},
									{
										"bold": "Konfiguration → Plugin Manager → Installiert → Plugin hochladen."
									},
									{
										"text": "Klicken Sie auf"
									},
									{
										"bold": "Auswählen"
									},
									{
										"text": "und wählen Sie die ZIP-Datei des Klarna Zahlungsmethode-Plugins. Klicken Sie zur Bestätigung"
									},
									{
										"bold": "Plugin hochladen."
									},
									{
										"text": "Das Plugin wird nun im Plugin Manager angezeigt."
									}
								],
								[
									{
										"text": "Installieren Sie das Plugin durch Klicken auf das"
									},
									{
										"bold": "grüne \"+\""
									},
									{
										"text": "Symbol."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Weitere Informationen zur Integration von Shopware finden Sie im"
									},
									{
										"link": "https://klarna.bestit-online.de/de/kp/master/installation",
										"text": "umfassenden Leitfaden (auf Deutsch)."
									}
								]
							]
						},
						{
							"title": "Konfigurieren des Klarna Zahlungsmethode-Plugins für Shopware",
							"step_instructions": [
								[
									{
										"text": "Wechseln SIe in die Plugin-Einstellungen durch Klicken auf"
									},
									{
										"bold": "Konfiguration → Grundeinstellungen → Nach Klarna Zahlungsmethode suchen"
									}
								],
								[
									{
										"text": "Geben Sie Ihre Klarna API-Zugangsdaten in die Felder ein."
									},
									{
										"bold": "Klarna API-Benutzername"
									},
									{
										"text": "und"
									},
									{
										"bold": "Klarna API-Passwort"
									},
									{
										"text": "ein und speichern Sie die Einstellungen."
									}
								],
								[
									{
										"text": "Bitte achten Sie darauf, den Live-Modus zu verwenden und Ihre tatsächlichen Klarna API-Zugangsdaten anzugeben."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Weitere Informationen zur Integration von Shopware finden Sie im"
									},
									{
										"link": "https://klarna.bestit-online.de/de/kp/master/installation",
										"text": "umfassenden Leitfaden (auf Deutsch)."
									}
								]
							]
						},
						{
							"title": "Konfigurieren Ihrer/Ihres Klarna Zahlungsmethode-Gateway(s)",
							"step_instructions": [
								[
									{
										"text": "Bevor Sie Klarna verwenden können, müssen Sie Ihre/Ihren Klarna Zahlungsmethode-Gateway(s) konfigurieren. Diese(n) finden Sie unter"
									},
									{
										"bold": "Konfiguration → Zahlungsarten"
									}
								],
								[
									{
										"text": "Standardmäßig sind alle Klarna Zahlungsmethode-Gateways installiert. Öffnen Sie die Klarna Zahlungsmethode-Gateways, für die Sie sich registriert haben und aktivieren Sie diese, indem Sie ein Häkchen setzen bei"
									},
									{
										"bold": "Aktiviert."
									},
									{
										"text": "Speichern Sie die Einstellungen."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Weitere Informationen zur Integration von Shopware finden Sie im"
									},
									{
										"link": "https://klarna.bestit-online.de/de/kp/master/installation",
										"text": "umfassenden Leitfaden (auf Deutsch)."
									}
								]
							]
						},
						{
							"title": "Konfigurieren der Versandkosten",
							"step_instructions": [
								[
									{
										"text": "Konfigurieren Sie die Versandkosten für Ihre(n) Klarna Zahlungsmethode-Gateway(s) durch Klicken auf"
									},
									{
										"bold": "Konfiguration → Versandkosten"
									}
								],
								[
									{
										"text": "Wählen Sie die Versandmethoden, die für Klarna zur Verfügung stehen sollen, durch Klicken auf das"
									},
									{
										"bold": "Bleistiftsymbol aus."
									}
								],
								[
									{
										"text": "Wählen Sie den Reiter zur Auswahl der Zahlungsmethoden aus und ändern Sie Ihre(n) Klarna Zahlungsmethode-Gateway(s) von"
									},
									{
										"bold": "Verfügbar"
									},
									{
										"text": "zu"
									},
									{
										"bold": "Ausgewählt."
									},
									{
										"text": "Speichern Sie Ihre Einstellungen."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Weitere Informationen zur Integration von Shopware finden Sie im"
									},
									{
										"link": "https://klarna.bestit-online.de/de/kp/master/installation",
										"text": "umfassenden Leitfaden (auf Deutsch)."
									}
								]
							]
						},
						{
							"title": "Aktivieren des Klarna Zahlungsmethode-Plugins",
							"step_instructions": [
								[
									{
										"text": "Im nächsten Schritt müssen Sie das Klarna Zahlungsmethode-Plugin aktivieren. Klicken Sie dazu durch die Navigationspunkte"
									},
									{
										"bold": "Konfiguration → Plugin Manager → Installiert"
									},
									{
										"text": "zum Anzeigen des Plugin Managers."
									}
								],
								[
									{
										"text": "Aktivieren Sie das Plugin durch Klicken auf das"
									},
									{
										"bold": "rote \"X\""
									},
									{
										"text": "Symbol."
									}
								],
								[
									{
										"text": "Sie werden gefragt, ob Sie den Cache leeren möchten. Klicken Sie auf"
									},
									{
										"bold": "Ja."
									},
									{
										"text": "Bitte beachten Sie, dass Sie nach jeder Änderung an den Moduleinstellungen oder den Zahlungsarten von Klarna den Cache leeren und Themes kompilieren müssen."
									}
								],
								[
									{
										"text": "Um das Klarna Zahlungsmethode-Plugin vollständig zu aktivieren, muss das Shop-Theme neu kompiliert werden. Klicken Sie auf"
									},
									{
										"bold": "Themes kompilieren,"
									},
									{
										"text": "wenn Sie dazu aufgefordert werden."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Weitere Informationen zur Integration von Shopware finden Sie im"
									},
									{
										"link": "https://klarna.bestit-online.de/de/kp/master/installation",
										"text": "umfassenden Leitfaden (auf Deutsch)."
									}
								]
							]
						},
						{
							"title": "Letzte Schritte",
							"step_instructions": [
								[
									{
										"text": "Um Rundungsfehler zu vermeiden, stellen Sie sicher, dass die PHP-Erweiterung bcmath auf Ihrem Server installiert ist. Den Leitfaden finden Sie"
									},
									{
										"link": "http://php.net/manual/en/book.bc.php",
										"text": "hier"
									},
									{
										"text": "."
									}
								],
								[
									{
										"text": "Starten Sie das Backend einmal neu, um sicherzustellen, dass alle Konfigurationen in Ihrem Shop zur Verfügung stehen."
									}
								],
								[
									{
										"text": "Stellen Sie sicher, dass Ihr(e) Klarna Payment Produkt(e) wie gewünscht angezeigt werden, indem Sie Ihrem Warenkorb einen Artikel hinzufügen, Klarna als Zahlungsmethode wählen und zum Checkout wechseln (geben Sie keine tatsächliche Bestellung auf)."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Weitere Informationen zur Integration von Shopware finden Sie im"
									},
									{
										"link": "https://klarna.bestit-online.de/de/kp/master/installation",
										"text": "umfassenden Leitfaden (auf Deutsch)."
									}
								]
							]
						}
					],
					"shopware_kco": [
						{
							"title": "Aktivieren des Klarna Checkout Plugins für Shopware",
							"step_instructions": [
								[
									{
										"text": "Stellen Sie zunächst sicher, dass Sie das Klarna Checkout Plugin für Shopware (Version 5.2.17 und neuer) installiert haben. Falls das Plugin noch nicht installiert ist, besuchen Sie"
									},
									{
										"link": "https://store.shopware.com/en/besti56121054232f/klarna-checkout.html",
										"text": "diese Seite,"
									},
									{
										"text": "um es abzurufen."
									}
								],
								[
									{
										"text": "Im nächsten Schritt müssen Sie das Klarna Checkout Plugin in Shopware importieren. Klicken Sie dazu durch die Navigationspunkte"
									},
									{
										"bold": "Konfiguration → Plugin Manager → Installiert → Plugin hochladen."
									},
									{
										"text": "Klicken Sie auf"
									},
									{
										"bold": "Auswählen"
									},
									{
										"text": "und wählen Sie die ZIP-Datei des Klarna Checkout Plugins. Bestätigen Sie mit einem Klick auf"
									},
									{
										"bold": "Plugin hochladen."
									},
									{
										"text": "Das Plugin wird nun im Plugin Manager angezeigt."
									}
								],
								[
									{
										"text": "Installieren Sie das Plugin durch Klicken auf das"
									},
									{
										"bold": "grüne \"+\""
									},
									{
										"text": "Symbol."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Weitere Informationen zur Integration von Shopware finden Sie im"
									},
									{
										"link": "https://klarna.bestit-online.de/de/kp/master/installation",
										"text": "umfassenden Leitfaden (auf Deutsch)."
									}
								]
							]
						},
						{
							"title": "Konfigurieren des Klarna Checkout Plugins für Shopware",
							"step_instructions": [
								[
									{
										"text": "Wechseln SIe in die Plugin-Einstellungen durch Klicken auf"
									},
									{
										"bold": "Konfiguration → Grundeinstellungen → Nach Klarna Checkout suchen"
									}
								],
								[
									{
										"text": "Geben Sie Ihre Klarna API-Zugangsdaten in die Felder ein."
									},
									{
										"bold": "Klarna API-Benutzername"
									},
									{
										"text": "und"
									},
									{
										"bold": "Klarna API-Passwort"
									},
									{
										"text": "ein und speichern Sie die Einstellungen."
									}
								],
								[
									{
										"text": "Bitte achten Sie darauf, den Live-Modus zu verwenden und Ihre tatsächlichen Klarna API-Zugangsdaten anzugeben."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Weitere Informationen zur Integration von Shopware finden Sie im"
									},
									{
										"link": "https://klarna.bestit-online.de/de/kp/master/installation",
										"text": "umfassenden Leitfaden (auf Deutsch)."
									}
								]
							]
						},
						{
							"title": "Aktivieren des Klarna Checkout Payment Gateway",
							"step_instructions": [
								[
									{
										"text": "Bevor Sie Klarna verwenden können, müssen Sie Ihren Klarna Payment Gateway konfigurieren. Diesen finden Sie unter"
									},
									{
										"bold": "Konfiguration → Zahlungsmethoden"
									}
								],
								[
									{
										"text": "Öffnen Sie den Klarna Checkout Gateway und aktivieren Sie diesen durch Aktivieren des Kontrollkästchens"
									},
									{
										"bold": "Aktiviert."
									},
									{
										"text": "Speichern Sie die Einstellungen."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Weitere Informationen zur Integration von Shopware finden Sie im"
									},
									{
										"link": "https://klarna.bestit-online.de/de/kp/master/installation",
										"text": "umfassenden Leitfaden (auf Deutsch)."
									}
								]
							]
						},
						{
							"title": "Konfigurieren der Versandkosten",
							"step_instructions": [
								[
									{
										"text": "Konfigurieren Sie die Versandkosten für Ihren Klarna Payment Gateway durch Klicken auf"
									},
									{
										"bold": "Konfiguration → Versandkosten"
									}
								],
								[
									{
										"text": "Wählen Sie die Versandmethoden, die für Klarna zur Verfügung stehen sollen, durch Klicken auf das"
									},
									{
										"bold": "Bleistiftsymbol aus."
									}
								],
								[
									{
										"text": "Wählen Sie den Reiter zur Auswahl der Zahlungsmethoden aus und ändern Sie Ihren Klarna Payment Gateway von"
									},
									{
										"bold": "Verfügbar"
									},
									{
										"text": "zu"
									},
									{
										"bold": "Ausgewählt."
									},
									{
										"text": "Speichern Sie Ihre Einstellungen."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Weitere Informationen zur Integration von Shopware finden Sie im"
									},
									{
										"link": "https://klarna.bestit-online.de/de/kp/master/installation",
										"text": "umfassenden Leitfaden (auf Deutsch)."
									}
								]
							]
						},
						{
							"title": "Aktivieren des Klarna Checkout Plugins",
							"step_instructions": [
								[
									{
										"text": "Im nächsten Schritt müssen Sie das Klarna Checkout Plugin aktivieren. Klicken Sie dazu durch die Navigationspunkte"
									},
									{
										"bold": "Konfiguration → Plugin Manager → Installiert"
									},
									{
										"text": "zum Anzeigen des Plugin Managers."
									}
								],
								[
									{
										"text": "Aktivieren Sie das Plugin durch Klicken auf das"
									},
									{
										"bold": "rote \"X\""
									},
									{
										"text": "Symbol."
									}
								],
								[
									{
										"text": "Sie werden gefragt, ob Sie den Cache leeren möchten. Klicken Sie auf"
									},
									{
										"bold": "Ja."
									}
								],
								[
									{
										"text": "Um das Klarna Checkout Plugin vollständig zu aktivieren, muss das Shop-Theme neu kompiliert werden. Klicken Sie auf"
									},
									{
										"bold": "Themes kompilieren,"
									},
									{
										"text": "wenn Sie dazu aufgefordert werden."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Weitere Informationen zur Integration von Shopware finden Sie im"
									},
									{
										"link": "https://klarna.bestit-online.de/de/kp/master/installation",
										"text": "umfassenden Leitfaden (auf Deutsch)."
									}
								]
							]
						},
						{
							"title": "Letzte Schritte",
							"step_instructions": [
								[
									{
										"text": "Um Rundungsfehler zu vermeiden, stellen Sie sicher, dass die PHP-Erweiterung bcmath auf Ihrem Server installiert ist. Den Leitfaden finden Sie"
									},
									{
										"link": "http://php.net/manual/en/book.bc.php",
										"text": "hier"
									},
									{
										"text": "."
									}
								],
								[
									{
										"text": "Stellen Sie sicher, dass \"Zusatzadresse 1\" und \" Zusatzadresse 2\" nicht als Pflichtfelder konfiguriert sind."
									}
								],
								[
									{
										"text": "Starten Sie das Backend einmal neu, um sicherzustellen, dass alle Konfigurationen in Ihrem Shop zur Verfügung stehen."
									}
								],
								[
									{
										"text": "Stellen Sie sicher, dass Ihr Klarna Checkout wie gewünscht angezeigt wird, indem Sie Ihrem Warenkorb einen Artikel hinzufügen, Klarna als Zahlungsmethode wählen und zum Checkout wechseln (geben Sie keine tatsächliche Bestellung auf)."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Weitere Informationen zur Integration von Shopware finden Sie im"
									},
									{
										"link": "https://klarna.bestit-online.de/de/kp/master/installation",
										"text": "umfassenden Leitfaden (auf Deutsch)."
									}
								]
							]
						}
					],
					"shopware_6_kp": [
						{
							"title": "Aktivieren Sie das Klarna Zahlungsmethode-Plugin für Shopware",
							"step_instructions": [
								[
									{
										"text": "Um das Klarna Plugin installieren zu können, benötigen Sie eine lauffähige Umgebung von Shopware 6. Eine Installationsanleitung hierzu finden Sie"
									},
									{
										"link": "https://docs.shopware.com/de/shopware-6-de/erste-schritte/shopware-6-installieren?category=shopware-6-de/erste-schritte",
										"text": "hier."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Für detaillierte Informationen bzgl. der Klarna Integration unter Shopware v6 folgen Sie bitte der"
									},
									{
										"link": "https://x.klarnacdn.net/mepo/onboarding/integration-guides/shopware_6/de.pdf",
										"text": "Integrationsanleitung."
									}
								]
							]
						},
						{
							"title": "Installation & Einrichtung. Es gibt verschiedene Wege, das Klarna Plugin zu installieren.",
							"step_instructions": [
								[
									{
										"text": "First Run Wizard."
									}
								],
								[
									{
										"text": "Installation via Administration."
									}
								],
								[
									{
										"text": "Installation via Community Store Direkt-Download."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Für detaillierte Informationen bzgl. der Klarna Integration unter Shopware v6 folgen Sie bitte der"
									},
									{
										"link": "https://x.klarnacdn.net/mepo/onboarding/integration-guides/shopware_6/de.pdf",
										"text": "Integrationsanleitung."
									}
								]
							]
						},
						{
							"title": "Klarna Zahlungsmethode-Plugin für Shopware aktivieren",
							"step_instructions": [
								[
									{
										"text": "Gehen Sie hierfür in der Shopware Administration auf die Übersicht Ihrer Plugins. Diese erreichen Sie via"
									},
									{
										"bold": "Einstellungen > System > Plugins. "
									}
								],
								[
									{
										"text": "Wählen Sie den Menüpunkt"
									},
									{
										"bold": "Installieren"
									},
									{
										"text": "über das Kontext-Menü (“...”) aus. Sie erhalten eine Erfolgsmeldung von Shopware, dass das Plugin erfolgreich installiert wurde."
									}
								],
								[
									{
										"text": "Zu Ihrer Sicherheit ist das Plugin jetzt installiert, jedoch noch nicht aktiviert, da Sie es zunächst mit Ihren Zugangsdaten und individuellen Einstellungen optimieren müssen."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Für detaillierte Informationen bzgl. der Klarna Integration unter Shopware v6 folgen Sie bitte der"
									},
									{
										"link": "https://x.klarnacdn.net/mepo/onboarding/integration-guides/shopware_6/de.pdf",
										"text": "Integrationsanleitung."
									}
								]
							]
						},
						{
							"title": "Wizard",
							"step_instructions": [
								[
									{
										"text": "Nachdem das Plugin aktiviert wurde, können Sie über das Kontext-Menü (“...”) die Installationsroutine in Form eines Wizards aufrufen. Klicken Sie hierfür auf den Menüpunkt "
									},
									{
										"bold": "Wizard.",
										"text": "Sie werden anschließend zur Routine weitergeleitet."
									}
								],
								[
									{
										"text": "Die Routine führt Sie vollständig durch den Einrichtungsprozess und erlaubt Ihnen auch sich bei Klarna zu registrieren, sollten Sie noch keinen Händleraccount besitzen."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Für detaillierte Informationen bzgl. der Klarna Integration unter Shopware v6 folgen Sie bitte der"
									},
									{
										"link": "https://x.klarnacdn.net/mepo/onboarding/integration-guides/shopware_6/de.pdf",
										"text": "Integrationsanleitung."
									}
								]
							]
						},
						{
							"title": "Plugin-Konfiguration",
							"step_instructions": [
								[
									{
										"bold": "Verkaufskanäle."
									},
									{
										"text": "Hier legen Sie fest, ob die nachfolgenden Einstellungen für “alle Verkaufskanäle” oder nur für bestimmte einzelne Verkaufskanäle gelten sollen."
									}
								],
								[
									{
										"bold": "API Einstellungen."
									},
									{
										"text": "API Benutzername und API Passwort: Tragen Sie hier Ihre API-Zugangsdaten für den Live- und Testmodus in die passende Abschnitte ein."
									}
								],
								[
									{
										"text": "Ihre Klarna API-Zugangsdaten können Sie hier durch Klicken testen"
									},
									{
										"bold": "API-Zugangsdaten testen,",
										"text": "welcher sich im Header befindet, überprüfen. Sie erhalten dann eine Erfolgsmeldung oder einen Hinweis, welche Daten nicht korrekt zu sein scheinen."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Für detaillierte Informationen bzgl. der Klarna Integration unter Shopware v6 folgen Sie bitte der"
									},
									{
										"link": "https://x.klarnacdn.net/mepo/onboarding/integration-guides/shopware_6/de.pdf",
										"text": "Integrationsanleitung."
									}
								]
							]
						},
						{
							"title": "Plugin aktivieren/deaktivieren",
							"step_instructions": [
								[
									{
										"text": "Falls Sie das Klarna Zahlungsmethode-Plugin aktivieren/deaktivieren möchten oder einfach nur den aktuellen Aktivierungsstatus einsehen möchten, wechseln Sie im Shopware Admin zu"
									},
									{
										"bold": "Einstellungen > System > Plugins. "
									}
								],
								[
									{
										"text": "Dort finden Sie den aktuellen Status in der Tabelle unter "
									},
									{
										"bold": "“Meine Plugins”."
									}
								],
								[
									{
										"text": "Der Status kann verändert werden, durch einen Klick auf den Schieberegler."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Für detaillierte Informationen bzgl. der Klarna Integration unter Shopware v6 folgen Sie bitte der"
									},
									{
										"link": "https://x.klarnacdn.net/mepo/onboarding/integration-guides/shopware_6/de.pdf",
										"text": "Integrationsanleitung."
									}
								]
							]
						},
						{
							"title": "Folgende Systemvoraussetzungen gelten:",
							"step_instructions": [
								[
									{
										"text": "PHP Version >= 7.2"
									}
								],
								[
									{
										"text": "Vollständige Installation von Shopware"
									},
									{
										"bold": "(Storefront und Administration, nicht Headless)."
									}
								],
								[
									{
										"text": "Das System muss von außen erreichbar sein für die Aktualisierung des Zahlungsstatus."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Für detaillierte Informationen bzgl. der Klarna Integration unter Shopware v6 folgen Sie bitte der"
									},
									{
										"link": "https://x.klarnacdn.net/mepo/onboarding/integration-guides/shopware_6/de.pdf",
										"text": "Integrationsanleitung."
									}
								]
							]
						}
					],
					"3dcart_kp": [
						{
							"title": "Erzeugen Sie Ihre Klarna API-Zugangsdaten und speichern Sie diese",
							"step_instructions": [
								[
									{
										"text": "Erzeugen Sie neue API-Zugangsdaten und laden Sie die Datei auf Ihren Computer. Öffnen Sie die Datei und lassen Sie sie geöffnet, da Sie diese API-Zugangsdaten im nächsten Abschnitt benötigen werden."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Für weitere ausführliche Informationen über Ihre 3dcart-Integration, folgen Sie bitte dem"
									},
									{
										"link": "https://support.3dcart.com/Knowledgebase/Article/View/886/56/how-do-i-set-up-klarna",
										"text": "detaillierten Integrationsleitfaden."
									}
								]
							]
						},
						{
							"title": "Aktivieren Sie die Klarna Zahlungsmethode im Online Store Manager",
							"step_instructions": [
								[
									{
										"text": "Melden Sie sich in Ihrem"
									},
									{
										"link": "https://www.shift4shop.com/login-page.html",
										"text": "3dcart Online Store Manager an,"
									},
									{
										"text": "und gehen dann zu"
									},
									{
										"bold": "Einstellungen → Zahlung."
									}
								],
								[
									{
										"text": "Auf der Zahlung-Seite klicken Sie auf"
									},
									{
										"bold": "die Schaltfläche"
									},
									{
										"text": "Zahlungsmethoden auswählen."
									}
								],
								[
									{
										"text": "Dort wird Ihnen eine Liste vorinstallierter Module angezeigt. Suchen Sie das Klarna Modul und aktivieren Sie es mithilfe des Schiebereglers."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Für weitere ausführliche Informationen über Ihre 3dcart-Integration, folgen Sie bitte dem"
									},
									{
										"link": "https://support.3dcart.com/Knowledgebase/Article/View/886/56/how-do-i-set-up-klarna",
										"text": "detaillierten Integrationsleitfaden."
									}
								]
							]
						},
						{
							"title": "Geben Sie Ihre Klarna API-Zugangsdaten ein.",
							"step_instructions": [
								[
									{
										"text": "Nach der Aktivierung des Moduls geben Sie Ihren Klarna API-Benutzernamen (UID) in das entsprechende Feld ein. Sie finden ihn in der Datei Zugangsdaten, die Sie heruntergeladen haben."
									}
								],
								[
									{
										"text": "Als Nächstes klicken Sie auf den Link zum"
									},
									{
										"bold": "Ändern des Passworts"
									},
									{
										"text": "und geben Ihr Klarna API-Passwort in das Feld Passwort ein."
									}
								],
								[
									{
										"text": "Unter"
									},
									{
										"bold": "Landessprache"
									},
									{
										"text": "Wählen Sie die Landessprache, die für die Klarna Zahlungsoptionen im Store verwendet wird."
									}
								],
								[
									{
										"text": "Oberhalb des Benutzernamen-Feldes befindet sich eine Checkbox mit der Beschriftung"
									},
									{
										"bold": "„Testmodus“."
									},
									{
										"text": "Setzen Sie hier ein Häkchen, um den Testmodus zu aktivieren. Auf diese Weise können Sie Bestellungen aufgeben, ohne dass beim Testen des Moduls Kosten entstehen oder Zahlungen geleistet werden müssen."
									}
								],
								[
									{
										"text": "Nachdem Sie Ihre Einstellungen konfiguriert haben, klicken Sie oben rechts auf „Speichern“."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Für weitere ausführliche Informationen über Ihre 3dcart-Integration, folgen Sie bitte dem"
									},
									{
										"link": "https://support.3dcart.com/Knowledgebase/Article/View/886/56/how-do-i-set-up-klarna",
										"text": "detaillierten Integrationsleitfaden."
									}
								]
							]
						},
						{
							"title": "Machen Sie einen Testkauf",
							"step_instructions": [
								[
									{
										"text": "Um die korrekte Integration zu prüfen, machen Sie in Ihrem Store bitte einen Testkauf."
									}
								],
								[
									{
										"text": "Nach Absenden der Bestellung, gehen Sie"
									},
									{
										"link": "/orders/#realm=merchants",
										"text": "im Händler Portal auf Bestellungen,"
									},
									{
										"text": "suchen Ihre Bestellung und stornieren sie, damit Sie keine Zahlung an sich selbst leisten müssen."
									}
								],
								[
									{
										"text": "Sobald Ihre Integration erfolgreich abgeschlossen wurde, ändert der Banner am oberen Rand dieser Seite seine Farbe zu Grün und zeigt „Integration abgeschlossen“ an."
									}
								],
								[
									{
										"text": "Falls Sie im vorhergehenden Schritt den „Testmodus“ aktiviert hatten, gehen Sie bitte zurück, deaktivieren ihn und speichern die Änderungen, bevor Sie mit Ihrem Store online gehen, damit Ihre echten Bestellungen korrekt verarbeitet werden."
									}
								]
							],
							"alternate": [
								[
									{
										"text": "Für weitere ausführliche Informationen über Ihre 3dcart-Integration, folgen Sie bitte dem"
									},
									{
										"link": "https://support.3dcart.com/Knowledgebase/Article/View/886/56/how-do-i-set-up-klarna",
										"text": "detaillierten Integrationsleitfaden."
									}
								]
							]
						}
					],
					"bigcommerce_kp": [
						{
							"title": "Erzeugen Sie Ihre Klarna API-Zugangsdaten und speichern Sie diese",
							"step_instructions": [
								[
									{
										"text": "Erzeugen Sie neue API-Zugangsdaten und laden Sie die Datei auf Ihren Computer. Öffnen Sie die Datei und lassen Sie sie geöffnet, da Sie diese API-Zugangsdaten im nächsten Abschnitt benötigen werden."
									}
								]
							],
							"alternate": [
								{
									"text": "Für weitere ausführliche Informationen über Ihre BigCommerce-Integration, folgen Sie bitte dem"
								},
								{
									"link": "https://support.bigcommerce.com/s/article/Connecting-with-Klarna-Payments",
									"text": "detaillierten Integrationsleitfaden."
								}
							]
						},
						{
							"title": "Konfigurieren Sie Ihre BigCommerce-Einstellungen",
							"step_instructions": [
								[
									{
										"text": "Gehen Sie in BigCommerce auf"
									},
									{
										"link": "http://login.bigcommerce.com/deep-links/settings/payment",
										"text": "Store Setup › Zahlungen,"
									},
									{
										"text": "und erweitern Sie den Abschnitt Online Zahlungsmöglichkeiten. Klicken Sie dann auf"
									},
									{
										"bold": "„Set up“"
									},
									{
										"text": "neben Klarna Zahlungsmethode."
									}
								],
								[
									{
										"text": "So kommen Sie zur Klarna Zahlungsmethode-Registerkarte Einstellungen. Rufen Sie die Datei mit den API-Zugangsdaten auf, die Sie im vorhergehenden Schritt gespeichert haben und kopieren den Benutzernamen und das Passwort in die entsprechenden Felder."
									}
								],
								[
									{
										"text": "Wenn Sie fertig sind, speichern Sie die Änderungen."
									}
								]
							],
							"alternate": [
								{
									"text": "Für weitere ausführliche Informationen über Ihre BigCommerce-Integration, folgen Sie bitte dem"
								},
								{
									"link": "https://support.bigcommerce.com/s/article/Connecting-with-Klarna-Payments",
									"text": "detaillierten Integrationsleitfaden."
								}
							]
						},
						{
							"title": "Machen Sie einen Testkauf",
							"step_instructions": [
								[
									{
										"text": "Um die korrekte Integration zu prüfen, machen Sie in Ihrem Store bitte einen Testkauf."
									}
								],
								[
									{
										"text": "Nach Absenden der Bestellung, gehen Sie"
									},
									{
										"link": "/orders/#realm=merchants",
										"text": "im Händler Portal auf Bestellungen,"
									},
									{
										"text": "suchen Ihre Bestellung und stornieren sie, damit Sie keine Zahlung an sich selbst leisten müssen."
									}
								],
								[
									{
										"text": "Sobald Ihre Integration erfolgreich abgeschlossen wurde, ändert der Banner am oberen Rand dieser Seite seine Farbe zu Grün und zeigt „Integration abgeschlossen“ an."
									}
								]
							],
							"alternate": [
								{
									"text": "Für weitere ausführliche Informationen über Ihre BigCommerce-Integration, folgen Sie bitte dem"
								},
								{
									"link": "https://support.bigcommerce.com/s/article/Connecting-with-Klarna-Payments",
									"text": "detaillierten Integrationsleitfaden."
								}
							]
						}
					],
					"prestashop_kco": [
						{
							"title": "Aktivieren Sie das Klarna Checkout Modul",
							"step_instructions": [
								[
									{
										"text": "Stellen Sie zunächst sicher, dass Sie das offizielle Klarna Modul für Prestashop installiert haben. Falls es noch nicht installiert ist, besuchen Sie"
									},
									{
										"link": "https://addons.prestashop.com/en/express-checkout-process/90132-klarna-checkout.html?no_cache=1",
										"text": "diese Seite,"
									},
									{
										"text": "um es abzurufen."
									}
								],
								[
									{
										"text": "Ab dem 1. Januar 2023 stehen diese Plug-ins, die von Prestasworks A.B (SI) entwickelt wurden, leider nicht mehr kostenlos zur Verfügung. Wenn Sie an Klarna interessiert sind, können Sie das Plug-in kaufen oder auf die Klarna-eigenen Plug-ins warten, die voraussichtlich im zweiten Quartal 2023 erscheinen werden."
									}
								],
								[
									{
										"text": "Melden Sie sich auf Ihrer Prestashop-Adminseite an und gehen Sie zu"
									},
									{
										"bold": "Module → Module."
									}
								],
								[
									{
										"text": "Suchen Sie in der Suchleiste nach \"Klarna\", um das Klarna-Modul von Prestaworks AB zu finden. Klicken Sie auf"
									},
									{
										"bold": "Konfigurieren."
									}
								]
							]
						},
						{
							"title": "Konfigurieren Sie Ihre Einstellungen für das Klarna-Modul",
							"step_instructions": [
								[
									{
										"text": "Sie befinden sich jetzt auf der Seite für die Modul-Einstellungen. Ganz oben unter \"Allgemeine Einstellungen\" sehen Sie eine Schaltfläche namens"
									},
									{
										"bold": "KCO in diesem Shop aktivieren"
									},
									{
										"text": "(Klarna Checkout V3). Wählen Sie"
									},
									{
										"bold": "Ja."
									}
								],
								[
									{
										"text": "Klicken Sie auf"
									},
									{
										"bold": "Speichern"
									},
									{
										"text": "um Ihre Einstellungen zu speichern."
									}
								],
								[
									{
										"text": "Klicken Sie jetzt im linken Menü auf Ihr Vertriebsland und geben Sie Ihre Klarna API-Zugangsdaten ein unter"
									},
									{
										"bold": "Klarna API-Benutzername"
									},
									{
										"text": "und"
									},
									{
										"bold": "Klarna API-Passwort."
									}
								],
								[
									{
										"text": "Klicken Sie auf"
									},
									{
										"bold": "Speichern."
									}
								]
							]
						},
						{
							"title": "Letzte Schritte",
							"step_instructions": [
								[
									{
										"text": "Stellen Sie sicher, dass der Testmodus deaktiviert ist, wenn Sie mit der Seite Live gehen möchten. Dies ist möglich unter dem Reiter"
									},
									{
										"bold": "Allgemeine Einstellungen"
									},
									{
										"text": "Die Schaltfläche"
									},
									{
										"bold": "Testdrive"
									},
									{
										"text": "stellen Sie auf"
									},
									{
										"bold": "Nein."
									}
								],
								[
									{
										"text": "Unter"
									},
									{
										"bold": "Allgemeine Einstellungen"
									},
									{
										"text": "sollten Sie Ihre Einstellungen dafür einrichten, wie Sie Bestellungen durchführen möchten, wie Rechnungen versandt werden usw."
									}
								],
								[
									{
										"text": "Stellen Sie sicher, dass Klarna Checkout wie gewünscht angezeigt wird, indem Sie Ihrem Warenkorb einen Artikel hinzufügen und zum Checkout wechseln (geben Sie keine tatsächliche Bestellung auf)."
									}
								]
							]
						}
					],
					"prestashop_kp": [
						{
							"title": "Erzeugen Sie Ihre Klarna API-Zugangsdaten und speichern Sie diese",
							"step_instructions": [
								[
									{
										"text": "Erzeugen Sie neue API-Zugangsdaten und laden Sie die Datei auf Ihren Computer. Öffnen Sie die Datei und lassen Sie sie geöffnet, da Sie diese API-Zugangsdaten im nächsten Abschnitt benötigen werden."
									}
								]
							]
						},
						{
							"title": "Installieren und aktivieren Sie das Klarna Zahlungsmethode-Modul",
							"step_instructions": [
								[
									{
										"text": "Öffnen Sie die"
									},
									{
										"link": "https://addons.prestashop.com/en/payment-card-wallet/90140-klarna-payments.html?no_cache=1",
										"text": "Klarna Zahlungsmethode Prestashop Anleitungsseite"
									},
									{
										"text": "und folgen Sie diesen, um das Modul in Ihrem Prestashop-Konto zu installieren und zu konfigurieren."
									}
								]
							]
						},
						{
							"title": "Machen Sie einen Testkauf",
							"step_instructions": [
								[
									{
										"text": "Um die korrekte Integration zu prüfen, machen Sie in Ihrem Store bitte einen Testkauf."
									}
								],
								[
									{
										"text": "Nach Absenden der Bestellung, gehen Sie"
									},
									{
										"link": "/orders/#realm=merchants",
										"text": "im Händler Portal auf Bestellungen,"
									},
									{
										"text": "suchen Ihre Bestellung und stornieren sie, damit Sie keine Zahlung an sich selbst leisten müssen."
									}
								],
								[
									{
										"text": "Sobald Ihre Integration erfolgreich abgeschlossen wurde, ändert der Banner am oberen Rand dieser Seite seine Farbe zu Grün und zeigt „Integration abgeschlossen“ an."
									}
								]
							]
						}
					],
					"jumpseller": [
						{
							"title": "Generieren Sie Ihre Klarna API-Zugangsdaten.",
							"step_instructions": [
								[
									{
										"text": "Sie benötigen diese Zugangsdaten, um Klarna in Ihrem Store zu integrieren."
									}
								]
							]
						},
						{
							"title": "Klarna als neue Zahlungsmethode hinzufügen.",
							"step_instructions": [
								[
									{
										"text": "Gehen Sie im Jumpseller-Admin-Bereich zu Einstellungen > Zahlungen, finden Sie \"Klarna\" in der Checkbox-Liste und klicken Sie auf \"Methode hinzufügen\"."
									}
								]
							]
						},
						{
							"title": "Konfigurieren Sie unsere neue Zahlungsmethode.",
							"step_instructions": [
								[
									{
										"text": "Im Klarna Konfigurationsbereich (im Jumpseller Admin-Bereich zu Einstellungen > Zahlungen > Klarna gehen) (i) fügen Sie die im ersten Schritt generierten Klarna API-Zugangsdaten ein, (ii) wählen Sie die EMD-Pakete aus, die Sie mit Klarna teilen möchten/müssen, und (iii) wählen Sie aus, ob die Bestellungen automatisch erfasst werden müssen (standardmäßig nicht aktiviert)."
									}
								]
							]
						}
					],
					"lightspeed": [
						{
							"title": "Lightspeed eCom integrieren",
							"step_instructions": [
								[
									{
										"text": "Siehe hierzu den Integrationsleitfaden in"
									},
									{
										"link": "https://x.klarnacdn.net/mepo/onboarding/integration-guides/lightspeed/eng.pdf",
										"text": "Englisch"
									},
									{
										"text": "und in"
									},
									{
										"link": "https://x.klarnacdn.net/mepo/onboarding/integration-guides/lightspeed/nl.pdf",
										"text": "Niederländisch"
									},
									{
										"text": " finden."
									}
								]
							]
						}
					],
					"shoper": [
						{
							"title": "Shoper integrieren",
							"step_instructions": [
								[
									{
										"text": "Lesen Sie hierzu den Integrationsleitfaden auf"
									},
									{
										"link": "https://www.shoper.pl/help/artykul/klarna-platnosci-odroczone-konfiguracja",
										"text": "der Shoper Website"
									},
									{
										"text": " finden."
									}
								]
							]
						}
					],
					"timma": [
						{
							"title": "Timma integrieren",
							"step_instructions": [
								[
									{
										"text": "Lesen Sie hierzu den Integrationsleitfaden auf"
									},
									{
										"link": "https://help.timma.fi/sv/articles/4990994-betalning-via-klarna",
										"text": "die Timma Website"
									},
									{
										"text": " finden."
									}
								]
							]
						}
					],
					"smartetailing": [
						{
							"title": "Erzeugen Sie Ihre Klarna API-Zugangsdaten und speichern Sie diese",
							"step_instructions": [
								[
									{
										"text": "Erzeugen Sie neue API-Zugangsdaten und laden Sie die Datei auf Ihren Computer. Öffnen Sie die Datei und lassen Sie sie geöffnet, da Sie diese API-Zugangsdaten im nächsten Abschnitt benötigen werden."
									}
								]
							]
						},
						{
							"title": "Integration mit SmartEtailing",
							"step_instructions": [
								[
									{
										"text": "Folgen Sie bitte den Anleitungen auf"
									},
									{
										"link": "https://www.smartetailing.com/help/financing-with-klarna",
										"text": "der Website von SmartEtailing."
									}
								]
							]
						}
					],
					"workstand": [
						{
							"title": "Erzeugen Sie Ihre Klarna API-Zugangsdaten und speichern Sie diese",
							"step_instructions": [
								[
									{
										"text": "Erzeugen Sie neue API-Zugangsdaten und laden Sie die Datei auf Ihren Computer. Öffnen Sie die Datei und lassen Sie sie geöffnet, da Sie diese API-Zugangsdaten im nächsten Abschnitt benötigen werden."
									}
								]
							]
						},
						{
							"title": "Integration mit Workstand",
							"step_instructions": [
								[
									{
										"text": "Folgen Sie bitte den Anleitungen auf"
									},
									{
										"link": "https://www.workstand.com/help/financing-with-klarna",
										"text": "der Website von Workstand."
									}
								]
							]
						}
					],
					"jtl5_kco": [
						{
							"title": "Lesen Sie die Dokumentation zu unserem Plugin",
							"step_instructions": [
								[
									{
										"text": "Rufen Sie unsere"
									},
									{
										"link": "https://solution360.atlassian.net/wiki/spaces/S360DOKU/pages/1518829612/Klarna+Zahlungsarten+JTL-Shop+5",
										"text": "Dokumentationsseite auf"
									}
								]
							]
						},
						{
							"title": "Aktivieren Sie das Klarna Checkout Modul für JTL-Shop 5",
							"step_instructions": [
								[
									{
										"text": "Stellen Sie zunächst sicher, dass Sie die offizielle Klarna Erweiterng installiert haben. Falls diese noch nicht installiert ist,"
									},
									{
										"text": "besuchen Sie"
									},
									{
										"link": "https://www.jtl-software.de/extension-store/klarna-payments-mehr-als-reine-zahlungsarten-jtl-shop-5",
										"text": "diese Seite,"
									},
									{
										"text": "um es abzurufen."
									}
								]
							]
						}
					],
					"jtl5_kp": [
						{
							"title": "Lesen Sie die Dokumentation zu unserem Plugin",
							"step_instructions": [
								[
									{
										"text": "Rufen Sie unsere"
									},
									{
										"link": "https://solution360.atlassian.net/wiki/spaces/S360DOKU/pages/1518829612/Klarna+Zahlungsarten+JTL-Shop+5",
										"text": "Dokumentationsseite auf"
									}
								]
							]
						},
						{
							"title": "Aktivieren Sie das Klarna Payment Modul für JTL-Shop 5",
							"step_instructions": [
								[
									{
										"text": "Stellen Sie zunächst sicher, dass Sie die offizielle Klarna Erweiterng installiert haben. Falls diese noch nicht installiert ist,"
									},
									{
										"text": "besuchen Sie"
									},
									{
										"link": "https://www.jtl-software.de/extension-store/klarna-payments-mehr-als-reine-zahlungsarten-jtl-shop-5",
										"text": "diese Seite,"
									},
									{
										"text": "um es abzurufen."
									}
								]
							]
						}
					],
					"no_instructions": [
						{
							"title": "Das müssen Sie als nächstes tun.",
							"step_instructions": [
								[
									{
										"bold": "Generieren Sie Ihre Klarna API-Zugangsdaten."
									},
									{
										"text": "Sie benötigen diese Zugangsdaten, um Klarna in Ihrem Store zu integrieren."
									}
								],
								[
									{
										"bold": "Fügen Sie die Klarna API-Zugangsdaten Ihrem Backend-System hinzu, um Klarna zu aktivieren."
									},
									{
										"text": "In unserem"
									},
									{
										"link": "https://developers.klarna.com/",
										"text": "Entwicklerportal"
									},
									{
										"text": "finden Sie weitere Hilfe."
									}
								]
							]
						}
					]
				},
				"stakeholders": {
					"form": {
						"first_name": {
							"label": "Vorname",
							"error": "Bitte geben Sie einen Vornamen an."
						},
						"last_name": {
							"label": "Nachname",
							"error": "Bitte geben Sie einen Nachnamen an."
						},
						"dateOfBirth": {
							"label": {
								"default": "Geburtstag (TT/MM/JJJJ)",
								"without_format": "Geburtstag",
								"US": "Geburtstag (MM/TT/JJJJ)"
							},
							"error": "Bitte geben Sie ein gültiges Datum an.",
							"error_too_young": "Sie müssen mindestens 18 Jahre alt sein, um mit Klarna zu verkaufen"
						},
						"address": {
							"label": "Wohnadresse",
							"error": "Bitte geben Sie eine Adresse an."
						},
						"city": {
							"label": "Ort",
							"error": "Bitte geben Sie einen Ort an."
						},
						"country": {
							"label": "Land",
							"error": "Bitte wählen Sie ein Land"
						},
						"postal_code": {
							"label": {
								"default": "Postleitzahl",
								"US": "Postleitzahl"
							},
							"error": {
								"default": "Bitte geben Sie eine gültige Postleitzahl an",
								"US": "Bitte geben Sie eine gültige Postleitzahl an"
							}
						},
						"region": {
							"label": "Region (optional)",
							"label_summary": "Region"
						},
						"state": {
							"label": "Bundesland",
							"error": "Bitte geben Sie ein Bundesland ein"
						},
						"role_question": {
							"OWNER": "Ist diese Person ein Eigentümer?",
							"BENEFICIAL_OWNER": "Hat diese Person mehr als 25 % der Anteile oder Stimmrechte?",
							"ULTIMATE_BENEFICIAL_OWNER": "Diese Person besitzt oder kontrolliert mehr als 25 % der Anteile oder Stimmrechte"
						},
						"is_person_pep": [
							{
								"text": "Ist diese Person eine"
							},
							{
								"link": "https://cdn.klarna.com/1.0/shared/content/merchant-portal/products/amu/pep-20180626.html",
								"text": "politisch exponierte Person (PEP)"
							},
							{
								"text": ","
							},
							{
								"link": "https://cdn.klarna.com/1.0/shared/content/merchant-portal/products/amu/pep-20180626.html",
								"text": "direkter Familienangehörige/r"
							},
							{
								"text": "oder"
							},
							{
								"link": "https://cdn.klarna.com/1.0/shared/content/merchant-portal/products/amu/pep-20180626.html",
								"text": "bekannter Mitarbeiter"
							},
							{
								"text": "einer solchen Person?"
							}
						],
						"pep_relationship": {
							"label": "Beziehung",
							"error": "Bitte wählen Sie die Art der Beziehung diese Person hat zu einer PEP"
						},
						"pep_position": {
							"label": "PEP-Position",
							"error": "Bitte wählen Sie welche Position die PEP innehat"
						},
						"personal_id_question": "Diese Person hat keine persönliche Identifikationsnummer",
						"personal_id": {
							"US": {
								"label": "Sozialversicherungsnummer (letzte vier Ziffern)",
								"label_summary": "Sozialversicherungsnummer"
							},
							"US_FULL_SSN": {
								"label": "Sozialversicherungsnummer",
								"label_summary": "Sozialversicherungsnummer"
							},
							"CA": {
								"label": "Sozialversicherungsnummer (SVN) oder Passnummer",
								"label_summary": "Sozialversicherungsnummer (SVN) oder Passnummer"
							},
							"SE": {
								"label": "Persönliche Identifikationsnummer (PNO)",
								"label_summary": "Persönliche Identifikationsnummer (PNO)"
							},
							"FI": {
								"label": "Persönlicher Identifikationscode (HETU)",
								"label_summary": "Persönliche Identifikationsnummer (HETU)"
							},
							"NO": {
								"label": "Nationale identitätsnummer",
								"label_summary": "Nationale identitätsnummer"
							},
							"DK": {
								"label": "Persönliche Identifikationsnummer",
								"label_summary": "Persönliche Identifikationsnummer (CPR)"
							},
							"IT": {
								"label": "Steuernummer",
								"label_summary": "Steuernummer"
							},
							"ES": {
								"label": "Persönliche Identifikationsnummer",
								"label_summary": "Persönliche Identifikationsnummer (DNI)"
							},
							"PL": {
								"label": "Persönliche Identifikationsnummer",
								"label_summary": "Persönliche Identifikationsnummer (PESEL)"
							},
							"default": {
								"label": "Passnummer",
								"label_summary": "Passnummer"
							},
							"value": "Vertraulich"
						},
						"registration_number": {
							"label": "Unternehmens-Identifikationsnummer",
							"error": "Geben Sie die UIN in folgendem Format ein: XX-XXXXXXXXX"
						},
						"company_name": {
							"label": "Name des Shops",
							"error": "Bitte geben Sie eine gültige Firmenbezeichnung an"
						},
						"legal_company_name": {
							"label": "Juristische Bezeichnung des Unternehmens",
							"error_label": "Bitte geben Sie die juristische Bezeichnung des Unternehmens an"
						},
						"add_person": "Person hinzufügen",
						"remove": "Entfernen",
						"edit": "Bearbeiten"
					}
				},
				"steps_headers": {
					"merchant": {
						"merchant_id": "Merchant ID: {merchantId}"
					}
				},
				"goodie_bags": {
					"marketing_material": {
						"title": "Marketingmaterial",
						"text": "Jetzt sind Sie Teil der Klarna-Familie. Holen Sie sich ein Paket mit Materialien und mehr, mit denen Sie gleich loslegen können.",
						"link": "Download"
					},
					"invite_more_users": {
						"title": "Laden Sie weitere Nutzer ein",
						"text": "Laden Sie Ihre Mitarbeiter in das Händlerportal ein. Dort können Sie ihnen passende Berechtigungen zuweisen.",
						"link": "Benutzer einladen"
					}
				},
				"terms_and_conditions_confirmation": {
					"title": "Produkte und Preise",
					"subtitle": "{country}",
					"pricing": "Preise für {country}",
					"monthly_fee": "monatiliche Gebühr",
					"transaction_fee": "Transaktionsgebühr",
					"before_link": "Ich akzeptiere die Klarna",
					"link_text": "AGB,",
					"after_link_one_product": "für dieses Produkt",
					"after_link_more_than_one_product": "für diese Produkte",
					"product_not_available_in_your_country": "* Dieses Produkt ist nicht für Ihren Heimatmarkt verfügbar, funktioniert jedoch in anderen Ländern."
				},
				"product_description": {
					"product_attributes": {
						"installed": {
							"text": "Installiert"
						},
						"in_progress": {
							"text": "In Bearbeitung"
						}
					}
				},
				"phone_collection_block": {
					"title": "Haben Sie Probleme mit Ihrer Klarna Integration?",
					"description": "Hinterlassen Sie uns Ihre Telefonnummer. Einer unserer Mitarbeiter ruft Sie an, um Ihnen beim Hinzufügen von Klarna zu Ihrem e-commerce-Geschäft zu helfen.",
					"success_banner": "Vielen Dank. Unser Team meldet sich in Kürze bei Ihnen.",
					"submit": "Absenden",
					"fields": {
						"phone": {
							"label": "Telefonnummer",
							"tooltip": "Sie müssen die Landesvorwahl angeben, z. B. +1 541 754 3010",
							"errors": {
								"required": "Telefonnummer fehlt",
								"invalid": "Ungültige Telefonnummer"
							}
						}
					}
				}
			},
			"containers": {
				"applicant": {
					"title": {
						"unmanaged": "Wer ist in Ihrem Unternehmen unterschriftsberechtigt?",
						"managed": "Wer ist für das Unternehmen unterschriftsberechtigt?",
						"recollection": "Wer sind die gesetzlichen Vertreter Ihres Unternehmens?"
					},
					"subtitle": {
						"unmanaged": "Ihr Unternehmen steht kurz davor, eine Vereinbarung mit Klarna einzugehen. Wir müssen überprüfen, wer rechtlich unterschriftsberechtigt ist.",
						"managed": "Bitte geben Sie die Daten aller Unterschriftsberechtigten des Unternehmens an. Wir sind gesetzlich zur Überprügung der Zeichnungsberechtigung der Unterschriftsberechtigten zu verpflichtet. Wenn niemand aus der Liste einen Unterschriftsberechtigung hat, wählen Sie die Option \"Person hinzufügen\" und geben Sie die erforderlichen Informationen an.",
						"recollection": "Da Ihr Unternehmen eine aktive Geschäftsbeziehung mit Klarna hat, sind wir gesetzlich verpflichtet Informationen über Ihre gesetzlichen Vertreter zur Identitätsprüfung der Vertragspartner zu erheben."
					},
					"form_title": "Bitte geben Sie die Informationen ein",
					"robot_message": {
						"unmanaged": "Dies sind in der Regel der Vorstand oder Führungskräfte wie der CEO, CFO oder COO. Wenn Sie mindestens zwei Personen nennen, kann das die Vertragsfreigabe beschleunigen.",
						"managed": "Dies sind in der Regel der Vorstand oder Führungskräfte wie der CEO, CFO oder COO. Wenn Sie mindestens zwei Personen nennen, kann das die Vertragsfreigabe beschleunigen."
					},
					"error_tooltip": {
						"too_young": "Diese Person ist nicht unterschriftsberechtigt, da sie jünger als {minAge} Jahre ist."
					},
					"alert_all_too_young": "Alle Personen, die den Vertrag abschließen, müssen über {minAge} Jahre alt sein. Um fortzufahren, fügen Sie bitte einen Antragsteller hinzu, der über {minAge} Jahre alt ist.",
					"buttons": {
						"next": "Weiter",
						"back": "Zurück",
						"add_person": "+ Person hinzufügen"
					},
					"role": {
						"recollection": "Gesetzliche(r) Vertreter(in)"
					}
				},
				"application_summary": {
					"title": "Antrag überprüfen und einreichen.",
					"subtitle": {
						"unmanaged": "Prüfen Sie Ihre Angaben vor dem Einreichen.",
						"managed": "Bitte überprüfen Sie vor dem Einreichen die Details."
					},
					"stakeholders": {
						"title": "Geschäftsführung des Unternehmens",
						"subtitle": "Stakeholder {index}"
					},
					"businessDetailsCard": {
						"title": "Unternehmensangaben"
					},
					"businessDetailsCardFields": {
						"companyName": "Name des Unternehmens",
						"organizationEntityType": "Steuerklassifikation",
						"organizationRegistrationAuthority": "Registergericht",
						"goodsCategory": "Warenkategorie",
						"registrationId": {
							"default": "Handelsregisternummer",
							"AT": "Firmenbuchnummer",
							"AU": "ABN",
							"CA": "Geschäftsnummer",
							"ES": "Unternehmens-NIF/NIE/DNI",
							"GB": "Handelsregisternummer",
							"GR": "G.E.MI.-Nummer (Γ.Ε.ΜΗ.)",
							"NZ": "Geschäftsnummer",
							"US": "Arbeitgeber-Identifikationsnummer"
						},
						"registered": {
							"default": "Eingetragenes Unternehmen",
							"AU": "Unternehmen hat eine ABN"
						},
						"subjectToVat": {
							"default": "Unternehmen ist umsatzsteuerpflichtig",
							"AU": "Unternehmen unterliegt ABN"
						},
						"vatId": {
							"default": "USt-IdNr.",
							"AU": "ABN",
							"NZ": "GST-Nummer",
							"ES": "Unternehmens-NIF/NIE/DNI"
						},
						"storeName": "Name des Shops",
						"storeName_us": "Markenname/DBA",
						"website": "Website",
						"email": "Kundenservice Email",
						"entityType": "Entitätstyp"
					},
					"companyRegistrationAddressCard": {
						"title": "Registrierte Firmenadresse"
					},
					"companyAddressCard": {
						"title": "Firmenadresse"
					},
					"operatingAddressCard": {
						"title": "Operative Betriebsadresse"
					},
					"documentsCard": {
						"title": "Hochgeladene Dokumente"
					},
					"buttons": {
						"edit": "Bearbeiten",
						"back": "Zurück",
						"submit": "Abschicken"
					},
					"noTermsAccepted": "Bitte lesen und akzeptieren Sie die AGB",
					"noTermsAcceptedWithPricingAnnex": "Bitte lesen und akzeptieren Sie die Händlervereinbarung und die Bedingungen für die Preisgestaltung"
				},
				"artificial_ultimate_beneficial_owner": {
					"title": {
						"default": "Wer leitet das Unternehmen?"
					},
					"subtitle": {
						"default": [
							{
								"text": "Gemäß der EU-Anti-Geldwäsche-Richtlinie ("
							},
							{
								"text": "EU 2015/849",
								"link": "https://eur-lex.europa.eu/legal-content/EN/TXT/PDF/?uri=CELEX:32015L0849"
							},
							{
								"text": ") sind wir gesetzlich dazu verpflichtet, diese Informationen zu sammeln."
							}
						],
						"US": [
							{
								"text": "Als Finanzinstitut sind wir gesetzlich dazu verpflichtet, diese Informationen zu erfassen."
							}
						],
						"CA": [
							{
								"text": "Als Finanzinstitut sind wir gesetzlich dazu verpflichtet, diese Informationen zu erfassen."
							}
						],
						"AU": [
							{
								"text": "Als Finanzinstitut sind wir gesetzlich dazu verpflichtet, diese Informationen zu erfassen."
							}
						]
					},
					"infobox": {
						"default": "Bitte geben Sie die persönlichen Daten und Wohnadresse des CEO des Unternehmens an.",
						"US": "Bitte geben Sie Daten zur Person und die Wohnadresse des Mehrheitseigentümers oder eines hochrangigen Geschäftsleiters wie des CEO, CFO oder COO an.",
						"CA": "Bitte geben Sie Daten zur Person und die Wohnadresse des Mehrheitseigentümers oder eines hochrangigen Geschäftsleiters wie des CEO, CFO oder COO an."
					},
					"buttons": {
						"next": "Weiter",
						"back": "Zurück"
					}
				},
				"managed_artificial_ultimate_beneficial_owner": {
					"title": "Handelt es sich bei diesem Unternehmen um ein börsennotiertes Unternehmen oder ist es alleiniges Eigentum eines börsennotierten Unternehmens?",
					"title_stakeholder": "Wer leitet das Unternehmen?",
					"subtitle": "Als Finanzinstitut sind wir gesetzlich dazu verpflichtet, diese Informationen zu erfassen.",
					"subtitle_stakeholder": "Bitte geben Sie die persönlichen Daten und Wohnadresse des CEO des Unternehmens an.",
					"buttons": {
						"next": "Weiter",
						"back": "Zurück"
					}
				},
				"bank_account": {
					"title": {
						"default": "Bitte geben Sie Ihre Bankverbindung an."
					},
					"subtitle": {
						"US": "Alle Transaktionen von Klarna gehen an dieses Bankkonto.",
						"default": "Wir nutzen die Bankverbindung zur Überweisung der Zahlungen Ihrer Verkäufe. "
					},
					"no_more_bank_accounts": "Sie haben bereits Bankkonten für alle unterstützten Währungen angegeben. Gute Arbeit!",
					"robot_message_general": "Das Standard-Bankkonto muss bei einer Bank in dem Land sein, in dem Ihr Unternehmen registriert ist. Zudem benötigen Sie auch ein Bankkonto für jede der Währungen, die Sie akzeptieren möchten.",
					"robot_message": "IBAN steht für International Bank Account Number. Diese erhalten Sie von Ihrer Bank für ihr Konto. z.B.: DE89 3704 0044 0532 0130 00",
					"robot_message_account_number": {
						"AU": "Die Kontonummer wird von Ihrer Bank vergeben und hat zwischen 6 und 10 Ziffern. Beispiel: 12345678",
						"US": "Die Kontonummer wird von Ihrer Bank vergeben und hat zwischen 5 und 17 Ziffern. Beispiel: 12345678",
						"GB": "Die Kontonummer wird von Ihrer Bank bereitgestellt und verfügt über 8 Ziffern, z. B.. 12345677. Manche Banken in Großbritannien haben kürzere Kontonummern (mit 7 Ziffern). In diesem Fall werden vorne an Ihrer Nummer Nullen hinzugefügt, damit die Länge 8 Ziffern beträgt."
					},
					"robot_message_revolut": "Die von Ihnen angegebene IBAN kann keine inländischen GBP-Zahlungen erhalten. Sie müssen sich an Ihre Bank wenden und die Unterstützung von indländischen GBP-Überweisungen anfragen.",
					"robot_message_local": "Die IBAN, die Sie angegeben haben, ist eine lokale IBAN Ihrer Bank. Diese wird von uns nicht unterstützt. Bitte fordern Sie bei Ihrer Bank Ihre persönliche IBAN an. Oder verwenden Sie ein anderes Konto zum Verbinden mit Klarna.",
					"buttons": {
						"add_bank_account": "+ Bankkonto hinzufügen",
						"skip": "Überspringen (vorerst)",
						"remove": "Entfernen",
						"submit": "Abschicken",
						"next": "Weiter",
						"back": "Zurück"
					},
					"fields": {
						"currency_code": {
							"label": "Währung",
							"disable_reason": {
								"account_in_merchant_currency_required": "Die Standardwährung ist {currency} aufgrund des Landes, in dem Ihr Unternehmen registriert ist."
							},
							"errors": {
								"general": "Bitte wählen Sie eine Währung."
							}
						},
						"country_of_bankaccount": {
							"label": "Land",
							"errors": {
								"general": "Bitte wählen Sie ein Land"
							}
						},
						"iban_account_number": {
							"label": "Kontonummer (IBAN)",
							"errors": {
								"general": "Bitte geben Sie eine Kontonummer (IBAN) ein"
							}
						},
						"use_as_default_bank_account": {
							"label": "Verwenden Sie dieses Konto für nicht festgelegte Währungen",
							"tooltip": "Bestellungen in einer anderen Währung als der auf dieser Seite genannten werden auf dieses Konto ausbezahlt. Bei manchen Währungen kann Ihre Bank eine Zusatzgebühr verlangen."
						},
						"local_account_number": {
							"label": {
								"default": "Kontonummer",
								"MX": "CLABE-Nummer"
							},
							"errors": {
								"general": {
									"default": "Bitte geben Sie eine Kontonummer ein",
									"MX": "Bitte geben Sie eine gültige CLABE-Nummer ein"
								}
							}
						},
						"account_holder": {
							"label": "Name des Kontoinhabers",
							"errors": {
								"general": "Bitte geben Sie den Namen des Kontoinhabers ein (maximal 70 Zeichen)."
							}
						},
						"transit_number": {
							"label": "Transitnummer",
							"errors": {
								"general": "Bitte geben Sie eine gültige Transitnummer ein"
							}
						},
						"institution_number": {
							"label": "Institutsnummer",
							"errors": {
								"general": "Bitte geben Sie eine gültige Institutsnummer ein"
							}
						},
						"bic": {
							"label": {
								"AU": "BSB (Bankleitzahl in Australien)"
							},
							"errors": {
								"general": {
									"AU": "Bitte geben Sie eine gültige BSB (Bank State Branch) ein"
								}
							},
							"tooltip": {
								"AU": "Die BSB-Nummer ist eine sechsstellige Nummer, die durch einen Bindestrich getrennt wird. Bsp.: 123-456"
							}
						},
						"routing_number": {
							"label": {
								"default": "Bankleitzahl",
								"GB": "Sortiercode"
							},
							"errors": {
								"general": {
									"default": "Bitte geben Sie eine gültige Bankleitzahl ein",
									"GB": "Bitte geben Sie einen gültigen Sortiercode ein"
								}
							}
						}
					}
				},
				"control_over_management": {
					"title": {
						"default": "Wer leitet das Unternehmen?"
					},
					"subtitle": {
						"default": [
							{
								"text": "Gemäß der EU-Anti-Geldwäsche-Richtlinie ("
							},
							{
								"text": "EU 2015/849",
								"link": "https://eur-lex.europa.eu/legal-content/EN/TXT/PDF/?uri=CELEX:32015L0849"
							},
							{
								"text": ") sind wir gesetzlich dazu verpflichtet, diese Informationen zu sammeln."
							}
						],
						"GB": [
							{
								"text": "Wir sind gesetzlich zur Erfassung dieser Informationen verpflichtet. Bitte sorgen Sie dafür, dass Ihre Daten in Companies House auf dem neuesten Stand sind."
							}
						]
					},
					"infobox": "Bitte geben Sie Daten zur Person und die Wohnadresse der Personen ein, die die Kontrolle über das Management Ihrer Firma ausüben, wie der Geschäftsführer oder Vorstandsmitglieder.",
					"buttons": {
						"next": "Weiter",
						"back": "Zurück",
						"add_person": "+ Person hinzufügen"
					},
					"messages": {
						"lookup": "Leiten diese Personen Ihr Unternehmen? Bitte überprüfen Sie die Angaben und bestätigen Sie diese falls sie korrekt sind."
					}
				},
				"de_registration_information": {
					"title": {
						"unmanaged": "Ist Ihr Unternehmen eine eingetragene Firma?",
						"managed": "Ist dieses Unternehmen eine eingetragene Gesellschaft?"
					},
					"subtitle": {
						"unmanaged": "Wir benötigen die Handelsregisternummer Ihres Unternehmens, um Ihre Unternehmensdaten zu überprüfen.",
						"managed": "Wir benötigen die Handelsregisternummer, um die Geschäftsdaten des Unternehmens zu überprüfen."
					},
					"question": {
						"title": {
							"unmanaged": "Bitte geben Sie Ihre Handelsregisternummer und das Registergericht an",
							"managed": "Geben Sie die Handelsregisternummer und das Registergericht ein"
						}
					},
					"fields": {
						"registration_number": {
							"label": "Registernummer"
						},
						"registration_court": {
							"label": "Registergericht",
							"errors": {
								"general": {
									"unmanaged": "Bitte wählen Sie Ihr Registergericht.",
									"managed": "Wählen Sie das Registergericht"
								}
							}
						}
					},
					"buttons": {
						"next": "Weiter",
						"back": "Zurück"
					}
				},
				"documents": {
					"title": "Bitte laden Sie hier Ihre Dokumente hoch",
					"subtitle": "Wir benötigen zusätzliche Nachweise zur Prüfung Ihrer Identität. Uploads nur im Format <strong>JPG</strong>, <strong>PNG</strong> oder <strong>PDF</strong> (max. Dateigröße 10 MB).",
					"subheadline": {
						"default": "Übermitteln Sie uns Dokumente zur Verifizierung Ihrer Identität. Bitte beachten Sie dabei, dass wir nur <strong>JPG-, PNG- oder PDF</strong>-Dateien akzeptieren können (maximale Dateigröße 10 MB).",
						"US": "Da Klarna eine in Schweden ansässige Bank ist und der schwedischen Finanzdienstleistungsaufsichtsbehörde unterliegt, hat Klarna die EU Richtlinie EU 2015/849 zu erfüllen. Klarna ist verpflichtet, Informationen über die Personen einzuholen, die das Unternehmen leiten, damit Sie Klarnas Dienstleistungen nutzen können. Bitte reichen Sie die folgenden Dokumente als Identitätsnachweis ein. Uploads nur im Format JPG, PNG oder PDF (max. Dateigröße 10 MB).",
						"IT": "Da Klarna eine in Schweden ansässige Bank ist und der schwedischen Finanzdienstleistungsaufsichtsbehörde unterliegt, hat Klarna die EU Richtlinie EU 2015/849 zu erfüllen. Klarna ist verpflichtet, Informationen über die Personen einzuholen, die das Unternehmen leiten, damit Sie Klarnas Dienstleistungen nutzen können. Bitte beachten Sie, dass Ihr Unternehmen bei der Handelskammer registriert sein muss, um mit dem Antrag fortzufahren. Uploads nur im Format JPG, PNG oder PDF (max. Dateigröße 10 MB)"
					},
					"header_title": "Dokumente",
					"stakeholder": "Stakeholder",
					"business_documents": "Geschäftliche Unterlagen",
					"browse_files": "Dateien durchsuchen",
					"optional": "(optional)",
					"upload_area": {
						"title": {
							"before_link": "Dateien hier ablegen oder",
							"link_text": "Dateien auswählen"
						},
						"description": "{acceptedFileFormats} - max. {maxFileSizeMB} MB/Datei"
					},
					"description": {
						"APPROVAL": "<strong>Genehmigung</strong> hochladen",
						"CONTRACT": "<strong>Vertrag</strong> hochladen",
						"CORRECTION_NOTE": "<strong>Korrekturvermerk</strong> hochladen",
						"COUNTERSIGNED_CONTRACT": "<strong>Gegengezeichneten Vertrag</strong> hochladen",
						"ID_DOCUMENT": "<strong>Personalausweis</strong> oder <strong>Reisepass</strong> hochladen",
						"LICENSE": "<strong>Zulassung</strong> hochladen",
						"PROOF_OF_ADDRESS": "<strong>Adressnachweis</strong> hochladen",
						"SPECIAL_AGREEMENT": "<strong>Sondervereinbarung</strong> hochladen",
						"SUPPORTING_DOCUMENT": "<strong>Beleg</strong> hochladen",
						"TAX_OFFICE_REGISTRATION": "<strong>Steuerliche Anmeldung</strong> hochladen"
					},
					"explanation": {
						"APPROVAL": {
							"title": {
								"default": "Genehmigung"
							},
							"subtitle": {
								"default": null
							}
						},
						"CONTRACT": {
							"title": {
								"default": "Vertrag"
							},
							"subtitle": {
								"default": null
							}
						},
						"CORRECTION_NOTE": {
							"title": {
								"default": "Korrekturvermerk"
							},
							"subtitle": {
								"default": null
							}
						},
						"COUNTERSIGNED_CONTRACT": {
							"title": {
								"default": "Gegengezeichneter Vertrag"
							},
							"subtitle": {
								"default": null
							}
						},
						"ID_DOCUMENT": {
							"title": {
								"default": "Identitätsnachweis der/des Zeichnungsberechtigten und wirtschaftlich Berechtigten",
								"IT": "Personalausweis"
							},
							"subtitle": {
								"default": "Bitte laden Sie beide Seiten Ihres Personalausweises hoch.",
								"AT": "Bitte legen Sie uns die Vorder- und Rückseite Ihres Personalausweises vor. Wenn Ihre Adresse nicht auf Ihrem Ausweis steht, benötigen wir zusätzliche Unterlagen.",
								"AU": "Damit Ihr Antrag schneller bearbeitet werden kann, reichen Sie bitte eine Kopie eines gültigen Lichtbildausweises ein, z. B. ein Reisepass oder ein australischer Führerschein. Dies ist für folgende Personen, die in Verbindung zum Unternehmen stehen, nötig: Einzelunternehmer/Partnerschaft – der/die Besitzer*innen. Unternehmen – der gesetzliche Vertreter, alle Geschäftsführer und alle Aktionäre, die mehr als 25 % der Anteile halten.",
								"BE": "Bitte reichen Sie beide Seiten des Ausweises ein und achten Sie darauf, dass die Bildqualität ausreichend ist und alle Informationen deutlich lesbar sind.",
								"DE": "Bitte legen Sie uns die Vorder- und Rückseite Ihres Personalausweises vor. Wenn Ihre Adresse nicht auf Ihrem Ausweis steht, benötigen wir zusätzliche Unterlagen.",
								"FR": "Bitte reichen Sie beide Seiten des Ausweises ein und achten Sie darauf, dass die Bildqualität ausreichend ist und alle Informationen deutlich lesbar sind.",
								"GB": "Bitte weisen Sie sich aus, zeigen Sie bei Personalausweisen beide Seiten.",
								"IT": "Die Vorder- und Rückseite eines gültigen Ausweises von jeder der Personen, die im Antrag genannt sind. Führerschein, Reisepass, Sozialversicherungskarte/Nummer kann nicht akzeptiert werden.",
								"NL": "Bitte reichen Sie beide Seiten des Ausweises ein und achten Sie darauf, dass die Bildqualität ausreichend ist und alle Informationen deutlich lesbar sind.",
								"US": "Führerschein oder Reisepass – bitte reichen Sie eine Kopie beider Seiten des Ausweises ein."
							}
						},
						"LICENSE": {
							"title": {
								"default": "Zulassung"
							},
							"subtitle": {
								"default": null
							}
						},
						"PROOF_OF_ADDRESS": {
							"title": {
								"default": "Adressnachweis der/des Zeichnungsberechtigten und wirtschaftlich Berechtigten",
								"BE": "Adressnachweis der/des Zeichnungsberechtigten",
								"CZ": "Adressnachweis der/des Zeichnungsberechtigten",
								"ES": "Adressnachweis der/des Zeichnungsberechtigten",
								"FI": "Adressnachweis der/des Zeichnungsberechtigten",
								"FR": "Adressnachweis der/des Zeichnungsberechtigten",
								"GR": "Adressnachweis der/des Zeichnungsberechtigten",
								"IT": "Adressnachweis der/des Zeichnungsberechtigten",
								"NL": "Adressnachweis der/des Zeichnungsberechtigten",
								"PL": "Adressnachweis der/des Zeichnungsberechtigten",
								"PT": "Adressnachweis der/des Zeichnungsberechtigten"
							},
							"subtitle": {
								"default": "Wir akzeptieren die folgenden Dokumente (nicht älter als 3 Monate) als Nachweis der Wohnadresse: Strom-, Wasser-, Gas-, Wi-Fi-Rechnungen, Steuererklärung oder den Mietvertrag auf Ihre Privatadresse. Sollten Sie keines der Dokumente haben, laden Sie bitte einen anderen Wohnsitznachweis hoch und fügen Sie einen Vermerk mit dem Grund hinzu.",
								"AU": "Für eine schnellere Bearbeitung Ihres Antrags reichen Sie bitte eines der folgenden Dokumente aus den letzten 90 Tagen ein, um die Wohnadresse zu belegen: Rechnungen von Versorgungsunternehmen, Internetrechnungen, Steuererklärungen oder Mietverträge. *Wenn Sie einen Reisepass als Ausweis einreichen oder wenn Ihre aktuelle Adresse nicht mit der Adresse auf Ihrem Ausweis übereinstimmt, ist dieser Schritt verpflichtend.",
								"BE": "Wir akzeptieren die folgenden Dokumente als Nachweis der Wohnadresse, wenn sie nicht älter als 3 Monate sind: Strom-, Wasser-, Gasrechnung, Steuererklärung oder Mietvertrag. Sollten Sie keines der Dokumente haben, laden Sie bitte einen anderen Nachweis des Wohnsitzes hoch und fügen Sie eine Erklärung dafür hinzu.",
								"FR": "Wir akzeptieren die folgenden Dokumente als Nachweis der Wohnadresse, wenn sie nicht älter als 3 Monate sind: Strom-, Wasser-, Gasrechnung, Steuererklärung oder Mietvertrag. Sollten Sie keines der Dokumente haben, laden Sie bitte einen anderen Nachweis des Wohnsitzes hoch und fügen Sie eine Erklärung dafür hinzu.",
								"NL": "Wir akzeptieren die folgenden Dokumente als Nachweis der Wohnadresse, wenn sie nicht älter als 3 Monate sind: Strom-, Wasser-, Gasrechnung, Steuererklärung oder Mietvertrag. Sollten Sie keines der Dokumente haben, laden Sie bitte einen anderen Nachweis des Wohnsitzes hoch und fügen Sie eine Erklärung dafür hinzu.",
								"US": "Wir akzeptieren Rechnungen von Versorgungsunternehmen (Gas, Wasser, Internet, Telefon usw.), Mietverträge oder Immobilienkreditverträge mit Adressnachweis. Das Datum darf nicht älter als 90 Tage ab dem Datum der Antragstellung sein.",
								"IT": "Wenn auf Ihrem Ausweis eine andere Adresse als Ihre aktuelle Wohnanschrift vermerkt ist, benötigen wir ein zusätzliches Dokument, um Ihren aktuellen Wohnsitz zu verifizieren. Wir akzeptieren die folgenden Dokumente, die nicht älter als 3 Monate sind, als Nachweis der Wohnadresse der im Antrag aufgeführten Personen:"
							},
							"list": {
								"IT": [
									{
										"text": "Wohnsitzbescheinigung, die online (über SPID) oder von der Gemeinde Ihres Wohnsitzes ausgestellt wird"
									},
									{
										"text": "Strom-/Wasser-/Gas-/Internetanschluss-Rechnungen"
									},
									{
										"text": "Mietvertrag"
									}
								]
							}
						},
						"SPECIAL_AGREEMENT": {
							"title": {
								"default": "Sondervereinbarung"
							},
							"subtitle": {
								"default": null
							}
						},
						"SUPPORTING_DOCUMENT": {
							"title": {
								"default": "Beleg",
								"GB": "Selfie"
							},
							"subtitle": {
								"default": null,
								"AU": "Wenn Sie hochwertige Markenobjekte verkaufen, reichen Sie hier bitte 2–3 Lieferantenrechnungen für diese Produkte ein. Bitte achten Sie darauf, dass die Rechnung die gekauften Produkte, den Namen des Lieferanten, den Namen des Empfängers und die Lieferadresse enthält.",
								"GB": "Bitte reichen Sie ein Foto von sich ein, auf dem Sie Ihren Personalausweis hochhalten."
							}
						},
						"TAX_OFFICE_REGISTRATION": {
							"title": {
								"default": "Umsatzsteueridentifikationnummer",
								"AT": "Umsatzsteueridentifikationnummer",
								"AU": "Treuhandurkunde",
								"BE": "Umsatzsteuer-Identifikationsnummer für grenzüberschreitende Transaktionen aktiviert (MIAS).",
								"DE": "Umsatzsteueridentifikationnummer",
								"FR": "Umsatzsteuer-Identifikationsnummer für grenzüberschreitende Transaktionen aktiviert (MIAS).",
								"IT": "Umsatzsteuer-Identifikationsnummer für grenzüberschreitende Transaktionen aktiviert (MIAS).",
								"NL": "Umsatzsteuer-Identifikationsnummer für grenzüberschreitende Transaktionen aktiviert (MIAS).",
								"NO": "Steuerliche Anmeldung",
								"US": "UIN Brief"
							},
							"subtitle": {
								"default": null,
								"AT": "Wir akzeptieren die folgenden Dokumente als Geschäftsdokumente: Firmenbuchauszug / Gisa-Auszug",
								"AU": "Wenn Ihre ABN mit einer Treuhandgesellschaft verbunden ist, reichen Sie bitte eine Kopie des Treuhanddokuments ein, einschließlich des Treuhandplans. Bitte beachten Sie, dass dieser Schritt für Treuhandgesellschaften obligatorisch ist.",
								"BE": "Vergewissern Sie sich, dass Ihre Umsatzsteuer-Identifikationsnummer für grenzüberschreitende Transaktionen freigeschaltet ist, auch wenn Sie nur in Ihrem Heimatland handeln, da Klarna ein ausländisches Unternehmen ist. https://ec.europa.eu/taxation_customs/vies/#/vat-validation . Sie können sich an Ihr örtliches Finanzamt wenden, um eine kostenlose VIES-Aktivierung Ihrer Umsatzsteuer-Identifikationsnummer zu beantragen.",
								"CZ": "Folgende Dokumente werden als Geschäftsnachweis akzeptiert: Bescheinigung über die Eintragung im öffentlichen Register oder Auszug aus dem Handelsregister des Einzelunternehmens.",
								"DE": "Wir akzeptieren die folgenden Dokumente als Geschäftsdokumente: Handelsreigsterauszug / Gewerbeanmeldung",
								"ES": "Folgende Dokumente werden als Geschäftsnachweis akzeptiert: Gewerbeschein für Einzelunternehmen für eingetragene Unternehmen; für Einzelunternehmer – Nachweis der Anmeldung beim Finanzamt / Formular 036 / Formular 037",
								"FI": "Folgende Dokumente werden als Geschäftsnachweis akzeptiert: Gewerbeschein für Einzelunternehmen – Nachweis der Anmeldung beim Finanzamt / Formular 036 / Formular 037",
								"FR": "Vergewissern Sie sich, dass Ihre Umsatzsteuer-Identifikationsnummer für grenzüberschreitende Transaktionen freigeschaltet ist, auch wenn Sie nur in Ihrem Heimatland handeln, da Klarna ein ausländisches Unternehmen ist. https://ec.europa.eu/taxation_customs/vies/#/vat-validation . Sie können sich an Ihr örtliches Finanzamt wenden, um eine kostenlose VIES-Aktivierung Ihrer Umsatzsteuer-Identifikationsnummer zu beantragen.",
								"GR": "Folgende Dokumente werden als Geschäftsnachweis akzeptiert: Anmeldung beim Finanzamt / Unternehmensgründung / Unternehmensregister-Dokument, ausgestellt von der zuständigen Dienststelle GEMI (Zentralverband der Kammern)",
								"IT": "Sie können sich an die Steuerbehörde (Agenzia delle Entrate) wenden, um eine kostenlose VIES-Aktivierung Ihrer Umsatzsteuer-Identifikationsnummer zu beantragen. Dies ist auch dann erforderlich, wenn Sie nur in Italien handeln, da Klarna ein ausländisches Unternehmen ist.",
								"NL": "Vergewissern Sie sich, dass Ihre Umsatzsteuer-Identifikationsnummer für grenzüberschreitende Transaktionen freigeschaltet ist, auch wenn Sie nur in Ihrem Heimatland handeln, da Klarna ein ausländisches Unternehmen ist. https://ec.europa.eu/taxation_customs/vies/#/vat-validation . Sie können sich an Ihr örtliches Finanzamt wenden, um eine kostenlose VIES-Aktivierung Ihrer Umsatzsteuer-Identifikationsnummer zu beantragen.",
								"NO": "Folgende Dokumente werden als Geschäftsnachweis akzeptiert: Unternehmensdokumente",
								"PL": "Folgende Dokumente werden als Geschäftsnachweis akzeptiert: Bescheinigung über die Eintragung in das Unternehmensregister CEIDG, Auszug aus dem nationalen Gerichtsregister (KRS)",
								"PT": "Folgende Dokumente werden als Geschäftsnachweis akzeptiert:  Certidão Permanente (zwingend erforderlich), Gründungsurkunde. Für Einzelunternehmer, Anmeldung der Selbstständigkeit (Declaração de Início de Atividade).",
								"US": "Dies ist der Brief, den Sie von der IRS erhalten haben, in dem Ihnen eine EIN zugewiesen wird (IRS CP575 EIN Letter). Wenn es sich bei Ihrem Unternehmen um ein Einzelunternehmen handelt und Sie es mit Ihrer SSN anmelden, reichen Sie bitte eine Kopie Ihrer SSN-Karte ein"
							},
							"link": {
								"BE": "https://ec.europa.eu/taxation_customs/vies/#/vat-validation",
								"FR": "https://ec.europa.eu/taxation_customs/vies/#/vat-validation",
								"NL": "https://ec.europa.eu/taxation_customs/vies/#/vat-validation",
								"GR": "https://www.businessregistry.gr/publicity/index"
							}
						},
						"CERTIFIED_ID": {
							"title": {
								"default": "Beglaubigtes Ausweisdokument"
							},
							"subtitle": {
								"default": "Folgende Dokumente werden akzeptiert: Ausweis, Reisepass, Führerschein. Die Dokumente müssen die folgenden Kriterien erfüllen:"
							},
							"list": [
								{
									"text": "Beglaubigt durch einen befugten Beglaubigungsbeamten (z. B. einen Notar, Eidesbevollmächtigten, Anwalt, Rechtsanwalt und/oder Wirtschaftsprüfer)."
								},
								{
									"text": "Unterschrieben und gestempelt. Der Stempel muss sichtbare und überprüfbare Angaben zum Beglaubiger enthalten, wie z. B. den vollständigen Namen, die Adresse und ggf. die Registrierungsnummer."
								},
								{
									"text": "Datiert - Beglaubigungsdatum nicht älter als 6 Monate."
								},
								{
									"text": "Beglaubigt als originalgetreue Kopie eines Originals mit dem eindeutigen Vermerk, dass das Originaldokument gesehen wurde."
								}
							]
						}
					},
					"modal": {
						"title": "Warum benötigen wir Ihre Dokumente?",
						"close": "Schließen",
						"content": [
							{
								"title": "Beschreibung des Prozesses",
								"text": "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat."
							},
							{
								"title": "Dateivorgaben",
								"text": "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat."
							},
							{
								"title": "Wie scanne ich Dokumente?",
								"text": "Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat."
							}
						]
					},
					"errors": {
						"general": "Hochladen fehlgeschlagen",
						"too_large_file": "Die Datei ist zu groß <strong>(max. {maxFileSizeMB} MB)</strong>",
						"max_num_files_exceeded": "Sie dürfen nur {number} Dateien hochladen.",
						"invalid_file_format": "Ungültiges Dateiformat. Zulässige Dateitypen sind: {acceptedFileFormats}",
						"duplicate_file_name": "Doppelt vorhandener Dateiname. Alle hochgeladenen Dateien müssen einen einmalig vergebenen Namen haben.",
						"try_again": "Versuchen Sie es erneut oder <u>wählen Sie eine andere Datei</u>"
					},
					"buttons": {
						"modal": "Warum benötigen wir Ihre Dokumente?",
						"next": "Weiter",
						"back": "Zurück",
						"submit": "Dokumente senden"
					}
				},
				"document_upload_success": {
					"title": "Hochladen beendet.",
					"message": "Vielen Dank! Ihre Dokumente wurde erfolgreich hochgeladen."
				},
				"forced_registration_information": {
					"title": {
						"unmanaged": {
							"default": "Bitte geben Sie Ihre Handelsregisternummer an.",
							"AT": "Bitte geben Sie Ihre Handelsregisternummer an.",
							"CA": "Bitte geben Sie Ihre Federal Business Number ein.",
							"GR": "Können Sie bitte Ihre G.E.MI.-Nummer (Γ.Ε.ΜΗ.) eingeben?",
							"NZ": "Bitte geben Sie Ihre Geschäftsnummer an."
						},
						"managed": {
							"default": "Würden Sie bitte die Handelsregisternummer eingeben?",
							"AT": "Würden Sie bitte die Handelsregisternummer eingeben?",
							"CA": "Bitte geben Sie Ihre Federal Business Number ein.",
							"GR": "Würden Sie bitte die G.E.MI.-Nummer (Γ.Ε.ΜΗ.) Ihres Unternehmens eingeben?",
							"NZ": "Würden Sie bitte die Geschäftsnummer eingeben?"
						}
					},
					"subtitle": {
						"unmanaged": {
							"default": "Wir benötigen die Handelsregisternummer Ihres Unternehmens, um Ihre Unternehmensdaten zu überprüfen.",
							"AT": "Wir benötigen die Handelsregisternummer Ihres Unternehmens, um Ihre Unternehmensdaten zu überprüfen.",
							"CA": "Wir benötigen Ihre Federal Business Number, die Ihnen die kanadische Steuerbehörde CRA zugeteilt hat, um Ihre Unternehmensdaten zu prüfen.",
							"GR": "Wir benötigen Ihre G.E.MI.-Nummer, um die Geschäftsdaten zu überprüfen.",
							"NZ": "Wir benötigen die Geschäftsnummer Ihres Unternehmens, um Ihre Unternehmensdaten zu überprüfen."
						},
						"managed": {
							"default": "Wir benötigen die Handelsregisternummer, um die Geschäftsdaten des Unternehmens zu überprüfen.",
							"AT": "Wir benötigen die Handelsregisternummer, um die Geschäftsdaten des Unternehmens zu überprüfen.",
							"CA": "Wir benötigen Ihre Federal Business Number, die Ihnen die kanadische Steuerbehörde CRA zugeteilt hat, um Ihre Unternehmensdaten zu prüfen.",
							"GR": "Wir benötigen die G.E.MI.-Nummer, um die Geschäftsdaten zu überprüfen.",
							"NZ": "Wir benötigen die Geschäftsnummer, um die Geschäftsdaten zu überprüfen."
						}
					},
					"infobox": {
						"unmanaged": {
							"CA": "Bitte beachten Sie, dass Klarna Einzelunternehmern in Kanada derzeit keine Zahlungsdienstleistungen anbietet. Wenn Sie jetzt fortfahren, müssen wir Ihren Antrag leider ablehnen."
						}
					},
					"fields": {
						"registration_number": {
							"label": {
								"default": "Registernummer",
								"AT": "Registernummer",
								"CA": "Geschäftsnummer",
								"GR": "G.E.MI.-Nummer (Γ.Ε.ΜΗ.)",
								"NZ": "Geschäftsnummer"
							}
						}
					},
					"buttons": {
						"next": "Weiter",
						"back": "Zurück"
					}
				},
				"tax_identification_number": {
					"title": {
						"unmanaged": "Wie lautet Ihre Steuerklassifikation?",
						"managed": "Bitte geben Sie die Steuerklassifikation des Unternehmens an."
					},
					"subtitle": {
						"unmanaged": "Je nach Rechtsform Ihres Unternehmens benötigen wir verschiedene Angaben von Ihnen.",
						"managed": "Je nach Rechtsform Ihres Unternehmens benötigen wir verschiedene Angaben von Ihnen."
					},
					"info": {
						"unmanaged": "Sie finden Ihre eigene EIN (Arbeitgeber-Identifikationsnummer) auf Steuerbescheiden, Bankauszügen, Gehaltsabrechnungen, auf Zulassungen und Genehmigungen",
						"managed": "Sie finden die Unternehmens-EIN (Arbeitgeber-Identifikatiosnnummer) auf Steuerbescheiden, Bankauszügen, Gehaltsabrechnungen, auf Zulassungen und Genehmigungen"
					},
					"fields": {
						"registration_number": {
							"label": "Arbeitgeber-Identifikationsnummer",
							"errors": {
								"general": "Bitte geben Sie eine gültige Arbeitgeber-Identifikationsnummer ein",
								"invalid": "Die Arbeitgeber-Identifikationsnummer besteht üblicherweise aus 9 Ziffern. Die ersten zwei Ziffern sind durch einen Bindestrich von den restlichen getrennt, z. B.: 12-3456789 "
							}
						},
						"organization_entity": {
							"label": {
								"unmanaged": "Staatliche Steuerklassifikation",
								"managed": "Unternehmensart"
							},
							"errors": {
								"is_one_of": "Bitte wählen Sie eine der aufgelisteten Unternehmensarten aus"
							}
						}
					},
					"buttons": {
						"next": "Weiter",
						"back": "Zurück"
					}
				},
				"forced_vat_registration": {
					"title": {
						"unmanaged": {
							"default": "Bitte geben Sie Ihre USt-IdNr. an.",
							"AU": "Bitte geben Sie Ihre ABN ein.",
							"ES": "Wie lautet Ihre Steueridentifikationsnummer?",
							"NZ": "Bitte geben Sie Ihre GST-Nummer an."
						},
						"managed": {
							"default": "Würden Sie bitte die Umsatzsteuer-Identifikationsnummer eingeben?",
							"AU": "Würden Sie bitte die ABN eingeben?",
							"ES": "Wie lautet Ihre Steueridentifikationsnummer?",
							"NZ": "Bitte geben Sie die GST-Nummer an."
						}
					},
					"subtitle": {
						"unmanaged": {
							"default": "Anhand Ihrer USt-IdNr. können wir Ihre Firmendaten leichter überprüfen",
							"AU": "Anhand Ihrer ABN können wir Ihre Unternehmensdaten leichter überprüfen",
							"NZ": "Anhand Ihrer GST-Nummer können wir Ihre Unternehmensdaten leichter überprüfen.",
							"ES": "Anhand Ihrer NIF-, NIE- oder DNI-Nummer können wir die Daten Ihres Unternehmens leichter überprüfen"
						},
						"managed": {
							"default": "Anhand der Umsatzsteuer-Identifikationsnummer überprüfen wir die Daten des Unternehmens.",
							"AU": "Anhand der ABN überprüfen wir die Daten des Unternehmens.",
							"NZ": "Anhand der GST-Nummer überprüfen wir die Daten des Unternehmens.",
							"ES": "Wir überprüfen die Daten des Unternehmens anhand der NIF-, NIE- oder DNI-Nummer."
						}
					},
					"fields": {
						"vat_number": {
							"label": {
								"default": "USt-IdNr.",
								"AU": "ABN",
								"NZ": "GST-Nummer",
								"ES": "NIF/NIE/DNI"
							}
						}
					},
					"buttons": {
						"next": "Weiter",
						"back": "Zurück"
					}
				},
				"legal_entity_type": {
					"title": {
						"unmanaged": "Was für ein Unternehmen haben Sie?",
						"managed": "Um welche Art von Geschäft handelt es sich bei diesem Unternehmen?"
					},
					"subtitle": {
						"unmanaged": "Wir sind verpflichtet, je nach Art Ihres Unternehmens einige spezielle Fragen zu stellen.",
						"managed": "Je nach Geschäftsart müssen wir einige spezifische Fragen stellen."
					},
					"fields": {
						"legal_entity_type": {
							"label": "Art des Unternehmens",
							"errors": {
								"is_one_of": "Bitte wählen Sie eine der aufgelisteten Unternehmensarten aus"
							}
						}
					},
					"buttons": {
						"next": "Weiter",
						"back": "Zurück"
					}
				},
				"optional_registration_information": {
					"title": {
						"unmanaged": {
							"default": "Ist Ihr Unternehmen eine eingetragene Firma?",
							"AU": "Hat Ihr Unternehmen eine ABN?",
							"ES": "Ist Ihr Gewerbe im Registro Mercantil angemeldet?"
						},
						"managed": {
							"default": "Ist dieses Unternehmen eine eingetragene Gesellschaft?",
							"AU": "Hat dieses Unternehmen eine ABN?",
							"ES": "Ist Ihr Gewerbe im Registro Mercantil angemeldet?"
						}
					},
					"subtitle": {
						"unmanaged": {
							"default": "Wir benötigen die Handelsregisternummer Ihres Unternehmens, um Ihre Unternehmensdaten zu überprüfen.",
							"AT": "Wir benötigen die Handelsregisternummer Ihres Unternehmens, um Ihre Unternehmensdaten zu überprüfen.",
							"AU": "Falls Sie eine ABN haben, geben Sie diese bitte ein. Ansonst wähle Sie \"Nein\" und fahren Sie fort.",
							"ES": "Antworten Sie mit ja, falls Ihre Rechtsform SL, SA, SCP usw. ist. Antworten Sie mit nein, falls Sie ein Alleininhaber, Selbstständiger usw. sind",
							"GB": "WIr benötigen die Organisationsnummer Ihres Unternehmens, um Ihre Gechäftsdaten zu bestätigen.",
							"GR": "Wir benötigen Ihre G.E.MI.-Nummer, um die Geschäftsdaten zu überprüfen."
						},
						"managed": {
							"default": "Wir benötigen die Handelsregisternummer, um die Geschäftsdaten des Unternehmens zu überprüfen.",
							"AT": "Wir benötigen die Handelsregisternummer, um die Geschäftsdaten des Unternehmens zu überprüfen.",
							"AU": "Falls dieses Unternehmen eine ABN haben, geben Sie diese bitte ein. Ansonst wähle Sie \"Nein\" und fahren Sie fort.",
							"ES": "Antworten Sie mit ja, falls Ihre Rechtsform SL, SA, SCP usw. ist. Antworten Sie mit nein, falls Sie ein Alleininhaber, Selbstständiger usw. sind",
							"GB": "Wir benötigen die Unternehmensnummer, um die Geschäftsdaten des Unternehmens zu überprüfen.",
							"GR": "Wir benötigen die G.E.MI.-Nummer des Unternehmens, um die Geschäftsdaten zu überprüfen."
						}
					},
					"form_title": {
						"unmanaged": {
							"default": "Bitte geben Sie Ihre Registernummer ein",
							"AT": "Bitte geben Sie Ihre Registernummer ein",
							"AU": "Bitte geben Sie Ihre ABN ein.",
							"ES": "Bitte geben Sie Ihre Unternehmens-NIF/NIE/DNI ein.",
							"GB": "Bitte geben Sie Ihre Organisationsnummer ein",
							"GR": "Bitte geben Sie Ihre G.E.MI.-Nummer (Γ.Ε.ΜΗ.) ein"
						},
						"managed": {
							"default": "Geben Sie die Registrierungsnummer ein",
							"AT": "Geben Sie die Registrierungsnummer ein",
							"AU": "Bitte geben Sie die ABN ein.",
							"ES": "Bitte geben Sie Ihre Unternehmens-NIF/NIE/DNI ein.",
							"GB": "Geben Sie die Unternehmensnummer ein",
							"GR": "Bitte geben Sie die G.E.MI.-Nummer (Γ.Ε.ΜΗ.) ein"
						}
					},
					"fields": {
						"registration_number": {
							"label": {
								"default": "Registernummer",
								"AT": "Registernummer",
								"AU": "Australische Handelsregisternummer (ACN, dt. ABN)",
								"ES": "Unternehmens-NIF/NIE/DNI",
								"GB": "Organisationsnummer",
								"GR": "G.E.MI.-Nummer (Γ.Ε.ΜΗ.)"
							},
							"errors": null
						}
					},
					"buttons": {
						"next": "Weiter",
						"back": "Zurück"
					}
				},
				"mid-selector": {
					"title": "Einen Shop auswählen",
					"subtitle": "Diese E-Mail-Adresse ist mit mehreren Shops verbunden. Bitte wählen Sie einen Shop, um fortzufahren.",
					"mid-selector": "Händler-ID/Name des Shops",
					"buttons": {
						"next": "Weiter"
					}
				},
				"optional_registration_information_widget": {
					"title": {
						"unmanaged": "Ist Ihr Unternehmen eine eingetragene Firma?",
						"managed": "Ist dieses Unternehmen eine eingetragene Gesellschaft?"
					},
					"subtitle": {
						"unmanaged": {
							"default": "Wir benötigen die Handelsregisternummer Ihres Unternehmens, um Ihre Unternehmensdaten zu überprüfen.",
							"AT": "Wir benötigen die Handelsregisternummer Ihres Unternehmens, um Ihre Unternehmensdaten zu überprüfen."
						},
						"managed": {
							"default": "Wir benötigen die Handelsregisternummer, um die Geschäftsdaten des Unternehmens zu überprüfen.",
							"AT": "Wir benötigen die Handelsregisternummer, um die Geschäftsdaten des Unternehmens zu überprüfen."
						}
					},
					"form_title": {
						"unmanaged": {
							"default": "Bitte geben Sie Ihre Registernummer ein",
							"AT": "Bitte geben Sie Ihre Registernummer ein"
						},
						"managed": {
							"default": "Geben Sie die Registrierungsnummer ein",
							"AT": "Geben Sie die Registrierungsnummer ein"
						}
					},
					"fields": {
						"registration_number": {
							"label": {
								"default": "Registernummer",
								"AT": "Registernummer"
							}
						}
					},
					"buttons": {
						"next": "Weiter",
						"back": "Zurück"
					}
				},
				"optional_vat_registration": {
					"title": {
						"unmanaged": {
							"default": "Ist Ihre Firma umsatzsteuerpflichtig?",
							"ES": "Besitzt Ihr Unternehmen eine NIF/NIE/DNI?",
							"NZ": "Ist Ihr Unternehmen GST-steuerpflichtig?"
						},
						"managed": {
							"default": "Ist dieses Unternehmen für die Umsatzsteuer registriert?",
							"ES": "Besitzt Ihr Unternehmen eine NIF/NIE/DNI?",
							"NZ": "Ist dieses Unternehmen zur GST registriert?"
						}
					},
					"subtitle": {
						"unmanaged": {
							"default": "Wenn Sie eine USt-IdNr. haben, können wir Ihre Unternehmensdaten leichter überprüfen.",
							"ES": "Verfügt Ihr Unternehmen über eine NIF/NIE/DNI-Nummer, können wir Ihre Unternehmensdaten leichter überprüfen.",
							"NZ": "Wenn Sie eine GST-Nr. haben, können wir Ihre Unternehmensdaten leichter überprüfen."
						},
						"managed": {
							"default": "Anhand der Umsatzsteuer-Identifikationsnummer überprüfen wir die Daten des Unternehmens.",
							"ES": "Verfügt Ihr Unternehmen über eine NIF/NIE/DNI-Nummer, können wir Ihre Unternehmensdaten leichter überprüfen.",
							"NZ": "Anhand der GST-Nr. überprüfen wir die Daten des Unternehmens."
						}
					},
					"form_title": {
						"unmanaged": {
							"default": "Bitte geben Sie Ihre USt-IdNr. ein",
							"ES": "Bitte geben Sie Ihre Unternehmens-NIF/NIE/DNI ein.",
							"NZ": "Bitte geben Sie Ihre GST-Nr. ein"
						},
						"managed": {
							"default": "Geben Sie die Umsatzsteuer-Identifikationsnummer ein",
							"ES": "Bitte geben Sie Ihre Unternehmens-NIF/NIE/DNI ein.",
							"NZ": "Bitte geben Sie Ihre GST-Nr. ein"
						}
					},
					"vat_id": {
						"label": {
							"default": "USt-IdNr.",
							"ES": "Unternehmens-NIF/NIE/DNI",
							"NZ": "GST-Nr."
						}
					},
					"buttons": {
						"next": "Weiter",
						"back": "Zurück"
					}
				},
				"optional_vat_registration_widget": {
					"title": {
						"unmanaged": "Ist Ihre Firma umsatzsteuerpflichtig?",
						"managed": "Ist dieses Unternehmen für die Umsatzsteuer registriert?"
					},
					"subtitle": {
						"unmanaged": "Wenn Sie eine USt-IdNr. haben, können wir Ihre Unternehmensdaten leichter überprüfen.",
						"managed": "Anhand der Umsatzsteuer-Identifikationsnummer überprüfen wir die Daten des Unternehmens."
					},
					"form_title": {
						"unmanaged": "Bitte geben Sie Ihre USt-IdNr. ein",
						"managed": "Geben Sie die Umsatzsteuer-Identifikationsnummer ein"
					},
					"vat_id": {
						"label": {
							"default": "USt-IdNr.",
							"NZ": "GST-Nr."
						}
					},
					"buttons": {
						"next": "Weiter",
						"back": "Zurück"
					}
				},
				"partnership_details": {
					"title": {
						"unmanaged": "Wie lautet Ihre Geschäftsadresse?",
						"managed": "Wie lautet die Geschäftsadresse des Unternehmens?"
					},
					"subtitle": {
						"unmanaged": "Bitte teilen Sie uns Ihren Unternehmensstandort mit.",
						"managed": "Wir müssen wissen, wo sich das Unternehmen befindet."
					},
					"buttons": {
						"next": "Weiter",
						"back": "Zurück"
					},
					"fields": {
						"partnership_name": {
							"label": "Name der Handelsgesellschaft",
							"errors": {
								"general": "Bitte geben Sie einen Namen für die Handelsgesellschaft ein"
							}
						},
						"street": {
							"label": "Adresse",
							"errors": {
								"general": "Bitte geben Sie eine gültige Adresse ein"
							}
						},
						"postal_code": {
							"label": "Postleitzahl",
							"errors": {
								"general": "Bitte geben Sie eine gültige Postleitzahl an"
							}
						},
						"city": {
							"label": "Ort",
							"errors": {
								"general": "Bitte geben Sie einen gültigen Ort an"
							}
						},
						"country": {
							"label": "Land",
							"errors": {
								"general": "Bitte geben Sie ein gültiges Land an"
							}
						}
					}
				},
				"partners_and_principals": {
					"title": {
						"default": "Wer ist der Eigentümer des Unternehmens?",
						"GB": "Wer leitet das Unternehmen?"
					},
					"subtitle": {
						"default": [
							{
								"text": "Gemäß der EU-Anti-Geldwäsche-Richtlinie ("
							},
							{
								"text": "EU 2015/849",
								"link": "https://eur-lex.europa.eu/legal-content/EN/TXT/PDF/?uri=CELEX:32015L0849"
							},
							{
								"text": ") sind wir gesetzlich dazu verpflichtet, diese Informationen zu sammeln."
							}
						],
						"AU": [
							{
								"text": "Als Finanzinstitut sind wir gesetzlich dazu verpflichtet, diese Informationen zu erfassen."
							}
						]
					},
					"infobox": "Bitte geben Sie Daten zur Person und die Wohnadresse aller Eigentümer und Partner ein, die die Kontrolle über das Management Ihres Unternehmens ausüben.",
					"buttons": {
						"add_person": "+ Person hinzufügen",
						"next": "Weiter",
						"back": "Zurück"
					}
				},
				"payouts_summary": {
					"title": "Bankkonten",
					"default_bank_accounts": {
						"no_elements": "Kein Standard-Bankkonto vorhanden"
					},
					"additional_bank_accounts": {
						"no_elements": "Sie haben keine weiteren Bankkonten angegeben"
					}
				},
				"pre_assessment_company_details": {
					"title": "Bitte geben Sie einige Unternehmensangaben ein.",
					"subtitle": "Bitte führen Sie die Unternehmensdaten für das Land auf, in dem es registriert ist. Bitte geben Sie außerdem an, ob das Unternehmen aus einem anderen Markt heraus agiert als das Registrierungsland, da dies für die Risikobewertung notwendig ist.",
					"fields": {
						"volume_by_card": {
							"label": "Anteil des Kartenvolumens am Gesamtvolumen (%)",
							"errors": {
								"invalid": "Das Kartenvolumen sollte eine Ziffer zwischen 0 und 100 sein",
								"invalid_hint": "Bitte fügen Sie den Anteil des Kartentransaktionsvolumens dem Gesamtvolumen von Klarna für diese Gelegenheit hinzu. Geben Sie 0 % ein, wenn Ihre Gelegenheit keine Kartenzahlungen hat."
							}
						},
						"average_order_value": {
							"label": "Durchschnittlicher Bestellwert (in SEK)",
							"tooltip": "Sollte ein positiver Betrag in SEK sein",
							"errors": {
								"invalid": "Sollte ein positiver Betrag in SEK sein"
							}
						},
						"registration_country": {
							"label": "Registrierungsland",
							"errors": {
								"required": "Registrierungsland wird benötigt"
							}
						},
						"operating_country": {
							"label": "Land der Unternemensaktivität",
							"errors": {
								"required": "Land der Unternehmensaktivität wird benötigt"
							}
						},
						"registration_number": {
							"label": {
								"default": "Handelsregisternummer (für angemeldete Unternehmen erforderlich)",
								"AU": "ACN (für angemeldete Unternehmen erforderlich)",
								"ES": "Unternehmens-NIF/NIE/DNI (für angemeldete Unternehmen erforderlich)",
								"GR": "G.E.MI.-Nummer (Γ.Ε.ΜΗ.) (für angemeldete Unternehmen erforderlich)",
								"NZ": "Betriebsnummer (für angemeldete Unternehmen erforderlich)",
								"US": "TIN/EIN (für angemeldete Unternehmen erforderlich)"
							}
						},
						"vat_number": {
							"label": "ABN",
							"errors": {
								"required": "Geben Sie die ACN oder ABN an",
								"invalid": "Die ABN umfasst 11 Ziffern"
							}
						},
						"registration_authority": {
							"label": "Registerbehörde",
							"errors": {
								"required": "Bitte wählen Sie Ihre Registerbehörde"
							}
						},
						"company_name": {
							"label": "",
							"errors": {
								"required": ""
							}
						},
						"sales_contact": {
							"label": "E-Mail Vertreter",
							"errors": {
								"invalid": "Bitte geben Sie eine gültige Email adresse ein"
							}
						},
						"store_url": {
							"label": "Shop-URL",
							"errors": {
								"required": "Shop-URL wird benötigt",
								"invalid": "Bitte geben Sie eine gültige Website-URL ein"
							}
						},
						"goods_category": {
							"label": "Hauptkategorie der verkauften Produkte",
							"errors": {
								"invalid": "Sie müssen eine der Optionen auswählen"
							}
						},
						"is_managed": {
							"label": "Händler-Verfahren abgeschlossen, um online zu gehen?"
						}
					},
					"buttons": {
						"next": "Weiter",
						"back": "Zurück"
					}
				},
				"pre_assessment_products": {
					"title": "Bitte führen Sie alle Produkte auf",
					"subtitle": "Für die Risikobewertung werden alle Produkte je Verkaufsland benötigt",
					"select": {
						"label": "Produkt suchen"
					},
					"selected": {
						"label": "Ausgewählte Produkte:"
					},
					"clear": "Alle löschen",
					"errors": {
						"invalid": "Es sollte mindests ein Produkt pro Land ausgewählt werden"
					},
					"channels": {
						"ONLINE": "Online",
						"IN_STORE": "Im Ladengeschäft",
						"TELESALES": "Televerkauf",
						"SELLER_APP": "Verkäufer-App"
					},
					"buttons": {
						"next": "Weiter",
						"back": "Zurück"
					}
				},
				"wrong_prefill_data": {
					"title": "Ungültige Daten angegeben",
					"subtitle": "Ungültige und inkompatible Prefill-Informationen von SalesForce bereitgestellt.",
					"details": "Details: ",
					"fields": {
						"goodsCategory": "Warenkategorie",
						"paymentInterval": "Zahlungsintervall",
						"paymentDelay": "Zahlungsverzögerung",
						"registrationCountry": "Registrierungsland",
						"storeUrl": "Shop-URL",
						"mainSellingCountry": "Haupt-Verkaufsland",
						"products": "Produkte",
						"products_item": "Produkt {Index}",
						"products_item_yearlyAcquiredVolume": "Produkt {index} jährlich erhaltenes Volumen",
						"products_item_sellingCountry": "Produkt {index} Verkaufsland",
						"products_item_productName": "Produkt {Index} Name",
						"products_item_channels": "Produkt {Index} Kanäle",
						"products_item_channels_item": "Produkt {Index} Kanal"
					},
					"error_types": {
						"fallback": "ist ungültig",
						"any": {
							"required": "ist vorgeschrieben und wurde nicht angegeben"
						}
					}
				},
				"selling_countries": {
					"title": "Bitte führen Sie alle Verkaufsländer auf",
					"subtitle": "Die vollständige Länderliste wird für die Risikobewertung benötigt",
					"select": {
						"label": "Land suchen"
					},
					"selected": {
						"label": "Ausgewählte Länder:"
					},
					"fields": {
						"selling_countries": {
							"label": "Land wählen",
							"errors": {
								"invalid": "Sie müssen mindestens ein Land wählen"
							}
						}
					},
					"clear": "Alle löschen",
					"buttons": {
						"next": "Weiter",
						"back": "Zurück"
					}
				},
				"main_selling_country": {
					"title": "Was ist der Klarna-Hauptmarkt für den Händler?",
					"subtitle": "Bitte wählen Sie den Markt mit dem höchsten erwarteten Klarna-Volumen",
					"errors": {
						"invalid": "Sie müssen ein Land wählen"
					},
					"buttons": {
						"next": "Weiter",
						"back": "Zurück"
					}
				},
				"fca_number": {
					"title": "Bitte geben Sie die FCA-Nummer ein",
					"subtitle": "Wir sind gesetzlich verpflichtet, die Kreditvermittlungs-Lizenz zu prüfen.",
					"fields": {
						"fca_number": {
							"label": "FCA-Nummer",
							"errors": {
								"general": "Geben Sie eine gültige FCA-Nummer ein"
							}
						}
					},
					"buttons": {
						"next": "Weiter",
						"back": "Zurück"
					}
				},
				"sole_trader": {
					"title": "Wer ist der Eigentümer des Unternehmens?",
					"subtitle": {
						"default": [
							{
								"text": "Gemäß der EU-Anti-Geldwäsche-Richtlinie ("
							},
							{
								"text": "EU 2015/849",
								"link": "https://eur-lex.europa.eu/legal-content/EN/TXT/PDF/?uri=CELEX:32015L0849"
							},
							{
								"text": ") sind wir gesetzlich dazu verpflichtet, diese Informationen zu sammeln."
							}
						]
					},
					"infobox": {
						"unmanaged": "Bitte geben Sie Ihre persönlichen Daten und Wohnadresse an.",
						"managed": "Bitte geben Sie die Daten und Wohnadresse des Eigentümers an."
					},
					"buttons": {
						"next": "Weiter",
						"back": "Zurück"
					},
					"fields": {
						"are_you_the_sole_trader": {
							"label": "Die antragstellende Person ist die gleiche wie der Einzelunternehmer",
							"error": "Es tut uns leid, aber Sie können nur fortfahren, wenn Sie als Einzelunternehmer selber diese Anmeldung durchführen."
						}
					},
					"address_form": {
						"question": {
							"title": {
								"unmanaged": "Sind Sie von einer anderen Adresse aus tätig?",
								"managed": "Ist dieses Unternehmen von einer anderen Adresse aus tätig?"
							},
							"subtitle": {
								"unmanaged": "Wählen Sie nur Ja, wenn Sie Ihr Unternehmen von einer anderen Adresse als der Ihres Wohnsitzes aus betreiben.",
								"managed": "Wählen Sie nur dann „Ja“, wenn dieses Unternehmen sein Geschäft von einer anderen Adresse als der Wohnadresse des Einzelunternehmers aus betreibt."
							}
						},
						"title": "Bitte geben Sie die Geschäftsadresse an",
						"fields": {
							"street": {
								"label": "Adresse",
								"errors": {
									"general": "Bitte geben Sie eine gültige Adresse an"
								}
							},
							"postal_code": {
								"label": "Postleitzahl",
								"errors": {
									"general": "Bitte geben Sie eine gültige Postleitzahl an"
								}
							},
							"city": {
								"label": "Ort",
								"errors": {
									"general": "Bitte geben Sie einen gültigen Ort an"
								}
							},
							"country": {
								"label": "Land",
								"errors": {
									"general": "Bitte geben Sie ein gültiges Land an"
								}
							}
						}
					}
				},
				"sole_trader_confirmation": {
					"title": "Wir möchten Sie bitten, noch zwei Dinge zu bestätigen.",
					"subtitle": "",
					"fields": {
						"are_you_the_sole_trader": {
							"title": "Sie sind der Einzelunternehmer",
							"label": "Die antragstellende Person ist die gleiche wie der Einzelunternehmer"
						},
						"are_you_the_only_with_financial_control": {
							"title": "Sie haben die alleinige finanzielle Kontrolle",
							"label": "Der Eigentümer ist die einzige Person, die die finanzielle Kontrolle über die Bankkonten Ihres Unternehmens hat."
						}
					},
					"buttons": {
						"next": "Weiter",
						"back": "Zurück"
					},
					"robot_message": "Entschuldigung, Sie müssen diese zwei Dinge bestätigen"
				},
				"underwriting_info": {
					"title": "Bitte geben Sie das Volumen und die Zahlungsverzögerung der Gelegenheit ein",
					"subtitle": "Bitte führen Sie das erwartete jährliche Klarna-Gesamtvolumen für diese Gelegenheit und die Zahlungsverzögerung ein. Falls sich die Zahlungsverzögerungen nach Land unterscheiden, verwenden Sie diejenige für das ausgewählte Hauptverkaufsland.",
					"fields": {
						"yearly_acquired_volume": {
							"label": "Jährliches Gesamtmarktvolumen (in SEK)",
							"errors": {
								"invalid": "Das jährliche Gesamtmarktvolumen sollte ein positiver Betrag in SEK sein",
								"too_long": "Das jährliche Gesamtmarktvolumen kann nicht mehr als 16 Ziffern enthalten"
							}
						},
						"payment_delay": {
							"label": "Zahlungsverzögerung",
							"errors": {
								"general": "Bitte geben Sie einen Wert für die Zahlungsverzögerung an",
								"invalid": "Die Zahlungsverzögerung sollte eine Zahl zwischen {min} und {max} sein"
							}
						},
						"payment_interval": {
							"label": "Zahlungsintervall",
							"errors": {
								"invalid": "Sie müssen eine der Optionen auswählen"
							}
						},
						"volume_by_card": {
							"label": "Share of Checkout (%)",
							"errors": {
								"invalid": "Share of Checkout sollte eine Ziffern zwischen 0 und 100 sein",
								"invalid_hint": "Bitte fügen Sie den Anteil des Kartentransaktionsvolumens dem Gesamtvolumen von Klarna für diese Gelegenheit hinzu. Geben Sie 0 % ein, wenn Ihre Gelegenheit keine Kartenzahlungen hat."
							}
						},
						"average_order_value": {
							"label": "Durchschnittlicher Bestellwert (in SEK)"
						}
					},
					"buttons": {
						"back": "Zurück",
						"next": "Weiter"
					}
				},
				"store_details": {
					"title": {
						"unmanaged": {
							"default": "Bitte geben Sie die Details zu Ihrem Shop an."
						},
						"managed": "Was sind Details zum Shop?"
					},
					"subtitle": {
						"unmanaged": {
							"US": "Wir nutzen diese Informationen, um Ihr Geschäftskonto einzurichten.",
							"default": "Wir verwenden die angegebenen Daten als Ihre primären Kontaktinformationen und um einen Blick auf Ihren Shop zu werfen."
						},
						"managed": "Wir werden die zur Verfügung gestellten Daten als primäre Kontaktdaten für Kunden und zur Einsichtnahme in den Store verwenden."
					},
					"fields": {
						"store_name": {
							"label": {
								"CA": "Markenname/DBA",
								"MX": "Markenname/DBA",
								"US": "Markenname/DBA",
								"default": "Name des Shops"
							},
							"errors": {
								"required": "Name des Shops ist erforderlich",
								"required_us": "Markenname/DBA ist erforderlich",
								"invalid": "Bitte geben Sie einen Shopnamen mit mindestens 2 Zeichen an",
								"invalid_us": "Bitte geben Sie einen Markennamen mit mindestens 2 Zeichen an",
								"invalid_characters": "Der Name des Shops darf keines der folgenden Zeichen enthalten: < >",
								"invalid_characters_us": "Der Markenname / DBA darf keines der folgenden Zeichen enthalten: < >"
							}
						},
						"website": {
							"label": "Online-Shop-Website",
							"errors": {
								"required": "Website ist erforderlich",
								"invalid": "Bitte geben Sie eine gültige Website-URL ein"
							}
						},
						"goods_category": {
							"label": "Hauptkategorie der verkauften Produkte",
							"errors": {
								"required": "Warenkategorie ist erforderlich"
							}
						},
						"email": {
							"label": "Kundenservice Email",
							"errors": {
								"required": "Email adresse des Geschäftsinhabers ist erforderlich",
								"invalid": "Bitte geben Sie eine gültige Email adresse ein"
							}
						}
					},
					"buttons": {
						"next": "Weiter",
						"back": "Produkte ändern"
					}
				},
				"uk_company_details": {
					"title": {
						"unmanaged": "Wie lautet Ihre registrierte Geschäftsadresse?",
						"managed": "Wie lautet die eingetragene Geschäftsadresse des Unternehmens?"
					},
					"subtitle": {
						"unmanaged": "Wir müssen wissen, unter welcher Adresse Ihr Unternehmen registriert ist.",
						"managed": "Wir müssen wissen, unter welcher Adresse das Unternehmen registriert ist."
					},
					"question": {
						"title": {
							"unmanaged": "Sind Sie von einer anderen Adresse aus tätig?",
							"managed": "Ist dieses Unternehmen von einer anderen Adresse aus tätig?"
						},
						"subtitle": {
							"unmanaged": "Wählen Sie nur Ja, wenn Sie Ihr Unternehmen von einer anderen Adresse als der registrierten Geschäftsadresse aus betreiben.",
							"managed": "Wählen Sie nur dann „Ja“, wenn dieses Unternehmen sein Geschäft von einer anderen Adresse als der eingetragenen Geschäftsadresse aus betreibt."
						}
					},
					"toggle": {
						"title": "Bitte geben Sie die Adresse Ihrer Hauptniederlassung an"
					},
					"fields": {
						"company_name": {
							"label": "Juristische Bezeichnung des Unternehmens",
							"errors": {
								"general": "Bitte geben Sie eine Firmenbezeichnung an"
							}
						},
						"street": {
							"label": "Adresse",
							"errors": {
								"general": "Bitte geben Sie eine Adresse an."
							}
						},
						"postal_code": {
							"label": "Postleitzahl",
							"errors": {
								"general": "Bitte geben Sie eine Postleitzahl an"
							}
						},
						"city": {
							"label": "Ort",
							"errors": {
								"general": "Bitte geben Sie einen Ort an"
							}
						},
						"country": {
							"label": "Land",
							"errors": {
								"general": "Bitte geben Sie ein Land an"
							}
						}
					},
					"buttons": {
						"next": "Weiter",
						"back": "Zurück"
					},
					"messages": {
						"lookup": "Ist dies Ihre Firma? Bitte überprüfen Sie die Angaben und bestätigen Sie diese falls die Angaben korrekt sind."
					}
				},
				"uk_sole_trader": {
					"title": "Wem gehört diese Firma?",
					"subtitle": {
						"unmanaged": "Sie sind dabei, einen Vertrag mit Klarna abzuschließen. Daher müssen wir Ihre Daten erfassen.",
						"managed": "Wir sind verpflichtet, die personenbezogenen Daten des Eigentümers zu erfassen und zu überprüfen."
					},
					"buttons": {
						"next": "Weiter",
						"back": "Zurück"
					},
					"address_form": {
						"question": {
							"title": {
								"unmanaged": "Sind Sie von einer anderen Adresse aus tätig?",
								"managed": "Ist dieses Unternehmen von einer anderen Adresse aus tätig?"
							},
							"subtitle": {
								"unmanaged": "Wählen Sie nur Ja, wenn Sie Ihr Unternehmen von einer anderen Adresse als der Ihres Wohnsitzes aus betreiben.",
								"managed": "Wählen Sie nur dann „Ja“, wenn dieses Unternehmen sein Geschäft von einer anderen Adresse als der Wohnadresse des Einzelunternehmers aus betreibt."
							}
						},
						"title": "Bitte geben Sie die Geschäftsadresse an",
						"fields": {
							"street": {
								"label": "Adresse",
								"errors": {
									"general": "Bitte geben Sie eine gültige Adresse an"
								}
							},
							"postal_code": {
								"label": "Postleitzahl",
								"errors": {
									"general": "Bitte geben Sie eine gültige Postleitzahl an"
								}
							},
							"city": {
								"label": "Ort",
								"errors": {
									"general": "Bitte geben Sie einen gültigen Ort an"
								}
							},
							"country": {
								"label": "Land",
								"errors": {
									"general": "Bitte geben Sie ein gültiges Land an"
								}
							}
						}
					}
				},
				"us_sole_proprietorship": {
					"title": "Wer ist der Eigentümer des Unternehmens?",
					"subtitle": {
						"default": "Als Finanzinstitut sind wir gesetzlich dazu verpflichtet, diese Informationen zu erfassen."
					},
					"infobox": {
						"unmanaged": "Bitte geben Sie Ihre persönlichen Daten und Wohnadresse an.",
						"managed": "Bitte geben Sie die Daten und Wohnadresse des Eigentümers an."
					},
					"buttons": {
						"next": "Weiter",
						"back": "Zurück"
					},
					"address_form": {
						"question": {
							"title": {
								"unmanaged": "Sind Sie von einer anderen Adresse aus tätig?",
								"managed": "Ist dieses Unternehmen von einer anderen Adresse aus tätig?"
							},
							"subtitle": {
								"unmanaged": "Wählen Sie nur Ja, wenn Sie Ihr Unternehmen von einer anderen Adresse als der Ihres Wohnsitzes aus betreiben.",
								"managed": "Wählen Sie nur dann „Ja“, wenn dieses Unternehmen sein Geschäft von einer anderen Adresse als der Wohnadresse des Einzelunternehmers aus betreibt."
							}
						},
						"title": "Bitte geben Sie die Geschäftsadresse an",
						"fields": {
							"street": {
								"label": "Adresse",
								"errors": {
									"general": "Bitte geben Sie eine gültige Adresse an"
								}
							},
							"postal_code": {
								"label": "Postleitzahl",
								"errors": {
									"general": "Bitte geben Sie eine gültige Postleitzahl an"
								}
							},
							"city": {
								"label": "Ort",
								"errors": {
									"general": "Bitte geben Sie einen gültigen Ort an"
								}
							},
							"country": {
								"label": "Land",
								"errors": {
									"general": "Bitte geben Sie ein gültiges Land an"
								}
							},
							"region": {
								"label": "Bundesland",
								"errors": {
									"general": "Bitte geben Sie einen Bundesstaat an"
								}
							}
						}
					}
				},
				"ultimate_beneficial_owner": {
					"title": {
						"default": "Gibt es Personen, denen mehr als 25 % des Unternehmens gehört?"
					},
					"subtitle": {
						"AU": [
							{
								"text": "Als Finanzinstitut sind wir gesetzlich dazu verpflichtet, diese Informationen zu erfassen."
							}
						],
						"default": [
							{
								"text": "Wir müssen wissen, wer die Personen sind, denen mehr als 25 % der Aktien oder Stimmrechte des Unternehmens gehören oder, die eine ähnliche Kontrolle ausüben. Wir sind durch die EU-Geldwäsche-Richtlinie ("
							},
							{
								"text": "EU 2015/849",
								"link": "https://eur-lex.europa.eu/legal-content/EN/TXT/PDF/?uri=CELEX:32015L0849"
							},
							{
								"text": ") sind wir gesetzlich dazu verpflichtet, diese Informationen zu sammeln."
							}
						]
					},
					"infobox": {
						"default": "Bitte geben Sie die Daten zu jeder Person und ihre Wohnadresse an.",
						"AU": "Bitte geben Sie die Daten zu jeder Person und ihre Wohnadresse an. Bei Unternehmen mit komplexen Eigentumsstrukturen muss es sich um natürliche Personen handeln."
					},
					"buttons": {
						"next": "Weiter",
						"back": "Zurück",
						"add_person": "+ Person hinzufügen"
					},
					"messages": {
						"lookup": "Leiten diese Personen Ihr Unternehmen? Bitte überprüfen Sie die Angaben und bestätigen Sie diese falls sie korrekt sind."
					}
				},
				"us_company_details": {
					"title": {
						"unmanaged": "Wie lautet Ihre Geschäftsadresse?",
						"managed": "Wie lautet die eingetragene Geschäftsadresse des Unternehmens?"
					},
					"subtitle": {
						"unmanaged": "Das ist die Adresse, an der Ihr Geschäft offiziell registriert ist, und diese Adresse wird auf Ihren Klarna Rechnungen verwendet.",
						"managed": "Wir müssen wissen, unter welcher Adresse das Unternehmen registriert ist."
					},
					"question": {
						"title": {
							"unmanaged": "Sind Sie von einer anderen Adresse aus tätig?",
							"managed": "Ist dieses Unternehmen von einer anderen Adresse aus tätig?"
						},
						"subtitle": {
							"unmanaged": "Wählen Sie nur Ja, wenn Sie Ihr Unternehmen von einer anderen Adresse als der registrierten Geschäftsadresse aus betreiben.",
							"managed": "Wählen Sie nur dann „Ja“, wenn dieses Unternehmen sein Geschäft von einer anderen Adresse als der eingetragenen Geschäftsadresse aus betreibt."
						}
					},
					"toggle": {
						"title": "Bitte geben Sie die Adresse Ihrer Hauptniederlassung an"
					},
					"fields": {
						"company_name": {
							"label": "Eingetragener Firmenname",
							"errors": {
								"general": "Bitte geben Sie eine Firmenbezeichnung an"
							}
						},
						"street": {
							"label": "Adresse",
							"errors": {
								"general": "Bitte geben Sie eine Adresse an."
							}
						},
						"postal_code": {
							"label": "Postleitzahl",
							"errors": {
								"general": "Bitte geben Sie eine Postleitzahl an"
							}
						},
						"city": {
							"label": "Ort",
							"errors": {
								"general": "Bitte geben Sie einen Ort an"
							}
						},
						"country": {
							"label": "Land",
							"errors": {
								"general": "Bitte geben Sie ein Land an"
							}
						},
						"state_of_incorporation": {
							"label": "Bundesstaat der Gesellschaftsgründung",
							"errors": {
								"general": "Bitte geben Sie einen Bundesstaat der Gesellschaftsgründung an"
							}
						},
						"state": {
							"label": "Bundesland",
							"errors": {
								"general": "Bitte geben Sie einen Bundesstaat an"
							}
						},
						"region": {
							"label": "Region",
							"errors": {
								"puerto_rico": "Puerto Rico nicht zugelassen"
							}
						}
					},
					"buttons": {
						"next": "Weiter",
						"back": "Zurück"
					}
				},
				"select_products": {
					"title": "Unsere Services",
					"title_kco_hidden": "Zahlungsarten, die Umsätze steigern",
					"subtitle": "Wählen Sie die Services aus, die Sie interessieren.",
					"subtitle_kco_hidden": "Erschließen Sie die Kaufkraft Ihrer Kunden. Bieten Sie mehr Zahlungsoptionen an, damit Ihre Kunden entscheiden können, wann und wie sie zahlen möchten.",
					"platform_alert": null,
					"buttons": {
						"next": "Weiter"
					}
				},
				"signup_products": {
					"title_line_1": "Klarna Produkte für Ihren Shop.",
					"title_kco_hidden_line_1": "Zahlungsarten, die",
					"title_kco_hidden_line_2": "Umsätze steigern.",
					"subtitle": "Die Möglichkeit, per Klarna zu zahlen, erhöht die Konversionsrate um durchschnittlich 30 %, den durchschnittlichen Bestellwert um 41 % und die Bestellhäufigkeit um 36 %.",
					"subtitle_kco_hidden": "Erschließen Sie die Kaufkraft Ihrer Kunden. Bieten Sie mehr Zahlungsoptionen an, damit Ihre Kunden entscheiden können, wann und wie sie zahlen möchten.",
					"info_block": "Verfügbare Produkte angezeigt für",
					"special_offer": "Sonderangebot: {percentageFee} % + {fixedFee} pro Transaktion. Gültig bis {validUntil}.",
					"buttons": {
						"contact_sales": "Den Vertrieb kontaktieren",
						"next": "Konto erstellen",
						"back": "Zurück"
					}
				},
				"questionnaire": {
					"buttons": {
						"back": "Zurück",
						"next": "Weiter"
					}
				},
				"business_concepts": {
					"title": "Bitte wählen Sie die zutreffenden Geschäftskonzepte aus.",
					"subtitle": "Bitte wählen Sie nur die zutreffenden Konzepte aus. Das können mehrere sein.",
					"errors": {
						"select_at_least_one": "Bitte wählen Sie mindestens ein Geschäftskonzept aus."
					},
					"buttons": {
						"next": "Weiter",
						"back": "Zurück"
					}
				},
				"confirm_copy": {
					"title": "Kopieren bestätigen",
					"disclaimer": "Alle Bestandsdaten der aktuellen MID werden überschrieben mit Daten von",
					"merchant_id": "{mid}",
					"buttons": {
						"skipCopy": "Nicht kopieren",
						"confirmCopy": "Daten kopieren"
					}
				},
				"pre_assessment_summary": {
					"title": "Zusammenfassung",
					"subtitle": "Bitte prüfen Sie die Angaben sorgfältig, bevor Sie sie zur Unterzeichnung einreichen",
					"banner": {
						"mcc_deal": "Dies ist ein MCC Deal, bitte befolgen Sie die MCC / ECC Eskalationsroutine."
					},
					"selling_countries": {
						"title": "Bitte wählen Sie den Markt mit dem höchsten erwarteten Volumen",
						"main_selling_country": "Haupt-Verkaufsland"
					},
					"pre_assessment_products": {
						"title": "Produkte"
					},
					"company_details": {
						"title": "Unternehmensangaben"
					},
					"fca_number": {
						"title": "FCA-Nummer"
					},
					"high_exposure_questionnaires": {
						"title": "Fragebögen zu hoher Belastung"
					},
					"mia_questionnaires": {
						"title": "MIA-Fragebögen"
					},
					"buttons": {
						"back": "Zurück",
						"edit": "Bearbeiten",
						"submit": "Abschicken"
					}
				},
				"pre_assessment_overview": {
					"title": "Vorbewertung-Übersicht",
					"subtitle_APPROVED": "Die genehmigten Bedingungen für diese Gelegenheit finden Sie unten.",
					"subtitle_REJECTED": "Die abgelehnten Bedingungen für diese Gelegenheit finden Sie unten.",
					"subtitle_UNRESOLVED": "Sie können die eingereichten Informationen ändern, falls Sie Fehler bemerken. Dadurch wird kein neuer Fall ausgelöst.",
					"status": {
						"APPROVED": "Der Fall wurde genehmigt",
						"REJECTED": "Der Fall wurde abgelehnt",
						"UNRESOLVED": "Warten auf das Ergebnis der Bewertung …",
						"UNRESOLVED_TIMED_OUT": "Der Fall wird manuell bewertet. Dies kann mehrere Tage in Anspruch nehmen.",
						"UNRESOLVED_TIMED_OUT_LINK_LABEL": "Fall im Händler-Bewertungsportal ansehen",
						"STARTED": "Der Fall wurde zur Prüdung eingereicht"
					},
					"buttons": {
						"change": "Ändern",
						"new_case": "Neuer Fall"
					}
				},
				"recollection_introduction": {
					"title": {
						"default": "Hallo!"
					},
					"subtitle": {
						"default": [
							{
								"text": "Klarna ist als Finanzinstitut unter Aufsicht der schwedischen Finanzdienstleistungsaufsicht entsprechend den Regelungen der EU Richtlinie EU 2015/849 (wie geändert oder ersetzt) verpflichtet, Maßnahmen zur Vermeidung von Geldwäsche vorzunehmen. Für Sie als Einzelhändler bedeutet dies, dass Klarna bestimmte Informationen über die wirtschaftlichen Eigentümer des Unternehmens einholen muß, bevor Sie unsere Dienstleistungen nutzen können. Auch von unseren Bestandskunden müssen wir diese Informationen regelmäßig abfragen, um sicherzustellen, dass diese noch aktuell sind. Nähere Informationen können Sie in der EU-Richtlinie"
							},
							{
								"text": "hier",
								"link": "https://eur-lex.europa.eu/legal-content/EN/TXT/PDF/?uri=CELEX:32015L0849"
							},
							{
								"text": " finden."
							}
						]
					},
					"buttons": {
						"next": "Weiter"
					}
				},
				"recollection_confirmation": {
					"title": "Bestätigung",
					"subtitle": "Bitte prüfen Sie die Angaben sorgfältig, bevor Sie sie zur Unterzeichnung einreichen",
					"stakeholder": "Stakeholder {index}",
					"buttons": {
						"back": "Zurück",
						"submit": "Abschicken"
					}
				},
				"recollection_overview": {
					"title": "Danke!",
					"subtitle": "Hier finden Sie eine Übersicht über die von Ihnen eingereichten Informationen.",
					"stakeholder": "Stakeholder {index}",
					"notice": "Ihre Informationen wurden erfolgreich übermittelt."
				},
				"volume_separation": {
					"title_line_1": "Welche Größe hat Ihr Online-Unternehmen?",
					"subtitle": "Klarna hat die passende Lösung für Ihr Unternehmen – ob groß oder klein.",
					"selector_title": "Jahreseinkommen",
					"below": "Unter {threshold}",
					"between": "Zwischen {belowThreshold} und {aboveThreshold}",
					"over": "Über {threshold}",
					"buttons": {
						"back": "Zurück"
					}
				},
				"basic_info": {
					"title_line_1": "Starten Sie mit Ihrem Unternehmen",
					"title_line_2": "durch – mit Klarna.",
					"subtitle": "Wir brauchen ein paar grundlegende Informationen, um alles einzurichten.",
					"fields": {
						"email": {
							"label": "Geschäftliche E-Mail-Adresse",
							"field_link": "Kein Unternehmen/Geschäft?",
							"errors": {
								"required": "E-Mail-Adresse fehlt",
								"invalid": "Bitte geben Sie eine gültige E-Mail-Adresse an."
							}
						},
						"email_confirmation": {
							"label": "Geschäftliche E-Mail-Adresse bestätigen",
							"tooltip": "Ihre geschäftliche E-Mail-Adresse stellt den Hauptkanal Ihrer Kommunikation mit Klarna dar. Achten Sie deshalb auf die korrekte Schreibweise",
							"errors": {
								"required": "Bitte bestätigen Sie Ihre geschäftliche E-Mail-Adresse",
								"invalid": "Bitte geben Sie Ihre E-Mail-Adresse zweifach in korrekter Schreibweise an"
							}
						},
						"website": {
							"label": "E-Commerce-URL",
							"errors": {
								"required": "E-Commerce-URL wird benötigt",
								"invalid": "Bitte geben Sie eine gültige URL an."
							}
						},
						"country": {
							"label": "Land der Registrierung",
							"errors": {
								"general": "Bitte wählen Sie ein gültiges Land."
							}
						}
					},
					"buttons": {
						"continue": "Weiter"
					}
				},
				"contact_details": {
					"title_line_1": "Unterhalten wir uns kurz.",
					"subtitle": "Füllen Sie dieses Formular aus und wir melden uns so schnell wie möglich mit Lösungen, die auf Ihr Unternehmen zugeschnitten sind.",
					"fields": {
						"full_name": {
							"label": "Vor- und Nachname",
							"errors": {
								"required": "Voller Name wird benötigt"
							}
						},
						"phone": {
							"label": "Telefonnummer",
							"tooltip": "Sie müssen die Landesvorwahl angeben, z. B. +1 541 754 3010",
							"errors": {
								"required": "Telefonnummer fehlt",
								"invalid": "Ungültige Telefonnummer"
							}
						},
						"tell_us_more": {
							"label": "Erzählen Sie uns ein bisschen mehr über Ihr Unternehmen (optional)"
						}
					},
					"buttons": {
						"back": "Zurück",
						"submit": "Kontaktdaten angeben"
					}
				},
				"contact_received": {
					"title": "Wir melden uns bald!",
					"message_1": "Unser Sales-Team wird sich bald bei Ihnen melden.",
					"message_2": "Unser Team wird sich bald bei Ihnen melden. Wir haben Ihnen auch eine Bestätigung der von Ihnen eingesendeten Informationen geschickt"
				},
				"we_are_sorry": {
					"title": "Es tut uns leid. Wir können Ihre Anmeldung zum jetzigen Zeitpunkt nicht genehmigen. ",
					"message_1_unsupported_country": "Klarna unterstützt das von Ihnen ausgewählte Land aktuell nicht:",
					"message_1_sensitive_goods": "Klarna unterstützt die von Ihnen gewählte Produktkategorie nicht:",
					"message_1_platform": "Klarna unterstützt die von Ihnen gewählte E-Commerce-Plattform nicht:",
					"message_2": "Wir arbeiten stetig an neuen Lösungsansätzen und werden Sie kontaktieren sobald eine Zusammenarbeit mit Klarna möglich ist.",
					"platform_alert": {
						"jtl4": [
							{
								"text": "Sie können trotzdem das"
							},
							{
								"text": "Plugin",
								"link": "https://www.mollie.com/de/integrations/jtl"
							},
							{
								"text": "von unserem Partner Mollie nutzen."
							}
						]
					}
				},
				"platform": {
					"title_line_1": "Mit welcher Plattform arbeiten Sie?",
					"subtitle": "Wählen Sie Ihre E-Commerce-Plattform und wir werden Ihr Unternehmen in kürzester Zeit integrieren.",
					"custom": "Selbst erstellte Integration",
					"other_platform": "Andere Integrationslösungen",
					"platform_search": {
						"label": "E-Commerce-Plattform",
						"no_match": "Kein Treffer gefunden für \"{input}\""
					},
					"buttons": {
						"back": "Zurück"
					}
				},
				"partner": {
					"title_line_1": "Mit welchem Zahlungsdienstleistungs-Partner möchten Sie das Onboarding durchführen?",
					"subtitle": "Wählen Sie den Zahlungsdienstleistungs-Partner aus, der Ihren Bedürfnissen am besten entspricht."
				},
				"account_creation_loading": {
					"title": "Ihr Konto wird erstellt ...",
					"message": "Richten Sie Ihre Geschäfts-ID ein ..."
				},
				"application_checking": {
					"title": "Ihr Antrag wird überprüft ...",
					"message": "Shop-Daten werden analysiert"
				},
				"application_review": {
					"title": "Wir prüfen Ihren Antrag.",
					"title_approved": "Ihr Antrag wurde angenommen!",
					"message": "Dies ist ein manueller Prozess, daher können die Bearbeitungszeiten variieren, aber wir erledigen das so schnell wie möglich.",
					"email_info_1": "Wir haben Ihnen eine E-Mail geschickt mit dem Betreff „{subject}“.",
					"email_info_2": "Folgen Sie den Anweisungen in der E-Mail, um sich anzumelden und Ihren Antragsstatus einzusehen.",
					"email_info_2_approved": "Folgen Sie den Anweisungen in der E-Mail, um sich anzumelden und Klarna in Ihren E-Commerce-Store zu integrieren.",
					"email_subject": "Willkommen beim Klarna Händler-Portal",
					"resend_email": "E-Mail erneut senden"
				},
				"user_already_exists": {
					"title": "Beim Händler-Portal anmelden, um fortzufahren.",
					"message_1": "Diese E-Mail-Adresse ist bereits mit einem Konto im Händler-Portal verknüpft. Um Änderungen an Ihrem bestehenden Konto vorzunehmen, melden Sie sich bitte an.",
					"log_in": "Beim Händler-Portal anmelden",
					"forgot_password": "Passwort vergessen?"
				},
				"otherPlatform": {
					"info": "Eine Integration für {platform} ist bereits verfügbar, bitte",
					"link": "Integration hier starten",
					"title": "Smoooth, Sie können die Integration direkt vornehmen!",
					"info2": "Erfreuliche Nachrichten: Sie können Klarna direkt von <strong>{platform}</strong> in Ihr E-Commerce-Geschäft integrieren.",
					"link2": "Gehen Sie auf {platform} + Klarna Integration"
				},
				"noLandingPagePlatform": {
					"text": {
						"one": {
							"default": "Bitte kontaktieren Sie direkt unser Sales Team",
							"SE": "Bitte kontaktieren Sie direkt unser Sales Team unter"
						}
					}
				},
				"sensitive_goods": {
					"title_2": "Bieten Sie irgendwelche der folgenden Produkte oder Dienstleistungen an?",
					"subtitle_2": "Klarna kann einige Artikel aufgrund des Marktes, der Gesetze, des Verkaufsvolumens, der Risikobereitschaft und anderer Faktoren als beschränkt definieren, die ohne die Zustimmung von Klarna nicht bearbeitet werden dürfen und können.",
					"titleV2": "Bitte geben Sie an, welche der folgenden Beschreibungen auf Ihr Geschäft zutrifft.",
					"goodsCategories": {
						"CBD_HEMP_TOBACCO_ECIGARETTES_VAPE": {
							"title_2": "Produkte mit Altersbeschränkung",
							"description_2": "Tabak, E-Zigaretten, Verdampfer, Cannabisprodukte, Alkohol, Erotikinhalte"
						},
						"EVENTS_TICKETS_TOURISM_TRAVEL_VOUCHERS": {
							"title_2": "Reisen, Touren und Events",
							"description_2": "Verkehrsmittel, Events, Ticketing-Plattform, Hotels oder Unterkünfte, Vermietungen, Reisebüros"
						},
						"WEAPONS_AMMUNITION": {
							"title_2": "Lizensierte Waffen",
							"description_2": "Munition, Kampfmesser, Jagdausrüstung, Schlagstöcke, Pfefferspray"
						},
						"MARKETPLACE": {
							"title_2": "Peer-to-Peer-Marktplatz",
							"description_2": "Dienste, die es Dritten ermöglichen, ihre Waren weiterzuverkaufen oder Dienstleistungen über ihre Online-Plattform anzubieten"
						},
						"PHARMACEUTICALS": {
							"title_2": "Arzneimittel und medizinische Dienstleistungen",
							"description_2": "Verkauf von verschreibungspflichtigen Medikamenten, medizinischen Verfahren einschließlich ästhetischen Verfahren und Tattoos"
						},
						"SERVICES_SUBSCRIPTIONS_MEMBERSHIPS_RENTALS_CONTENT": {
							"title_2": "Mitgliedschaften, Abonnements und Dienstleistungen",
							"description_2": "Abonnements für physische Waren, digitale Inhalte, Streaming-Dienste, Dating-Seiten usw."
						},
						"NONE": {
							"title_2": "Ich biete andere Arten von Produkten/Dienstleistungen an"
						}
					},
					"link": "Mehr zu beschränkten Artikeln",
					"buttons": {
						"next": "Weiter",
						"continue": "Weiter"
					}
				}
			},
			"address_form_component": {
				"postal_code": {
					"tooltip": {
						"default": "Bitte geben Sie ihre Postleitzahl ein, um Ihre übrigen Adressangaben automatisch ausfüllen zu lassen",
						"US": "Bitte geben Sie Ihre PLZ ein, um Ihre übrigen Adressangaben automatisch ausfüllen zu lassen"
					},
					"label": {
						"default": "Postleitzahl",
						"US": "Postleitzahl"
					},
					"error": {
						"default": "Bitte geben Sie eine gültige Postleitzahl an",
						"US": "Bitte geben Sie eine gültige Postleitzahl an"
					}
				},
				"city": {
					"label": "Ort",
					"error": "Bitte geben Sie einen Ort an."
				},
				"street": {
					"label": "Adresse",
					"error": "Bitte geben Sie eine Adresse an.",
					"tooltip": "Beginnen Sie mit der Eingabe, um Vorschläge für weitere Straßennamen zu erhalten",
					"no_suggestion_found": "Kein Treffer für {input}"
				},
				"country": {
					"label": "Land",
					"error": "Bitte wählen Sie ein Land"
				},
				"region": {
					"label": "Region (optional)"
				},
				"state": {
					"label": "Bundesland",
					"error": "Bitte geben Sie ein Bundesland ein"
				}
			},
			"platforms": {
				"custom": "API Integration",
				"other": "Meine Plattform ist nicht aufgeführt."
			},
			"buttons": {
				"back": "Zurück"
			},
			"products": {
				"not_available": "Nicht möglich, da {reason}",
				"not_available_country": "Nicht verfügbar in Ihrem Land",
				"not_available_platform": "Nicht verfügbar für {platform}",
				"why_product": "Warum Klarna {name}",
				"kco_one": {
					"name": {
						"default": "Checkout"
					},
					"description": {
						"default": "Ersetzen Sie die Bezahlseite Ihres Shops mit Klarnas komplettem Checkout-Service."
					},
					"description_expanded": {
						"default": "Ersetzen Sie die Bezahlseite Ihres Shops mit Klarnas komplettem Checkout-Service."
					},
					"options": {
						"kco_one-pay-now": {
							"name": {
								"default": "Sofort bezahlen"
							},
							"description": {
								"default": "Direktzahlung per Karte oder Sofortüberweisung."
							}
						},
						"kco_one-pay-later": {
							"name": {
								"default": "In 30 Tagen bezahlen"
							},
							"description": {
								"default": "Rechnungskauf in 30 Tagen. Keine Zinsen.\n "
							}
						},
						"kco_one-slice-it": {
							"name": {
								"default": "Ratenkauf"
							},
							"description": {
								"default": "Ratenzahlung über 6–36 Monate.",
								"DE": "Ratenzahlung über 6–24 Monate",
								"AT": "Ratenzahlung über 6–24 Monate."
							}
						},
						"kco_one-slice-it-in-3": {
							"name": {
								"default": "Raten"
							},
							"description": {
								"default": "Drei zinsfreie Ratenzahlungen anbieten.",
								"GB": "Drei zinsfreie Ratenzahlungen anbieten."
							}
						},
						"kco_one-slice-it-in-4": {
							"name": {
								"default": "Slice it in 4",
								"US": "Ratenzahlung",
								"AU": "In 4 Raten zahlen"
							},
							"description": {
								"default": "Vier zinsfreie Ratenzahlungen anbieten.",
								"GB": "Vier zinsfreie Ratenzahlungen anbieten."
							}
						}
					},
					"features": {
						"other_payment_options": {
							"name": {
								"default": "Weitere Zahlungsoptionen"
							},
							"description": {
								"default": "Kreditkarten, EC-Karten und weitere"
							}
						},
						"on_site_messaging": {
							"name": {
								"default": "On-Site Messaging"
							}
						},
						"billing": {
							"name": {
								"default": "Automatische Identifizierung und Abrechnung"
							}
						},
						"shipping": {
							"name": {
								"default": "Individualisierte Versandoptionen"
							}
						},
						"post_purchase": {
							"name": {
								"default": "Nachkaufbetreuung"
							}
						}
					}
				},
				"kp_one": {
					"name": {
						"default": "Zahlungsmethode"
					},
					"description": {
						"default": "Fügen Sie die Zahlungsmöglichkeiten von Klarna in Ihren bestehenden Checkout ein"
					},
					"description_expanded": {
						"default": "Die Möglichkeit, per Klarna zu zahlen, erhöht die Konversionsrate um durchschnittlich 30 %, den durchschnittlichen Bestellwert um 41 % und die Bestellhäufigkeit um 36 %."
					},
					"options": {
						"kp_one-pay-now": {
							"name": {
								"default": "Sofort bezahlen"
							},
							"description": {
								"default": "Direktzahlung per Karte oder Sofortüberweisung."
							}
						},
						"kp_one-pay-later": {
							"name": {
								"default": "In 30 Tagen bezahlen"
							},
							"description": {
								"default": "Kunden zahlen 30 Tage nach dem Kauf, zinsfrei."
							}
						},
						"kp_one-slice-it": {
							"name": {
								"default": "Ratenkauf"
							},
							"description": {
								"default": "Kunden können in 6–36 Monaten zahlen.",
								"DE": "Kunden können in 6–24 Monaten zahlen",
								"AT": "Kunden können in 6–24 Monaten zahlen."
							}
						},
						"kp_one-slice-it-in-3": {
							"name": {
								"default": "Raten"
							},
							"description": {
								"default": "Drei zinsfreie Ratenzahlungen anbieten.",
								"GB": "Drei zinsfreie Ratenzahlungen anbieten."
							}
						},
						"kp_one-slice-it-in-4": {
							"name": {
								"default": "Slice it in 4",
								"US": "4 Zahlungen",
								"CA": "4 Zahlungen",
								"AU": "In 4 Raten zahlen"
							},
							"description": {
								"default": "Vier zinsfreie Ratenzahlungen anbieten.",
								"GB": "Vier zinsfreie Ratenzahlungen anbieten.",
								"US": "Bestellungen von 35 $ bis 1000 $ können in 4 zinsfreie Zahlungen mit 14-tägiger Fälligkeit aufgeteilt werden.",
								"CA": "Bestellungen von 35 $ bis 1000 $ können in 4 zinsfreie Zahlungen mit 14-tägiger Fälligkeit aufgeteilt werden."
							}
						},
						"kp_one-pay-by-card": {
							"name": {
								"default": "Per Karte zahlen"
							},
							"description": {
								"default": "Ermöglichen Sie Direktzahlung per Karte oder Sofortüberweisung."
							}
						}
					}
				}
			}
		},
		"fields": {
			"enm": {
				"product_channel": {
					"label": "Wie planen Sie, Ihre Verkäufe zu tätigen?",
					"options": {
						"IN_STORE": "Ladengeschäft",
						"TELESALES": "Telesales"
					},
					"description": {
						"IN_STORE": "Der Verkauf wird in erster Linie in persönlichem Kontakt statt und die Kundschaft erhält die Artikel sofort.",
						"TELESALES": "Der Verkauf wird in erster Linie telefonisch abgewickelt. Die Kundschaft erhält die Artikel nicht umgehend."
					}
				},
				"country": {
					"label": "Land"
				},
				"organization_category": {
					"label": "Rechtsform",
					"options": {
						"SOLE_TRADER": "Einzelunternehmer",
						"PARTNERSHIP": "Partnerschaften/Andere",
						"UNDEFINED": "NICHT DEFINIERT",
						"BV": "BV",
						"CV": "CV",
						"CVOA": "CVOA",
						"EEN": "EEN",
						"MTS": "MTS",
						"NV": "NV",
						"SE": "SE",
						"VOF": "VOF",
						"C_CORP": "C Corporation",
						"S_CORP": "S Corporation",
						"TRUST_ESTATE": "Trust/Nachlass",
						"INDIVIDUAL": "Natürliche Person",
						"SOLE_PROPRIETORSHIP": "Einzelunternehmen",
						"SINGLE_MEMBER_LIMITED_LIABILITY_COMPANY": "Single-Member-LLC",
						"LIMITED_LIABILITY_COMPANY": "Gesellschaft mit beschränkter Haftung",
						"PUBLIC_LISTED_COMPANY": "Börsennotiertes Unternehmen",
						"PRIVATE_COMPANY": "PRIVATUNTERNEHMEN"
					}
				},
				"store_category": {
					"label": "Hauptkategorie der verkauften Produkte",
					"options": {
						"ADULT_SHOES_AND_CLOTHING": "Bekleidung & Schuhe - Schuhe und Kleidung für Erwachsene",
						"AUTOMOTIVE_PARTS_AND_ACCESSORIES": "Automotive Produkte - Autoteile und Zubehör",
						"BAGS_AND_WALLETS": "Schmuck & Accessoires - Taschen und Brieftaschen",
						"BODY_AND_HAIR_CARE": "Gesundheit & Schönheit - Körper- und Haarpflege",
						"BOOK_AND_MAGAZINES": "Unterhaltung - Bücher und Magazine",
						"CANDY": "Speisen und Getränke - Süßigkeiten",
						"CAR_ELECTRONICS": "Elektronik - Kfz-Elektronik",
						"CHILDREN_CLOTHES_AND_NURTURING_PRODUCTS": "Kinder Produkte - Kinderkleidung und -pflege",
						"CHILDREN_TOYS": "Kinder Produkte - Kinderspielzeug",
						"CLEANING_AND_SANITARY": "Haus & Garten - Reinigung und Sanitär",
						"COLLECTIBLES": "Freizeit, Sport & Hobby - Sammlerstücke",
						"CONCEPT_STORES_AND_MISCELLANEOUS": "Freizeit, Sport & Hobby - Concept Stores und Sonstiges",
						"COSMETICS": "Gesundheit & Schönheit - Kosmetik",
						"COSTUMES_AND_PARTY_SUPPLIES": "Freizeit, Sport & Hobby - Kostüme und Partyzubehör",
						"DATING_SERVICES": "Immaterielle Produkte - Datingservice",
						"DECORATION_AND_ART": "Haus & Garten - Kunst und Dekoration",
						"DIETARY_SUPPLEMENTS": "Gesundheit & Schönheit - Nahrungsergänzungsmittel",
						"DIGITAL_SERVICES": "Immaterielle Produkte - Digitale Dienste",
						"DIVERSIFIED_CHILDREN_PRODUCTS": "Kinder Produkte - Diverse Produkte für Kinder",
						"DIVERSIFIED_ELECTRONICS": "Elektronik - Diverse Elektronik ",
						"DIVERSIFIED_ENTERTAINMENT": "Unterhaltung - Unterhaltung diverse",
						"DIVERSIFIED_EROTIC_MATERIAL": "Erotikartikel - Diverse Erotikartikel",
						"DIVERSIFIED_HEALTH_AND_BEAUTY_PRODUCTS": "Gesundheit & Schönheit – Diverse Gesundheits- und Schönheitsprodukte",
						"DIVERSIFIED_HOME_AND_GARDEN_PRODUCTS": "Haus & Garten - Heim und Garten diverse",
						"DIVERSIFIED_JEWELRY_AND_ACCESSORIES": "Schmuck & Accessoires - Diverse Schmuckstücke und Accessoires",
						"EDUCATION": "Immaterielle Produkte - Bildung",
						"ELECTRONIC_EQUIPMENT_AND_RELATED_ACCESSORIES": "Elektronik - Elektrogeräte und Zubehör",
						"EROTIC_CLOTHING_AND_ACCESSORIES": "Erotikartikel - Erotische Kleidung und Accessoires",
						"EVENT_TICKETS": "Immaterielle Produkte - Event-Tickets",
						"FOOD_AND_BEVERAGE": "Speisen und Getränke - Speisen und Getränke",
						"FRAGRANCES": "Gesundheit & Schönheit - Düfte",
						"FURNITURE": "Haus & Garten - Möbel",
						"GENERAL_SHOES_AND_CLOTHING": "Bekleidung & Schuhe - Schuhe und Kleidung allgemein",
						"HOBBY_ARTICLES": "Freizeit, Sport & Hobby - Hobbyartikel ",
						"HOUSEHOLD_ELECTRONICS": "Elektronik - Haushaltsgeräte",
						"JEWELRY_AND_WATCHES": "Schmuck & Accessoires - Schmuck und Uhren",
						"KITCHENWARE": "Haus & Garten - Küchengeräte",
						"MARKETPLACES": "Immaterielle Produkte - Marketplaces",
						"MUSIC_AND_MOVIES": "Unterhaltung - Musik und Film",
						"MUSICAL_INSTRUMENTS_AND_EQUIPMENT": "Freizeit, Sport & Hobby - Musikinstrumente und Zubehör",
						"NON_PRESCRIPTION_SUNGLASSES_AND_LENSES": "Schmuck & Accessoires - Sonnenbrillen und Linsen ohne Stärke ",
						"OFFICE_MACHINES_AND_RELATED_ACCESSORIES": "Elektronik - Bürogeräte und Zubehör",
						"OTHER_SERVICES": "Immaterielle Produkte - Andere Services",
						"PERSONAL_CARE_AND_BODY_IMPROVEMENT": "Gesundheit & Schönheit - Körperpflege",
						"PET_SUPPLIES": "Haus & Garten - Haustierzubehör",
						"PHARMACEUTICAL_PRODUCTS": "Gesundheit & Schönheit - Arzneimittel",
						"PLANTS_AND_FLOWERS": "Haus & Garten - Pflanzen und Blumen",
						"PRESCRIPTION_OPTICS": "Gesundheit & Schönheit - Brillen und Linsen mit Sehstärke",
						"PRINTS_AND_PHOTOS": "Freizeit, Sport & Hobby - Drucke und Fotos",
						"SAFETY_PRODUCTS": "Haus & Garten - Sicherheitsprodukte",
						"SEX_TOYS": "Erotikartikel - Sex-Spielzeug",
						"SPORTS_GEAR_AND_OUTDOOR": "Freizeit, Sport & Hobby - Sport- und Outdoor-Ausrüstung",
						"TOBACCO": "Speisen und Getränke - Tabakwaren",
						"TOOLS_AND_HOME_IMPROVEMENT": "Haus & Garten - Heim- und Handwerk",
						"TRAVEL_SERVICES": "Immaterielle Produkte - Reisedienste",
						"UNDERWEAR": "Bekleidung & Schuhe - Unterwäsche",
						"VIDEO_GAMES_AND_RELATED_ACCESSORIES": "Unterhaltung - Videospiele und Zubehör",
						"WHEELS_AND_TIRES": "Automotive Produkte - Reifen und Räder",
						"WINE_BEER_AND_LIQUOR": "Speisen und Getränke - Wein, Bier und Spirituosen",
						"YOUTHFUL_SHOES_AND_CLOTHING": "Bekleidung & Schuhe - Jugendliche Kleidung und Schuhe"
					}
				},
				"currency": {
					"label": "Währung"
				},
				"account_type": {
					"label": "Bankkontotyp",
					"options": {
						"IBAN": "IBAN",
						"LOCAL_SE": "Regional Schweden",
						"LOCAL_US": "Regional USA",
						"LOCAL_GENERIC": "Regional Norwegen/Dänemark",
						"SPECIAL": "Speziell",
						"BANKGIRO": "Regional Schweden Bankgiro",
						"PLUSGIRO": "Regional Schweden Plusgiro"
					}
				},
				"person_role": {
					"label": "Funktion",
					"options": {
						"LEGAL_REPRESENTATIVE": "Gesetzliche(r) Vertreter(in)",
						"ALTERNATIVE_BENEFICIAL_OWNER": "Alternativer wirtschaftlicher Eigentümer",
						"ULTIMATE_BENEFICIAL_OWNER": "Wirtschaftlicher Eigentümer",
						"OWNER": "Eigentümer"
					}
				},
				"business_size": {
					"label": "Unternehmensgröße",
					"options": {
						"LARGE": "groß",
						"MEDIUM": "mittel",
						"small": "klein"
					}
				},
				"sensitive_good_category": {
					"label": "Bieten Sie folgende Produkte oder Dienstleistungen in Ihrem Ladengeschäft an?",
					"options": {
						"AGE_RESTRICTED_PRODUCTS": "Produkte mit Altersbeschränkung",
						"LICENSED_WEAPONS": "Lizensierte Waffen",
						"PHARMA_AND_MEDICAL_SERVICES": "Arzneimittel und medizinische Dienstleistungen",
						"TRAVEL_TOURS_EVENTS": "Reisen, Touren und Events",
						"PEER_TO_PEER_MARKETPLACE": "Peer-to-Peer-Marktplatz",
						"MEMBERSHIPS_SUBSCRIPTIONS_SERVICES": "Mitgliedschaften, Abonnements und Dienstleistungen",
						"NONE": "Ich biete andere Arten von Produkten/Dienstleistungen an"
					},
					"description": {
						"AGE_RESTRICTED_PRODUCTS": "Tabak, E-Zigaretten, Verdampfer, Cannabisprodukte, Alkohol, Erotikinhalte",
						"LICENSED_WEAPONS": "Munition, Kampfmesser, Jagdausrüstung, Schlagstöcke, Pfefferspray",
						"PHARMA_AND_MEDICAL_SERVICES": "Verkauf von verschreibungspflichtigen Medikamenten, medizinischen Verfahren einschließlich ästhetischen Verfahren und Tattoos",
						"TRAVEL_TOURS_EVENTS": "Verkehrsmittel, Events, Ticketing-Plattform, Hotels oder Unterkünfte, Vermietungen, Reisebüros",
						"PEER_TO_PEER_MARKETPLACE": "Dienste, die es Dritten ermöglichen, ihre Waren weiterzuverkaufen oder Dienstleistungen über ihre Online-Plattform anzubieten",
						"MEMBERSHIPS_SUBSCRIPTIONS_SERVICES": "Abonnements für physische Waren, digitale Inhalte, Streaming-Dienste, Dating-Seiten usw.",
						"NONE": "Ich biete andere Arten von Produkten/Dienstleistungen an"
					},
					"error_message": "Wir bedauern. Ihr Antrag kann nicht weiterbearbeitet werden, da wir Ihren ausgewählten Produkt- oder Dienstleistungstyp derzeit nicht unterstützen."
				}
			},
			"common": {
				"country": {
					"label": "Land"
				},
				"address": {
					"city": {
						"label": "Ort"
					},
					"postal_code": {
						"label": "Postleitzahl"
					},
					"region": {
						"label": "Region"
					},
					"street_address": {
						"label": "Adresse des Ladengeschäfts"
					},
					"street_address2": {
						"label": "Adresszeile 2"
					}
				}
			},
			"payload": {
				"business_information": {
					"company_name": {
						"label": "Name des Unternehmens"
					},
					"registration_authority": {
						"label": "Registerbehörde"
					},
					"registration_id": {
						"label": "Firmenbuchnummer"
					},
					"subject_to_vat": {
						"label": "Ist Ihre Firma umsatzsteuerpflichtig?"
					},
					"vat_id": {
						"label": "USt-IdNr."
					},
					"persons": {
						"date_of_birth": {
							"label": "Geburtstag"
						},
						"first_name": {
							"label": "Vorname"
						},
						"last_name": {
							"label": "Nachname"
						},
						"person_identity_document": {
							"label": "Ausweisdokument"
						},
						"person_proof_of_address": {
							"label": "Adressnachweis"
						},
						"personal_identifier": {
							"label": "Personalausweisnummer"
						}
					},
					"should_auto_capture_orders": {
						"label": "Möchten Sie Bestellungen automatisch erfassen?",
						"tooltip": "Die Bestellungen sollten bei der Instore-Übergabe oder beim Versand aus einem Lager erfasst werden. Wenn Sie die automatische Erfassung auswählen, wird die Bestellung automatisch erfasst, wenn die Kundschaft den Einkauf bestätigt."
					}
				},
				"contract_entity": {
					"label": "Vertragspartei"
				},
				"contract_onboarding_type": {
					"label": "Art des Geschäftspartner-Onboardings"
				},
				"underwriting_inquiry_email": {
					"label": "Zeichnungs-E-Mail-Adresse"
				},
				"bank_accounts": {
					"account_holder": {
						"label": "Name des Kontoinhabers"
					},
					"account_number": {
						"label": "Kontonummer"
					},
					"bic": {
						"label": "BIC"
					},
					"iban": {
						"label": "Kontonummer (IBAN)"
					},
					"is_default": {
						"label": "Verwenden Sie dieses Konto für nicht festgelegte Währungen"
					},
					"routing_number": {
						"label": "Bankleitzahl"
					}
				},
				"in_stores": {
					"contact_email": {
						"label": "Kontakt-E-Mail"
					},
					"name": {
						"label": "Name des Shops"
					},
					"support_email": {
						"label": "Kundenservice Email"
					},
					"support_phone": {
						"label": "Kundenservice-Telefonnummer"
					},
					"business_concepts": {
						"options": {
							"TRADITIONAL_SALE_OF_GOODS": "Traditioneller Verkauf von Ware",
							"VOUCHER": "Gutschein",
							"MEMBERSHIP": "Mitgliedschaft",
							"SUBSCRIPTION": "Abonnement",
							"PHARMACIES": "Apotheken",
							"US_PHARMACIES": "Apotheken der USA",
							"MEDICAL_SERVICES": "Medizinische Versorgung",
							"MARKETPLACES": "Marketplaces",
							"FIREARM_DEALERS": "Schusswaffenhändler",
							"AUCTIONS": "Auktionen",
							"ALCOHOL": "Alkohol",
							"TOBACCO": "Tabakwaren",
							"HEMP_CBD_THC": "Hanf, CBD oder THC",
							"DONATIONS_CHARITY": "Spenden und Wohlfahrt",
							"TRAVEL": "Reisen",
							"EVENTS": "Events",
							"COURSES": "Kurse",
							"EDUCATIONAL_COURSES": "Schulungen",
							"FOOD_DELIVERY": "Essenslieferung",
							"CUSTOMISED_PRE_ORDER_FURNITURE": "Personalisierte Vorbestellungen/Möbel",
							"DIGITAL_CONTENT": "Digitale Inhalte",
							"GAMING_INDUSTRY": "Glücksspielbranche (Glücksspiel, Wetten, Casinos, Lotterien)"
						}
					}
				},
				"terms_and_conditions": {
					"default": "AGB",
					"UPSELL_WEBSTORE_TO_KPOS": "Bedingungen für Klarna In-store"
				},
				"pricing_terms": {
					"default": "Bedingungen für die Preisgestaltung",
					"UPSELL_WEBSTORE_TO_KPOS": "Preisgestaltung für Klarna In-store"
				}
			}
		},
		"group": {
			"title": {
				"additional_data": "Weitere Informationen",
				"bank_account": "Bitte geben Sie Ihre Bankverbindung an.",
				"business_size": "Welches jährliche Volumen erwarten Sie durch Klarna Point of Sale?",
				"in_store_get_started": "Starten Sie mit Ihrem Unternehmen mit Klarna",
				"in_store_legal_form": "Was für ein Unternehmen haben Sie?",
				"in_store_registered_address": "Wie lautet Ihre registrierte Adresse?",
				"in_store_registration": "Ist Ihr Unternehmen eine eingetragene Firma?",
				"in_store_stakeholder": "Wer leitet das Unternehmen?",
				"in_store_stores": "Was sind Ihre Shop-Details für Klarna Point of Sale?",
				"in_store_vat": "Ist Ihre Firma umsatzsteuerpflichtig?",
				"product_channel": "Wie beabsichtigt Ihr Unternehmen, Klarna Point of Sale zu nutzen?",
				"sensitive_goods": "Welche Kategorie an Produkten werden Sie mit Klarna Point of Sale verkaufen?",
				"ads_manager_get_started": "Fast geschafft.",
				"content_store_get_started": "Fast geschafft."
			},
			"subtitle": {
				"additional_data": "Wir prüfen Ihren Antrag und benötigen weitere Informationen, um fortfahren zu können.",
				"bank_account": "Alle Transaktionen von Klarna gehen an dieses Bankkonto.",
				"business_size": "Wir benötigen einige grundlegende Informationen zu Ihrem Unternehmen, um Ihren Antrag zu bearbeiten.",
				"in_store_get_started": "Wir brauchen ein paar grundlegende Informationen, um alles einzurichten",
				"in_store_legal_form": "Wir sind verpflichtet, je nach Art Ihres Unternehmens einige spezielle Fragen zu stellen.",
				"in_store_registered_address": "Das ist die Adresse, an der Ihr Unternehmen offiziell registriert ist, und diese Adresse wird auf Ihren Klarna-Rechnungen verwendet.",
				"in_store_registration": "Wir benötigen die Handelsregisternummer Ihres Unternehmens, um Ihre Unternehmensdaten zu überprüfen.",
				"in_store_stakeholder": "Als Finanzinstitut sind wir verpflichtet, diese Informationen zu erheben.",
				"in_store_stores": "Wir nutzen diese Angaben, um Ihr neues Klarna Point of Sale Konto einzurichten.",
				"in_store_vat": "Wenn Sie eine USt-IdNr. haben, können wir Ihre Unternehmensdaten leichter überprüfen.",
				"product_channel": "Wählen Sie Ihren primären Verkaufskanal. Sie werden Klarna Point of Sale für beide Kanäle nutzen können.",
				"sensitive_goods": "Das selbstständige Onboarding für Klarna Point of Sale gestattet es Ihnen nicht, Artikel zu vertreiben, die von Klarna als beschränkt definiert wurden.",
				"ads_manager_get_started": "Bitte geben Sie eine E-Mail-Adresse für Rechnungen an, an die Rechnungen für Kampagnen geschickt werden. Sie müssen ein Admin-Benutzer sein, um das Konto zu aktivieren. Admins können dann anderen Benutzern Berechtigungen erteilen.",
				"content_store_get_started": "Um Zugriff auf den Content Manager zu erhalten, lesen und akzeptieren Sie bitte unsere Allgemeinen Geschäftsbedingungen."
			},
			"summary": {
				"title": "Prüfen Sie Ihre Details, bevor Sie Ihre Anmeldung absenden"
			},
			"status": {
				"UNDERWRITING_INITIATED": {
					"title": {
						"default": "Ihr Antrag ist in Bearbeitung. Dies kann einen kurzen Moment dauern.",
						"UPSELL_WEBSTORE_TO_ADS_MANAGER": "Einen Augenblick bitte ...",
						"UPSELL_WEBSTORE_TO_CONTENT_MANAGER": "Einen Augenblick bitte ..."
					},
					"paragraphs": {
						"default": [
							{
								"text": "Ihr Antrag wird bearbeitet und es wird eine neue Händler-ID erstellt."
							}
						],
						"UPSELL_WEBSTORE_TO_ADS_MANAGER": [
							{
								"text": "Wir bereiten alles für Ihr Ads Manager Konto vor."
							}
						],
						"UPSELL_WEBSTORE_TO_CONTENT_MANAGER": [
							{
								"text": "Wir bereiten alles für Ihr Content-Manager-Konto vor."
							}
						]
					}
				},
				"ONBOARDING_COMPLETED": {
					"title": {
						"default": "Glückwunsch! Ihr Antrag wurde genehmigt.",
						"UPSELL_WEBSTORE_TO_ADS_MANAGER": "Alles erledigt!",
						"UPSELL_WEBSTORE_TO_CONTENT_MANAGER": "Alles erledigt!"
					},
					"paragraphs": {
						"default": [
							{
								"text": "Lassen Sie uns nun Klarna in Ihren Online-Shop integrieren. Unter der Registerkarte Produkte in Ihrem Händlerportal-Konto finden Sie Ihre Zugangsdaten für die Integration und Anleitungen, wie Sie diese verwenden."
							}
						],
						"UPSELL_WEBSTORE_TO_KPOS": [
							{
								"text": "Lassen Sie uns jetzt Ihren Shop einrichten, damit Sie gleich bereit sind, Zahlungen entgegenzunehmen."
							}
						],
						"UPSELL_WEBSTORE_TO_ADS_MANAGER": [
							{
								"text": "Rufen Sie den Ads Manager auf, um Ihre erste Kampagne zu erstellen."
							}
						],
						"UPSELL_WEBSTORE_TO_CONTENT_MANAGER": [
							{
								"text": "Rufen Sie den Content Manager auf, um heute Ihr erstes Angebot zu veröffentlichen."
							}
						]
					},
					"second_title": {
						"default": "Unter Klarna Docs finden Sie weitere Informationen zur Integration mit Klarna",
						"UPSELL_WEBSTORE_TO_KPOS": "Benötigen Sie Hilfe bei der Einrichtung Ihres Shops? Wir helfen Ihnen gerne weiter",
						"UPSELL_WEBSTORE_TO_ADS_MANAGER": "Benötigen Sie Hilfe bei der Verwendung des Ads Manager? Sehen Sie in den FAQ nach oder wenden Sie sich an den Händlersupport. Wir sind Ihnen gerne behilflich.",
						"UPSELL_WEBSTORE_TO_CONTENT_MANAGER": "Benötigen Sie Hilfe bei der Verwendung des Content Manager? Sehen Sie in den FAQ nach oder wenden Sie sich an den Händlersupport. Wir sind Ihnen gerne behilflich."
					},
					"second_paragraphs": {
						"default": [
							{
								"text": "Unsere Best-Practice-Richtlinien können Ihnen dabei helfen, das Beste aus Ihrer neuen Partnerschaft mit uns herauszuholen."
							},
							{
								"text": "Klarna Checkout",
								"link": "#"
							},
							{
								"text": "Klarna Payments",
								"link": "#"
							}
						],
						"UPSELL_WEBSTORE_TO_KPOS": [
							{
								"text": "Bitte kontaktieren Sie unseren Händlersupport. Wir sind Ihnen gerne behilflich."
							},
							{
								"text": "Support kontaktieren",
								"link": "https://www.klarna.com/se/foretag/butikssupport/"
							}
						],
						"UPSELL_WEBSTORE_TO_ADS_MANAGER": [
							{
								"text": "Rufen Sie die FAQ auf.",
								"link": "https://portal.klarna.com/?help-page=topic%3Aads-manager"
							}
						],
						"UPSELL_WEBSTORE_TO_CONTENT_MANAGER": [
							{
								"text": "Rufen Sie die FAQ auf.",
								"link": "https://portal.klarna.com/?help-page=topic%3Acontent-manager"
							}
						]
					},
					"button_text": {
						"default": "Los geht's.",
						"UPSELL_WEBSTORE_TO_ADS_MANAGER": "Los geht's",
						"UPSELL_WEBSTORE_TO_CONTENT_MANAGER": "Los geht's",
						"UPSELL_WEBSTORE_TO_KPOS": "Jetzt verkaufen"
					}
				},
				"MANUAL_UNDERWRITING_INITIATED": {
					"title": "Vielen Dank! Ihr Antrag wird geprüft.",
					"badge": "Ungefähr 5-7 Tage",
					"paragraphs": [
						{
							"text": "Sie erhalten eine E-Mail, wenn die Überprüfung abgeschlossen ist oder wenn wir zusätzliche Informationen benötigen."
						}
					],
					"second_title": "In der Zwischenzeit überprüfen Sie bitte Ihre E-Mails",
					"second_paragraphs": [
						{
							"text": "Sie haben von uns eine E-Mail erhalten mit dem Betreff „Willkommen im Klarna Händlerportal“. Bitte befolgen Sie die Schritte, um sich anzumelden und Ihr Konto zu aktivieren."
						}
					]
				},
				"SUSPENDED": {
					"title": "Leider wurde Ihr Antrag nicht genehmigt.",
					"paragraphs": [
						{
							"text": "Nach Prüfung Ihrer Geschäftsdaten müssen wir Ihnen leider mitteilen, dass wir Ihren Antrag für <strong>{businessName}</strong> nicht stattgeben können."
						},
						{
							"text": "Dies sind einige der häufigsten Gründe:"
						},
						{
							"list": [
								{
									"text": "Ihr Store widerspricht Klarnas ethischen Richtlinien."
								},
								{
									"text": "Ihr Kundenservice ist nicht erreichbar."
								},
								{
									"text": "Andere administrative Faktoren."
								}
							]
						},
						{
							"text": "Vielen Dank für Ihr Interesse an <strong>Klarna [In-store]</strong>. Wir hoffen, dass sich künftig eine Gelegenheit zur Zusammenarbeit ergibt."
						}
					],
					"second_title": "Wenn Sie weitere Fragen haben",
					"second_paragraphs": [
						{
							"text": "bezüglich unserer Entscheidung oder eines anderen Klarna-Produkts, kontaktieren Sie uns bitte, wir helfen Ihnen gerne weiter."
						}
					]
				}
			},
			"stakeholders": {
				"LEGAL_REPRESENTATIVE": {
					"title": {
						"default": "Wer ist in Ihrem Unternehmen unterschriftsberechtigt?"
					},
					"subtitle": {
						"default": [
							{
								"text": "Ihr Unternehmen steht kurz davor, eine Vereinbarung mit Klarna einzugehen. Wir müssen überprüfen, wer rechtlich unterschriftsberechtigt ist."
							}
						]
					}
				},
				"OWNER": {
					"title": {
						"default": "Gibt es Personen, denen mehr als 25 % des Unternehmens gehört?"
					},
					"subtitle": {
						"AU": [
							{
								"text": "Als Finanzinstitut sind wir gesetzlich dazu verpflichtet, diese Informationen zu erfassen."
							}
						],
						"default": [
							{
								"text": "Wir müssen wissen, wer die Personen sind, denen mehr als 25 % der Aktien oder Stimmrechte des Unternehmens gehören oder, die eine ähnliche Kontrolle ausüben. Wir sind durch die EU-Geldwäsche-Richtlinie ("
							},
							{
								"text": "EU 2015/849",
								"link": "https://eur-lex.europa.eu/legal-content/EN/TXT/PDF/?uri=CELEX:32015L0849"
							},
							{
								"text": ") sind wir gesetzlich dazu verpflichtet, diese Informationen zu sammeln."
							}
						]
					}
				},
				"ALTERNATIVE_BENEFICIAL_OWNER": {
					"title": {
						"default": "Wer leitet das Unternehmen?"
					},
					"subtitle": {
						"default": [
							{
								"text": "Gemäß der EU-Anti-Geldwäsche-Richtlinie ("
							},
							{
								"text": "EU 2015/849",
								"link": "https://eur-lex.europa.eu/legal-content/EN/TXT/PDF/?uri=CELEX:32015L0849"
							},
							{
								"text": ") sind wir gesetzlich dazu verpflichtet, diese Informationen zu sammeln."
							}
						],
						"US": [
							{
								"text": "Als Finanzinstitut sind wir gesetzlich dazu verpflichtet, diese Informationen zu erfassen."
							}
						],
						"CA": [
							{
								"text": "Als Finanzinstitut sind wir gesetzlich dazu verpflichtet, diese Informationen zu erfassen."
							}
						],
						"AU": [
							{
								"text": "Als Finanzinstitut sind wir gesetzlich dazu verpflichtet, diese Informationen zu erfassen."
							}
						]
					}
				},
				"ULTIMATE_BENEFICIAL_OWNER": {
					"title": {
						"default": "Gibt es Personen, denen mehr als 25 % des Unternehmens gehört?"
					},
					"subtitle": {
						"AU": [
							{
								"text": "Als Finanzinstitut sind wir gesetzlich dazu verpflichtet, diese Informationen zu erfassen."
							}
						],
						"default": [
							{
								"text": "Wir müssen wissen, wer die Personen sind, denen mehr als 25 % der Aktien oder Stimmrechte des Unternehmens gehören oder, die eine ähnliche Kontrolle ausüben. Wir sind durch die EU-Geldwäsche-Richtlinie ("
							},
							{
								"text": "EU 2015/849",
								"link": "https://eur-lex.europa.eu/legal-content/EN/TXT/PDF/?uri=CELEX:32015L0849"
							},
							{
								"text": ") sind wir gesetzlich dazu verpflichtet, diese Informationen zu sammeln."
							}
						]
					}
				}
			}
		},
		"product-selection-container": {
			"products": {
				"products_block": {
					"title_1": "Bezahllösungen",
					"title_2": "Zahlungsarten",
					"note": "Alle Preise pro Transaktion.",
					"per_transaction": "per Transaktion",
					"cross_border_notice": "Es können zusätzliche Gebühren für den grenzüberschreitenden Zahlungsverkehr anfallen",
					"cross_border_notice_pricing_annex_suffix": {
						"before_link": "Mehr dazu im",
						"link_text": "Anhang zur Preisgestaltung"
					},
					"not_available_for_business": "Für Ihr Geschäft nicht verfügbar",
					"not_available_for_country": "Sie können nur an andere Märkte verkaufen",
					"not_compatible_with_platform": "Für Ihre Plattform nicht verfügbar",
					"installed": "Installiert"
				},
				"buttons": {
					"next": "Weiter"
				}
			}
		}
	}
};